// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-touch .leaflet-control-attribution,
.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: 2px solid rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
}

/* popup */
.leaflet-popup {
  position: absolute;
  text-align: center;
}

.leaflet-popup-content-wrapper {
  padding: 1px;
  text-align: left;
  border-radius: 12px;
}

.leaflet-popup-content {
  margin: 13px 19px;
  line-height: 1.4;
}

.leaflet-popup-content p {
  margin: 18px 0;
}

.leaflet-popup-tip-container {
  margin: 0 auto;
  width: 40px;
  height: 20px;
  position: relative;
  overflow: hidden;
}

.leaflet-popup-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: white;
  -webkit-box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
          box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
}

.leaflet-container a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}

.leaflet-container a.leaflet-popup-close-button:hover {
  color: #999;
}

.leaflet-popup-scrolled {
  overflow: auto;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

.leaflet-oldie .leaflet-popup-content-wrapper {
  zoom: 1;
}

.leaflet-oldie .leaflet-popup-tip {
  width: 24px;
  margin: 0 auto;
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";
  filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);
}

.leaflet-oldie .leaflet-popup-tip-container {
  margin-top: -1px;
}

.leaflet-oldie .leaflet-control-zoom,
.leaflet-oldie .leaflet-control-layers,
.leaflet-oldie .leaflet-popup-content-wrapper,
.leaflet-oldie .leaflet-popup-tip {
  border: 1px solid #999;
}

/* div icon */
.leaflet-div-icon {
  background: #fff;
  border: 1px solid #666;
}

/*
Version: 3.5.1 Timestamp: Tue Jul 22 18:58:56 EDT 2014
*/
.select2-container {
  margin: 0;
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.select2-container,
.select2-drop,
.select2-search,
.select2-search input {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  /* css3 */
}

.select2-container .select2-choice {
  display: block;
  height: 25px;
  padding: 0 0 0 8px;
  overflow: hidden;
  position: relative;
  border: 1px solid #aaa;
  white-space: nowrap;
  line-height: 20px;
  color: #444;
  text-decoration: none;
  border-radius: 4px;
  background-clip: padding-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  background-color: #fff;
}

.select2-container.select2-drop-above .select2-choice {
  border-bottom-color: #aaa;
  border-radius: 0 0 4px 4px;
}

.select2-container.select2-allowclear .select2-choice .select2-chosen {
  margin-right: 42px;
}

.select2-container .select2-choice > .select2-chosen {
  margin-right: 26px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  float: none;
  width: auto;
}

.select2-container .select2-choice abbr {
  display: none;
  width: 12px;
  height: 12px;
  position: absolute;
  right: 24px;
  top: 4px;
  font-size: 1px;
  text-decoration: none;
  border: 0;
  background: url("/public/imgs/common/select2/select2.png") right top no-repeat;
  cursor: pointer;
  outline: 0;
}

.select2-container.select2-allowclear .select2-choice abbr {
  display: inline-block;
}

.select2-container .select2-choice abbr:hover {
  background-position: right -11px;
  cursor: pointer;
}

.select2-drop-mask {
  border: 0;
  margin: 0;
  padding: 0;
  position: fixed;
  left: 0;
  top: 0;
  min-height: 100%;
  min-width: 100%;
  height: auto;
  width: auto;
  opacity: 0;
  z-index: 9998;
  background-color: #fff;
}

.select2-drop {
  width: 100%;
  margin-top: -1px;
  position: absolute;
  z-index: 9999;
  top: 100%;
  background: #fff;
  color: #000;
  border: 1px solid #aaa;
  border-top: 0;
  border-radius: 0 0 4px 4px;
}

.select2-drop.select2-drop-above {
  margin-top: 1px;
  border-top: 1px solid #aaa;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
}

.select2-drop-active {
  border: 1px solid #5897fb;
  border-top: none;
}

.select2-drop.select2-drop-above.select2-drop-active {
  border-top: 1px solid #5897fb;
}

.select2-drop-auto-width {
  border-top: 1px solid #aaa;
  width: auto;
}

.select2-drop-auto-width .select2-search {
  padding-top: 4px;
}

.select2-container .select2-choice .select2-arrow {
  display: inline-block;
  width: 18px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #aaa;
  border-radius: 0 4px 4px 0;
  background-clip: padding-box;
  background: #ccc;
}

.select2-container .select2-choice .select2-arrow b {
  top: -3px;
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  background: url("/public/imgs/common/select2/select2.png") no-repeat 0 1px;
}

.select2-search {
  display: inline-block;
  width: 100%;
  min-height: 26px;
  margin: 0;
  padding-left: 4px;
  padding-right: 4px;
  position: relative;
  z-index: 10000;
  white-space: nowrap;
}

.select2-search input {
  width: 100%;
  height: 25px;
  padding: 4px 20px 4px 5px;
  margin: 0;
  outline: 0;
  font-family: sans-serif;
  font-size: 1em;
  border: 1px solid #aaa;
  border-radius: 0;
  background: #fff url("/public/imgs/common/select2/select2.png") no-repeat 100% -22px;
}

.select2-drop.select2-drop-above .select2-search input {
  margin-top: 4px;
}

.select2-search input.select2-active {
  background: #fff url("/public/imgs/common/select2/select2-spinner.gif")
    no-repeat 100%;
}

.select2-container-active .select2-choice,
.select2-container-active .select2-choices {
  border: 1px solid #5897fb;
  outline: none;
}

.select2-dropdown-open .select2-choice {
  border-bottom-color: transparent;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #eee;
}

.select2-dropdown-open.select2-drop-above .select2-choice,
.select2-dropdown-open.select2-drop-above .select2-choices {
  border: 1px solid #5897fb;
  border-top-color: transparent;
}

.select2-dropdown-open .select2-choice .select2-arrow {
  background: transparent;
  border-left: none;
}

.select2-dropdown-open .select2-choice .select2-arrow b {
  background-position: -18px 1px;
}

.select2-hidden-accessible {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* results */
.select2-results {
  max-height: 200px;
  padding: 0 0 0 4px;
  margin: 4px 4px 4px 0;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-tap-highlight-color: transparent;
}

.select2-results ul.select2-result-sub {
  margin: 0;
  padding-left: 0;
}

.select2-results li {
  list-style: none;
  display: list-item;
  background-image: none;
}

.select2-results li.select2-result-with-children > .select2-result-label {
  font-weight: bold;
}

.select2-results .select2-result-label {
  padding: 3px 7px 4px;
  margin: 0;
  cursor: pointer;
  min-height: 1em;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.select2-results-dept-1 .select2-result-label {
  padding-left: 20px;
}

.select2-results-dept-2 .select2-result-label {
  padding-left: 40px;
}

.select2-results-dept-3 .select2-result-label {
  padding-left: 60px;
}

.select2-results-dept-4 .select2-result-label {
  padding-left: 80px;
}

.select2-results-dept-5 .select2-result-label {
  padding-left: 100px;
}

.select2-results-dept-6 .select2-result-label {
  padding-left: 110px;
}

.select2-results-dept-7 .select2-result-label {
  padding-left: 120px;
}

.select2-results .select2-highlighted {
  background: #3875d7;
  color: #fff;
}

.select2-results li em {
  background: #feffde;
  font-style: normal;
}

.select2-results .select2-highlighted em {
  background: transparent;
}

.select2-results .select2-highlighted ul {
  background: #fff;
  color: #000;
}

.select2-results .select2-no-results,
.select2-results .select2-searching,
.select2-results .select2-ajax-error,
.select2-results .select2-selection-limit {
  background: #f4f4f4;
  display: list-item;
  padding-left: 5px;
}

/*
disabled look for disabled choices in the results dropdown
*/
.select2-results .select2-disabled.select2-highlighted {
  color: #666;
  background: #f4f4f4;
  display: list-item;
  cursor: default;
}

.select2-results .select2-disabled {
  background: #f4f4f4;
  display: list-item;
  cursor: default;
}

.select2-results .select2-selected {
  display: none;
}

.select2-more-results.select2-active {
  background: #f4f4f4 url("/public/imgs/common/select2/select2-spinner.gif")
    no-repeat 100%;
}

.select2-results .select2-ajax-error {
  background: rgba(255, 50, 50, 0.2);
}

.select2-more-results {
  background: #f4f4f4;
  display: list-item;
}

/* disabled styles */
.select2-container.select2-container-disabled .select2-choice {
  background-color: #f4f4f4;
  background-image: none;
  border: 1px solid #ddd;
  cursor: default;
}

.select2-container.select2-container-disabled .select2-choice .select2-arrow {
  background-color: #f4f4f4;
  background-image: none;
  border-left: 0;
}

.select2-container.select2-container-disabled .select2-choice abbr {
  display: none;
}

/* multiselect */
.select2-container-multi .select2-choices {
  margin: 0;
  padding: 0 5px 0 0;
  position: relative;
  border: 1px solid #aaa;
  cursor: text;
  overflow: hidden;
  background-color: #fff;
}

.select2-locked {
  padding: 3px 5px 3px 5px !important;
}

.select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #5897fb;
  outline: none;
}

.select2-container-multi .select2-choices li {
  float: left;
  list-style: none;
}

.select2-container-multi .select2-choices .select2-search-field {
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.select2-container-multi .select2-choices .select2-search-field input {
  padding: 0px 0px 0px 5px;
  margin: 1px 0;
  font-family: sans-serif;
  font-size: 100%;
  color: #666;
  outline: 0;
  border: 0;
  background: transparent !important;
}

.select2-container-multi
  .select2-choices
  .select2-search-field
  input.select2-active {
  background: #fff url("/public/imgs/common/select2/select2-spinner.gif")
    no-repeat 100% !important;
}

.select2-default {
  color: #999 !important;
}

.select2-container-multi .select2-choices .select2-search-choice {
  font-size: 12px;
  padding: 1px 5px 3px 18px;
  margin: 2px 0 3px 5px;
  position: relative;
  line-height: 11px;
  color: #333;
  cursor: default;
  border: 1px solid #aaaaaa;
  border-radius: 3px;
  background-clip: padding-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  background-color: #e4e4e4;
}

.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-chosen {
  cursor: default;
}

.select2-container-multi .select2-choices .select2-search-choice-focus {
  background: #d4d4d4;
}

.select2-search-choice-close {
  display: block;
  width: 12px;
  height: 13px;
  position: absolute;
  right: 3px;
  top: 1px;
  font-size: 1px;
  outline: none;
  background: url("/public/imgs/common/select2/select2.png") right top no-repeat;
}

.select2-container-multi .select2-search-choice-close {
  left: 3px;
}

.select2-container-multi
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close:hover {
  background-position: right -11px;
}

.select2-container-multi
  .select2-choices
  .select2-search-choice-focus
  .select2-search-choice-close {
  background-position: right -11px;
}

/* disabled styles */
.select2-container-multi.select2-container-disabled .select2-choices {
  background-color: #f4f4f4;
  background-image: none;
  border: 1px solid #ddd;
  cursor: default;
}

.select2-container-multi.select2-container-disabled
  .select2-choices
  .select2-search-choice {
  padding: 3px 5px 3px 5px;
  border: 1px solid #ddd;
  background-image: none;
  background-color: #f4f4f4;
}

.select2-container-multi.select2-container-disabled
  .select2-choices
  .select2-search-choice
  .select2-search-choice-close {
  display: none;
  background: none;
}

/* end multiselect */
.select2-result-selectable .select2-match,
.select2-result-unselectable .select2-match {
  text-decoration: underline;
}

.select2-offscreen,
.select2-offscreen:focus {
  clip: rect(0 0 0 0) !important;
  width: 1px !important;
  height: 1px !important;
  border: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  position: absolute !important;
  outline: 0 !important;
  left: 0px !important;
  top: 0px !important;
}

.select2-display-none {
  display: none;
}

.select2-measure-scrollbar {
  position: absolute;
  top: -10000px;
  left: -10000px;
  width: 100px;
  height: 100px;
  overflow: scroll;
}

/* Retina-ize icons */
@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
  only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-resolution: 2dppx) {
  .select2-search input,
  .select2-search-choice-close,
  .select2-container .select2-choice abbr,
  .select2-container .select2-choice .select2-arrow b {
    background-image: url("/public/imgs/common/select2/select2x2.png") !important;
    background-repeat: no-repeat !important;
    background-size: 60px 40px !important;
  }
  .select2-search input {
    background-position: 100% -21px !important;
  }
}

/* SELECT2 BOOTSTRAP */
.form-control .select2-choice {
  border: 0;
  border-radius: 2px;
}

.form-control .select2-choice .select2-arrow {
  border-radius: 0 2px 2px 0;
}

.form-control.select2-container {
  height: auto !important;
  padding: 0;
}

.form-control.select2-container.select2-dropdown-open {
  border-color: #5897fb;
  border-radius: 3px 3px 0 0;
}

.form-control .select2-container.select2-dropdown-open .select2-choices {
  border-radius: 3px 3px 0 0;
}

.form-control.select2-container .select2-choices {
  border: 0 !important;
  border-radius: 3px;
}

.control-group.warning .select2-container .select2-choice,
.control-group.warning .select2-container .select2-choices,
.control-group.warning .select2-container-active .select2-choice,
.control-group.warning .select2-container-active .select2-choices,
.control-group.warning
  .select2-dropdown-open.select2-drop-above
  .select2-choice,
.control-group.warning
  .select2-dropdown-open.select2-drop-above
  .select2-choices,
.control-group.warning
  .select2-container-multi.select2-container-active
  .select2-choices {
  border: 1px solid #c09853 !important;
}

.control-group.warning .select2-container .select2-choice div {
  border-left: 1px solid #c09853 !important;
  background: #fcf8e3 !important;
}

.control-group.error .select2-container .select2-choice,
.control-group.error .select2-container .select2-choices,
.control-group.error .select2-container-active .select2-choice,
.control-group.error .select2-container-active .select2-choices,
.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.error
  .select2-container-multi.select2-container-active
  .select2-choices {
  border: 1px solid #b94a48 !important;
}

.control-group.error .select2-container .select2-choice div {
  border-left: 1px solid #b94a48 !important;
  background: #f2dede !important;
}

.control-group.info .select2-container .select2-choice,
.control-group.info .select2-container .select2-choices,
.control-group.info .select2-container-active .select2-choice,
.control-group.info .select2-container-active .select2-choices,
.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.info
  .select2-container-multi.select2-container-active
  .select2-choices {
  border: 1px solid #3a87ad !important;
}

.control-group.info .select2-container .select2-choice div {
  border-left: 1px solid #3a87ad !important;
  background: #d9edf7 !important;
}

.control-group.success .select2-container .select2-choice,
.control-group.success .select2-container .select2-choices,
.control-group.success .select2-container-active .select2-choice,
.control-group.success .select2-container-active .select2-choices,
.control-group.success
  .select2-dropdown-open.select2-drop-above
  .select2-choice,
.control-group.success
  .select2-dropdown-open.select2-drop-above
  .select2-choices,
.control-group.success
  .select2-container-multi.select2-container-active
  .select2-choices {
  border: 1px solid #468847 !important;
}

.control-group.success .select2-container .select2-choice div {
  border-left: 1px solid #468847 !important;
  background: #dff0d8 !important;
}

/* The MIT License */
.dropzone,
.dropzone *,
.dropzone-previews,
.dropzone-previews * {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin-top: 25px;
  margin-bottom: 25px;
}

.dropzone {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.02);
  padding: 1em;
}

.dropzone.dz-clickable {
  cursor: pointer;
}

.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message span {
  cursor: pointer;
}

.dropzone.dz-clickable * {
  cursor: default;
}

.dropzone .dz-message {
  opacity: 1;
}

.dropzone.dz-drag-hover {
  border-color: rgba(0, 0, 0, 0.15);
  background: rgba(0, 0, 0, 0.04);
}

.dropzone.dz-started .dz-message {
  display: none;
}

.dropzone .dz-preview,
.dropzone-previews .dz-preview {
  background: rgba(255, 255, 255, 0.8);
  position: relative;
  display: inline-block;
  margin: 17px;
  vertical-align: top;
  border: 1px solid #acacac;
  padding: 6px 6px 6px 6px;
}

.dropzone .dz-preview.dz-file-preview [data-dz-thumbnail],
.dropzone-previews .dz-preview.dz-file-preview [data-dz-thumbnail] {
  display: none;
}

.dropzone .dz-preview .dz-details,
.dropzone-previews .dz-preview .dz-details {
  width: 100px;
  height: 100px;
  position: relative;
  background: #ebebeb;
  padding: 5px;
  margin-bottom: 22px;
}

.dropzone .dz-preview .dz-details .dz-filename,
.dropzone-previews .dz-preview .dz-details .dz-filename {
  overflow: hidden;
  height: 100%;
}

.dropzone .dz-preview .dz-details img,
.dropzone-previews .dz-preview .dz-details img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
}

.dropzone .dz-preview .dz-details .dz-size,
.dropzone-previews .dz-preview .dz-details .dz-size {
  position: absolute;
  bottom: -28px;
  left: 3px;
  height: 28px;
  line-height: 28px;
}

.dropzone .dz-preview.dz-error .dz-error-mark,
.dropzone-previews .dz-preview.dz-error .dz-error-mark {
  display: block;
}

.dropzone .dz-preview.dz-success .dz-success-mark,
.dropzone-previews .dz-preview.dz-success .dz-success-mark {
  display: block;
}

.dropzone .dz-preview:hover .dz-details img,
.dropzone-previews .dz-preview:hover .dz-details img {
  display: none;
}

.dropzone .dz-preview .dz-success-mark,
.dropzone-previews .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark,
.dropzone-previews .dz-preview .dz-error-mark {
  display: none;
  position: absolute;
  width: 40px;
  height: 40px;
  font-size: 30px;
  text-align: center;
  right: -10px;
  top: -10px;
}

.dropzone .dz-preview .dz-success-mark,
.dropzone-previews .dz-preview .dz-success-mark {
  color: #8cc657;
}

.dropzone .dz-preview .dz-error-mark,
.dropzone-previews .dz-preview .dz-error-mark {
  color: #ee162d;
}

.dropzone .dz-preview .dz-progress,
.dropzone-previews .dz-preview .dz-progress {
  position: absolute;
  top: 100px;
  left: 6px;
  right: 6px;
  height: 6px;
  background: #d7d7d7;
  display: none;
}

.dropzone .dz-preview .dz-progress .dz-upload,
.dropzone-previews .dz-preview .dz-progress .dz-upload {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0%;
  background-color: #8cc657;
}

.dropzone .dz-preview.dz-processing .dz-progress,
.dropzone-previews .dz-preview.dz-processing .dz-progress {
  display: block;
}

.dropzone .dz-preview .dz-error-message,
.dropzone-previews .dz-preview .dz-error-message {
  display: none;
  position: absolute;
  top: -5px;
  left: -20px;
  background: rgba(245, 245, 245, 0.8);
  padding: 8px 10px;
  color: #800;
  min-width: 140px;
  max-width: 500px;
  z-index: 500;
}

.dropzone .dz-preview:hover.dz-error .dz-error-message,
.dropzone-previews .dz-preview:hover.dz-error .dz-error-message {
  display: block;
}

.dropzone {
  border: 1px solid rgba(0, 0, 0, 0.03);
  min-height: 360px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.03);
  padding: 23px;
}

.dropzone .dz-default.dz-message {
  opacity: 1;
  -webkit-transition: opacity 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;
  background-image: url("/public/imgs/common/dropzone/spritemap.png");
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  width: 428px;
  height: 123px;
  margin-left: -214px;
  margin-top: -61.5px;
  top: 50%;
  left: 50%;
}

@media all and (-webkit-min-device-pixel-ratio: 1.5),
  (min-device-pixel-ratio: 1.5),
  (-webkit-min-device-pixel-ratio: 1.4375),
  (min-resolution: 138dpi),
  (-webkit-min-device-pixel-ratio: 1.5),
  (min-resolution: 1.5dppx) {
  .dropzone .dz-default.dz-message {
    background-image: url("/public/imgs/common/dropzone/spritemap@2x.png");
    background-size: 428px 406px;
  }
}

.dropzone .dz-default.dz-message span {
  display: none;
}

.dropzone.dz-square .dz-default.dz-message {
  background-position: 0 -123px;
  width: 268px;
  margin-left: -134px;
  height: 174px;
  margin-top: -87px;
}

.dropzone.dz-drag-hover .dz-message {
  opacity: 0.15;
}

.dropzone.dz-started .dz-message {
  display: block;
  opacity: 0;
}

.dropzone .dz-preview,
.dropzone-previews .dz-preview {
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.16);
          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.16);
  font-size: 14px;
}

.dropzone .dz-preview.dz-image-preview:hover .dz-details img,
.dropzone-previews .dz-preview.dz-image-preview:hover .dz-details img {
  display: block;
  opacity: 0.1;
}

.dropzone .dz-preview.dz-success .dz-success-mark,
.dropzone-previews .dz-preview.dz-success .dz-success-mark {
  opacity: 1;
}

.dropzone .dz-preview.dz-error .dz-error-mark,
.dropzone-previews .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
}

.dropzone .dz-preview.dz-error .dz-progress .dz-upload,
.dropzone-previews .dz-preview.dz-error .dz-progress .dz-upload {
  background: #ee1e2d;
}

.dropzone .dz-preview .dz-error-mark,
.dropzone-previews .dz-preview .dz-error-mark,
.dropzone .dz-preview .dz-success-mark,
.dropzone-previews .dz-preview .dz-success-mark {
  display: block;
  opacity: 0;
  -webkit-transition: opacity 0.4s ease-in-out;
  transition: opacity 0.4s ease-in-out;
  background-image: url("/public/imgs/common/dropzone/spritemap.png");
  background-repeat: no-repeat;
}

@media all and (-webkit-min-device-pixel-ratio: 1.5),
  (min-device-pixel-ratio: 1.5),
  (-webkit-min-device-pixel-ratio: 1.4375),
  (min-resolution: 138dpi),
  (-webkit-min-device-pixel-ratio: 1.5),
  (min-resolution: 1.5dppx) {
  .dropzone .dz-preview .dz-error-mark,
  .dropzone-previews .dz-preview .dz-error-mark,
  .dropzone .dz-preview .dz-success-mark,
  .dropzone-previews .dz-preview .dz-success-mark {
    background-image: url("/public/imgs/common/dropzone/spritemap@2x.png");
    background-size: 428px 406px;
  }
}

.dropzone .dz-preview .dz-error-mark span,
.dropzone-previews .dz-preview .dz-error-mark span,
.dropzone .dz-preview .dz-success-mark span,
.dropzone-previews .dz-preview .dz-success-mark span {
  display: none;
}

.dropzone .dz-preview .dz-error-mark,
.dropzone-previews .dz-preview .dz-error-mark {
  background-position: -268px -123px;
}

.dropzone .dz-preview .dz-success-mark,
.dropzone-previews .dz-preview .dz-success-mark {
  background-position: -268px -163px;
}

.dropzone .dz-preview .dz-progress .dz-upload,
.dropzone-previews .dz-preview .dz-progress .dz-upload {
  -webkit-animation: loading 0.4s linear infinite;
          animation: loading 0.4s linear infinite;
  -webkit-transition: width 0.3s ease-in-out;
  transition: width 0.3s ease-in-out;
  border-radius: 2px;
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-image: url("/public/imgs/common/dropzone/spritemap.png");
  background-repeat: repeat-x;
  background-position: 0px -400px;
}

@media all and (-webkit-min-device-pixel-ratio: 1.5),
  (min-device-pixel-ratio: 1.5),
  (-webkit-min-device-pixel-ratio: 1.4375),
  (min-resolution: 138dpi),
  (-webkit-min-device-pixel-ratio: 1.5),
  (min-resolution: 1.5dppx) {
  .dropzone .dz-preview .dz-progress .dz-upload,
  .dropzone-previews .dz-preview .dz-progress .dz-upload {
    background-image: url("/public/imgs/common/dropzone/spritemap@2x.png");
    background-size: 428px 406px;
  }
}

.dropzone .dz-preview.dz-success .dz-progress,
.dropzone-previews .dz-preview.dz-success .dz-progress {
  display: block;
  opacity: 0;
  -webkit-transition: opacity 0.4s ease-in-out;
  transition: opacity 0.4s ease-in-out;
}

.dropzone .dz-preview .dz-error-message,
.dropzone-previews .dz-preview .dz-error-message {
  display: block;
  opacity: 0;
  -webkit-transition: opacity 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;
}

.dropzone .dz-preview:hover.dz-error .dz-error-message,
.dropzone-previews .dz-preview:hover.dz-error .dz-error-message {
  opacity: 1;
}

.dropzone a.dz-remove,
.dropzone-previews a.dz-remove {
  background-image: -webkit-gradient(linear, left top, left bottom, from(#fafafa), to(#eee));
  background-image: linear-gradient(to bottom, #fafafa, #eee);
  border-radius: 2px;
  border: 1px solid #eee;
  text-decoration: none;
  display: block;
  padding: 4px 5px;
  text-align: center;
  color: #aaa;
  margin-top: 26px;
}

.dropzone a.dz-remove:hover,
.dropzone-previews a.dz-remove:hover {
  color: #666;
}

@-webkit-keyframes loading {
  from {
    background-position: 0 -400px;
  }
  to {
    background-position: -7px -400px;
  }
}

@keyframes loading {
  from {
    background-position: 0 -400px;
  }
  to {
    background-position: -7px -400px;
  }
}

/*
    TimelineJS - ver. 2.33.1 - 2014-06-24
    Copyright (c) 2012-2013 Northwestern University
    a project of the Northwestern University Knight Lab, originally created by Zach Wise
    https://github.com/NUKnightLab/TimelineJS
    This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0.
    If a copy of the MPL was not distributed with this file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
/*@noflip*/
.vco-storyjs div * {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

/*@noflip*/
.vco-storyjs h1,
.vco-storyjs h2,
.vco-storyjs h3,
.vco-storyjs h4,
.vco-storyjs h5,
.vco-storyjs h6,
.vco-storyjs p,
.vco-storyjs blockquote,
.vco-storyjs pre,
.vco-storyjs a,
.vco-storyjs abbr,
.vco-storyjs acronym,
.vco-storyjs address,
.vco-storyjs cite,
.vco-storyjs code,
.vco-storyjs del,
.vco-storyjs dfn,
.vco-storyjs em,
.vco-storyjs img,
.vco-storyjs q,
.vco-storyjs s,
.vco-storyjs samp,
.vco-storyjs small,
.vco-storyjs strike,
.vco-storyjs strong,
.vco-storyjs sub,
.vco-storyjs sup,
.vco-storyjs tt,
.vco-storyjs var,
.vco-storyjs dd,
.vco-storyjs dl,
.vco-storyjs dt,
.vco-storyjs li,
.vco-storyjs ol,
.vco-storyjs ul,
.vco-storyjs fieldset,
.vco-storyjs form,
.vco-storyjs label,
.vco-storyjs legend,
.vco-storyjs button,
.vco-storyjs table,
.vco-storyjs caption,
.vco-storyjs tbody,
.vco-storyjs tfoot,
.vco-storyjs thead,
.vco-storyjs tr,
.vco-storyjs th,
.vco-storyjs td,
.vco-storyjs .vco-container,
.vco-storyjs .content-container,
.vco-storyjs .media,
.vco-storyjs .text,
.vco-storyjs .vco-slider,
.vco-storyjs .slider,
.vco-storyjs .date,
.vco-storyjs .title,
.vco-storyjs .messege,
.vco-storyjs .map,
.vco-storyjs .credit,
.vco-storyjs .caption,
.vco-storyjs .vco-feedback,
.vco-storyjs .vco-feature,
.vco-storyjs .toolbar,
.vco-storyjs .marker,
.vco-storyjs .dot,
.vco-storyjs .line,
.vco-storyjs .flag,
.vco-storyjs .time,
.vco-storyjs .era,
.vco-storyjs .major,
.vco-storyjs .minor,
.vco-storyjs .vco-navigation,
.vco-storyjs .start,
.vco-storyjs .active {
  margin: 0;
  padding: 0;
  border: 0;
  font-weight: normal;
  font-style: normal;
  font-size: 100%;
  line-height: 1;
  font-family: inherit;
  width: auto;
  float: none;
}

/*@noflip*/
.vco-storyjs h1,
.vco-storyjs h2,
.vco-storyjs h3,
.vco-storyjs h4,
.vco-storyjs h5,
.vco-storyjs h6 {
  clear: none;
}

/*@noflip*/
.vco-storyjs table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*@noflip*/
.vco-storyjs ol,
.vco-storyjs ul {
  list-style: none;
}

/*@noflip*/
.vco-storyjs q:before,
.vco-storyjs q:after,
.vco-storyjs blockquote:before,
.vco-storyjs blockquote:after {
  content: "";
}

/*@noflip*/
.vco-storyjs a:focus {
  outline: thin dotted;
}

/*@noflip*/
.vco-storyjs a:hover,
.vco-storyjs a:active {
  outline: 0;
}

/*@noflip*/
.vco-storyjs article,
.vco-storyjs aside,
.vco-storyjs details,
.vco-storyjs figcaption,
.vco-storyjs figure,
.vco-storyjs footer,
.vco-storyjs header,
.vco-storyjs hgroup,
.vco-storyjs nav,
.vco-storyjs section {
  display: block;
}

/*@noflip*/
.vco-storyjs audio,
.vco-storyjs canvas,
.vco-storyjs video {
  display: inline-block;
  *display: inline;
  *zoom: 1;
}

/*@noflip*/
.vco-storyjs audio:not([controls]) {
  display: none;
}

/*@noflip*/
.vco-storyjs div {
  max-width: none;
}

/*@noflip*/
.vco-storyjs sub,
.vco-storyjs sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

/*@noflip*/
.vco-storyjs sup {
  top: -0.5em;
}

/*@noflip*/
.vco-storyjs sub {
  bottom: -0.25em;
}

/*@noflip*/
.vco-storyjs img {
  border: 0;
  -ms-interpolation-mode: bicubic;
}

/*@noflip*/
.vco-storyjs button,
.vco-storyjs input,
.vco-storyjs select,
.vco-storyjs textarea {
  font-size: 100%;
  margin: 0;
  vertical-align: baseline;
  *vertical-align: middle;
}

/*@noflip*/
.vco-storyjs button,
.vco-storyjs input {
  line-height: normal;
  *overflow: visible;
}

/*@noflip*/
.vco-storyjs button-moz-focus-inner,
.vco-storyjs input-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*@noflip*/
.vco-storyjs button,
.vco-storyjs input[type="button"],
.vco-storyjs input[type="reset"],
.vco-storyjs input[type="submit"] {
  cursor: pointer;
  -webkit-appearance: button;
}

/*@noflip*/
.vco-storyjs input[type="search"] {
  -webkit-appearance: textfield;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

/*@noflip*/
.vco-storyjs input[type="search"]-webkit-search-decoration {
  -webkit-appearance: none;
}

/*@noflip*/
.vco-storyjs textarea {
  overflow: auto;
  vertical-align: top;
}

/*@noflip*/
.vco-storyjs {
  font-family: Lato, sans-serif;
}

.vco-storyjs .twitter,
.vco-storyjs .vcard,
.vco-storyjs .messege,
.vco-storyjs .credit,
.vco-storyjs .caption,
.vco-storyjs .zoom-in,
.vco-storyjs .zoom-out,
.vco-storyjs .back-home,
.vco-storyjs .time-interval div,
.vco-storyjs .time-interval-major div,
.vco-storyjs .nav-container {
  font-family: Lato, sans-serif !important;
}

/*@noflip*/
.vco-storyjs h1.date,
.vco-storyjs h2.date,
.vco-storyjs h3.date,
.vco-storyjs h4.date,
.vco-storyjs h5.date,
.vco-storyjs h6.date {
  font-family: Lato, sans-serif !important;
}

/*@noflip*/
.vco-storyjs .timenav h1,
.vco-storyjs .flag-content h1,
.vco-storyjs .era h1,
.vco-storyjs .timenav h2,
.vco-storyjs .flag-content h2,
.vco-storyjs .era h2,
.vco-storyjs .timenav h3,
.vco-storyjs .flag-content h3,
.vco-storyjs .era h3,
.vco-storyjs .timenav h4,
.vco-storyjs .flag-content h4,
.vco-storyjs .era h4,
.vco-storyjs .timenav h5,
.vco-storyjs .flag-content h5,
.vco-storyjs .era h5,
.vco-storyjs .timenav h6,
.vco-storyjs .flag-content h6,
.vco-storyjs .era h6 {
  font-family: Lato, sans-serif !important;
}

/*@noflip*/
.vco-storyjs p,
.vco-storyjs blockquote,
.vco-storyjs blockquote p,
.vco-storyjs .twitter blockquote p {
  font-family: Lato, sans-serif !important;
}

/*@noflip*/
.vco-storyjs .vco-feature h1,
.vco-storyjs .vco-feature h2,
.vco-storyjs .vco-feature h3,
.vco-storyjs .vco-feature h4,
.vco-storyjs .vco-feature h5,
.vco-storyjs .vco-feature h6 {
  font-family: Lato, sans-serif;
}

/*@noflip*/
.timeline-tooltip {
  font-family: Lato, sans-serif;
}

/*@noflip*/
.vco-storyjs {
  font-size: 15px;
  font-weight: normal;
  line-height: 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}

.vco-storyjs p {
  font-size: 15px;
  font-weight: normal;
  line-height: 20px;
  margin-bottom: 20px;
  color: #666;
}

.vco-storyjs p small {
  font-size: 12px;
  line-height: 17px;
}

/*@noflip*/
.vco-storyjs p:first-child {
  margin-top: 20px;
}

/*@noflip*/
.vco-storyjs .vco-navigation p {
  color: #999;
}

/*@noflip*/
.vco-storyjs .vco-feature h3,
.vco-storyjs .vco-feature h4,
.vco-storyjs .vco-feature h5,
.vco-storyjs .vco-feature h6 {
  margin-bottom: 15px;
}

/*@noflip*/
.vco-storyjs .vco-feature p {
  color: #666;
}

/*@noflip*/
.vco-storyjs .vco-feature blockquote,
.vco-storyjs .vco-feature blockquote p {
  color: #000;
}

/*@noflip*/
.vco-storyjs .date a,
.vco-storyjs .title a {
  color: #999;
}

/*@noflip*/
.vco-storyjs .hyphenate {
  -ms-hyphens: auto;
  hyphens: auto;
  word-wrap: break-word;
}

/*@noflip*/
.vco-storyjs h1,
.vco-storyjs h2,
.vco-storyjs h3,
.vco-storyjs h4,
.vco-storyjs h5,
.vco-storyjs h6 {
  font-weight: normal;
  color: #000;
  text-transform: none;
}

.vco-storyjs h1 a,
.vco-storyjs h2 a,
.vco-storyjs h3 a,
.vco-storyjs h4 a,
.vco-storyjs h5 a,
.vco-storyjs h6 a {
  color: #999;
}

/*@noflip*/
.vco-storyjs h1 small,
.vco-storyjs h2 small,
.vco-storyjs h3 small,
.vco-storyjs h4 small,
.vco-storyjs h5 small,
.vco-storyjs h6 small {
  color: #999;
}

/*@noflip*/
.vco-storyjs h1.date,
.vco-storyjs h2.date,
.vco-storyjs h3.date,
.vco-storyjs h4.date,
.vco-storyjs h5.date,
.vco-storyjs h6.date {
  font-weight: bold;
}

/*@noflip*/
.vco-storyjs h2.start {
  font-size: 36px;
  line-height: 38px;
  margin-bottom: 15px;
}

/*@noflip*/
.vco-storyjs h1 {
  margin-bottom: 15px;
  font-size: 32px;
  line-height: 34px;
}

.vco-storyjs h1 small {
  font-size: 18px;
}

/*@noflip*/
.vco-storyjs h2 {
  margin-bottom: 15px;
  font-size: 28px;
  line-height: 30px;
}

.vco-storyjs h2 small {
  font-size: 14px;
  line-height: 16px;
}

/*@noflip*/
.vco-storyjs h2.date {
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 3.75px;
  color: #999;
}

/*@noflip*/
.vco-storyjs h3,
.vco-storyjs h4,
.vco-storyjs h5,
.vco-storyjs h6 {
  line-height: 40px;
}

.vco-storyjs h3 .active,
.vco-storyjs h4 .active,
.vco-storyjs h5 .active,
.vco-storyjs h6 .active {
  color: #08c;
}

/*@noflip*/
.vco-storyjs h3 {
  font-size: 28px;
  line-height: 30px;
}

.vco-storyjs h3 small {
  font-size: 14px;
}

/*@noflip*/
.vco-storyjs h4 {
  font-size: 20px;
  line-height: 22px;
}

.vco-storyjs h4 small {
  font-size: 12px;
}

/*@noflip*/
.vco-storyjs h5 {
  font-size: 16px;
  line-height: 18px;
}

/*@noflip*/
.vco-storyjs h6 {
  font-size: 13px;
  line-height: 14px;
  text-transform: uppercase;
}

/*@noflip*/
.vco-storyjs strong {
  font-weight: bold;
  font-style: inherit;
}

/*@noflip*/
.vco-storyjs em {
  font-style: italic;
  font-weight: inherit;
}

/*@noflip*/
.vco-storyjs Q {
  quotes: "â€ž" "â€œ";
  font-style: italic;
}

/*@noflip*/
.vco-storyjs blockquote,
.vco-storyjs blockquote p {
  font-size: 24px;
  line-height: 32px;
  text-align: left;
  margin-bottom: 6px;
  padding-top: 10px;
  background-color: #fff;
  color: #000;
}

/*@noflip*/
.vco-storyjs .credit {
  color: #999;
  text-align: right;
  font-size: 10px;
  line-height: 10px;
  display: block;
  margin: 0 auto;
  clear: both;
}

/*@noflip*/
.vco-storyjs .caption {
  text-align: left;
  margin-top: 5px;
  color: #666;
  font-size: 11px;
  line-height: 14px;
  clear: both;
}

/*@noflip*/
.vco-storyjs.vco-right-to-left h1,
.vco-storyjs.vco-right-to-left h2,
.vco-storyjs.vco-right-to-left h3,
.vco-storyjs.vco-right-to-left h4,
.vco-storyjs.vco-right-to-left h5,
.vco-storyjs.vco-right-to-left h6,
.vco-storyjs.vco-right-to-left p,
.vco-storyjs.vco-right-to-left blockquote,
.vco-storyjs.vco-right-to-left pre,
.vco-storyjs.vco-right-to-left a,
.vco-storyjs.vco-right-to-left abbr,
.vco-storyjs.vco-right-to-left acronym,
.vco-storyjs.vco-right-to-left address,
.vco-storyjs.vco-right-to-left cite,
.vco-storyjs.vco-right-to-left code,
.vco-storyjs.vco-right-to-left del,
.vco-storyjs.vco-right-to-left dfn,
.vco-storyjs.vco-right-to-left em,
.vco-storyjs.vco-right-to-left img,
.vco-storyjs.vco-right-to-left q,
.vco-storyjs.vco-right-to-left s,
.vco-storyjs.vco-right-to-left samp,
.vco-storyjs.vco-right-to-left small,
.vco-storyjs.vco-right-to-left strike,
.vco-storyjs.vco-right-to-left strong,
.vco-storyjs.vco-right-to-left sub,
.vco-storyjs.vco-right-to-left sup,
.vco-storyjs.vco-right-to-left tt,
.vco-storyjs.vco-right-to-left var,
.vco-storyjs.vco-right-to-left dd,
.vco-storyjs.vco-right-to-left dl,
.vco-storyjs.vco-right-to-left dt,
.vco-storyjs.vco-right-to-left li,
.vco-storyjs.vco-right-to-left ol,
.vco-storyjs.vco-right-to-left ul,
.vco-storyjs.vco-right-to-left fieldset,
.vco-storyjs.vco-right-to-left form,
.vco-storyjs.vco-right-to-left label,
.vco-storyjs.vco-right-to-left legend,
.vco-storyjs.vco-right-to-left button,
.vco-storyjs.vco-right-to-left table,
.vco-storyjs.vco-right-to-left caption,
.vco-storyjs.vco-right-to-left tbody,
.vco-storyjs.vco-right-to-left tfoot,
.vco-storyjs.vco-right-to-left thead,
.vco-storyjs.vco-right-to-left tr,
.vco-storyjs.vco-right-to-left th,
.vco-storyjs.vco-right-to-left td {
  direction: rtl;
}

/*@noflip*/
.timeline-tooltip {
  position: absolute;
  z-index: 1000000000000000013287555072;
  display: block;
  visibility: visible;
  padding: 5px;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 15px;
  font-weight: bold;
  line-height: 20px;
  font-size: 12px;
  line-height: 12px;
}

/*@noflip*/
.timeline-tooltip.in {
  opacity: 0.8;
  filter: alpha(opacity=80);
}

/*@noflip*/
.timeline-tooltip.top {
  margin-top: -2px;
}

/*@noflip*/
.timeline-tooltip.right {
  margin-left: 2px;
}

/*@noflip*/
.timeline-tooltip.bottom {
  margin-top: 2px;
}

/*@noflip*/
.timeline-tooltip.left {
  margin-left: -2px;
}

/*@noflip*/
.timeline-tooltip.top .timeline-tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #000;
}

/*@noflip*/
.timeline-tooltip.left .timeline-tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #000;
}

/*@noflip*/
.timeline-tooltip.bottom .timeline-tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #000;
}

/*@noflip*/
.timeline-tooltip.right .timeline-tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #000;
}

/*@noflip*/
.timeline-tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #000;
  border-radius: 4px;
}

/*@noflip*/
.timeline-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
}

/*@noflip*/
.fancybox-wrap,
.fancybox-skin,
.fancybox-outer,
.fancybox-inner,
.fancybox-image,
.fancybox-wrap iframe,
.fancybox-wrap object,
.fancybox-nav,
.fancybox-nav span,
.fancybox-tmp {
  padding: 0;
  margin: 0;
  border: 0;
  outline: none;
  vertical-align: top;
}

/*@noflip*/
.fancybox-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8020;
}

/*@noflip*/
.fancybox-skin {
  position: relative;
  background: #fff;
  color: #444;
  text-shadow: none;
}

/*@noflip*/
.fancybox-opened {
  z-index: 8030;
}

/*@noflip*/
.fancybox-opened .fancybox-skin {
  -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
}

/*@noflip*/
.fancybox-outer,
.fancybox-inner {
  position: relative;
}

/*@noflip*/
.fancybox-inner {
  overflow: hidden;
}

/*@noflip*/
.fancybox-type-iframe .fancybox-inner {
  -webkit-overflow-scrolling: touch;
}

/*@noflip*/
.fancybox-error {
  color: #444;
  font: 14px/20px Lato, sans-serif;
  margin: 0;
  padding: 15px;
  white-space: nowrap;
}

/*@noflip*/
.fancybox-image,
.fancybox-iframe {
  display: block;
  width: 100%;
  height: 100%;
}

/*@noflip*/
.fancybox-image {
  max-width: 100%;
  max-height: 100%;
}

/*@noflip*/
.fancybox-close,
.fancybox-prev span,
.fancybox-next span {
  background-image: url("/public/imgs/common/timeline/fancybox_sprite.png");
}

/*@noflip*/
#fancybox-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -14px;
  margin-left: -14px;
  background-position: 0 -108px;
  opacity: 0.8;
  cursor: pointer;
  z-index: 8060;
}

/*@noflip*/
#fancybox-loading div {
  width: 28px;
  height: 28px;
  background: url("/public/imgs/common/timeline/loading.gif") center center
    no-repeat;
}

/*@noflip*/
.fancybox-close {
  position: absolute;
  top: -18px;
  right: -18px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  z-index: 8040;
}

/*@noflip*/
.fancybox-nav {
  position: absolute;
  top: 0;
  width: 40%;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
  background: transparent url("/public/imgs/common/timeline/blank.gif");
  -webkit-tap-highlight-color: transparent;
  z-index: 8040;
}

/*@noflip*/
.fancybox-prev {
  left: 0;
}

/*@noflip*/
.fancybox-next {
  right: 0;
}

/*@noflip*/
.fancybox-nav span {
  position: absolute;
  top: 50%;
  width: 36px;
  height: 34px;
  margin-top: -18px;
  cursor: pointer;
  z-index: 8040;
  visibility: hidden;
}

/*@noflip*/
.fancybox-prev span {
  left: 10px;
  background-position: 0 -36px;
}

/*@noflip*/
.fancybox-next span {
  right: 10px;
  background-position: 0 -72px;
}

/*@noflip*/
.fancybox-nav:hover span {
  visibility: visible;
}

/*@noflip*/
.fancybox-tmp {
  position: absolute;
  top: -99999px;
  left: -99999px;
  visibility: hidden;
  max-width: 99999px;
  max-height: 99999px;
  overflow: visible !important;
}

/*@noflip*/
.fancybox-lock {
  overflow: hidden !important;
  width: auto;
}

/*@noflip*/
.fancybox-lock body {
  overflow: hidden !important;
}

/*@noflip*/
.fancybox-lock-test {
  overflow-y: hidden !important;
}

/*@noflip*/
.fancybox-overlay {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  display: none;
  z-index: 8010;
  background: url("/public/imgs/common/timeline/overlay.png");
}

/*@noflip*/
.fancybox-overlay-fixed {
  position: fixed;
  bottom: 0;
  right: 0;
}

/*@noflip*/
.fancybox-lock .fancybox-overlay {
  overflow: auto;
  overflow-y: scroll;
}

/*@noflip*/
.fancybox-title {
  visibility: hidden;
  font: normal 13px/20px Lato, sans-serif;
  position: relative;
  text-shadow: none;
  z-index: 8050;
}

/*@noflip*/
.fancybox-opened .fancybox-title {
  visibility: visible;
}

/*@noflip*/
.fancybox-title-float-wrap {
  position: absolute;
  bottom: 0;
  right: 50%;
  margin-bottom: -35px;
  z-index: 8050;
  text-align: center;
}

.fancybox-title-float-wrap .child {
  display: inline-block;
  margin-right: -100%;
  padding: 2px 20px;
  background: transparent;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 15px;
  text-shadow: 0 1px 2px #222;
  color: #fff;
  font-weight: bold;
  line-height: 24px;
  white-space: nowrap;
}

/*@noflip*/
.fancybox-title-outside-wrap {
  position: relative;
  margin-top: 10px;
  color: #fff;
}

/*@noflip*/
.fancybox-title-inside-wrap {
  padding-top: 10px;
}

/*@noflip*/
.fancybox-title-over-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  color: #fff;
  padding: 10px;
  background: #000;
  background: rgba(0, 0, 0, 0.8);
}

/*@noflip*/
@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
  only screen and (min--moz-device-pixel-ratio: 1.5),
  only screen and (min-device-pixel-ratio: 1.5) {
  #fancybox-loading,
  .fancybox-close,
  .fancybox-prev span,
  .fancybox-next span {
    background-image: url("/public/imgs/common/timeline/fancybox_sprite@2x.png");
    background-size: 44px 152px;
  }
  #fancybox-loading div {
    background-image: url("/public/imgs/common/timeline/loading@2x.gif");
    background-size: 24px 24px;
  }
}

@media only screen and (max-width: 480px),
  only screen and (max-device-width: 480px) {
  .vco-slider .nav-next,
  .vco-slider .nav-previous {
    display: none;
  }
}

.vco-skinny
  .vco-slider
  .slider-item
  .content
  .layout-text-media
  .text
  .container {
  text-align: center !important;
}

/*@noflip*/
.vco-skinny .vco-slider .slider-item .content .layout-text-media h2,
.vco-skinny .vco-slider .slider-item .content .layout-text-media h3 {
  display: block !important;
  width: 100% !important;
  text-align: center !important;
}

/*@noflip*/
.vco-skinny .vco-slider .slider-item .content .content-container {
  display: block;
}

.vco-skinny .vco-slider .slider-item .content .content-container .text {
  width: 100%;
  max-width: 100%;
  min-width: 120px;
  display: block;
}

.vco-skinny
  .vco-slider
  .slider-item
  .content
  .content-container
  .text
  .container {
  display: block;
  -ms-hyphens: auto;
  hyphens: auto;
  word-wrap: break-word;
}

/*@noflip*/
.vco-skinny .vco-slider .slider-item .content .content-container .media {
  width: 100%;
  min-width: 50%;
  float: none;
}

.vco-skinny
  .vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  display: block;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-previous,
.vco-skinny.vco-notouch .vco-slider .nav-next {
  z-index: 203;
}

.vco-skinny.vco-notouch .vco-slider .nav-previous .nav-container .date,
.vco-skinny.vco-notouch .vco-slider .nav-next .nav-container .date,
.vco-skinny.vco-notouch .vco-slider .nav-previous .nav-container .title,
.vco-skinny.vco-notouch .vco-slider .nav-next .nav-container .title {
  filter: alpha(opacity=1);
  -khtml-opacity: 0.01;
  -moz-opacity: 0.01;
  opacity: 0.01;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-previous .nav-container .icon,
.vco-skinny.vco-notouch .vco-slider .nav-next .nav-container .icon {
  filter: alpha(opacity=15);
  -khtml-opacity: 0.15;
  -moz-opacity: 0.15;
  opacity: 0.15;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-previous .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -208px 0;
  width: 24px;
  height: 24px;
  overflow: hidden;
  margin-left: 10px;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-next .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -232px 0;
  width: 24px;
  height: 24px;
  overflow: hidden;
  margin-left: 66px;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-previous:hover,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover {
  color: #aaa !important;
  background-color: #333;
  background-color: rgba(0, 0, 0, 0.65);
  border-radius: 10px;
}

.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .icon,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .icon,
.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .date,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .date,
.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .title,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .title {
  border-radius: 10px;
  font-weight: bold;
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .title,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .title {
  padding-bottom: 5px;
}

/*@noflip*/
.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .date,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .date,
.vco-skinny.vco-notouch .vco-slider .nav-previous:hover .nav-container .title,
.vco-skinny.vco-notouch .vco-slider .nav-next:hover .nav-container .title {
  padding-left: 5px;
  padding-right: 5px;
}

/*@noflip*/
@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2) {
  .vco-skinny.vco-notouch .vco-slider .nav-previous .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -208px 0;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }
  .vco-skinny.vco-notouch .vco-slider .nav-next .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -232px 0;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }
}

.vco-slider {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.vco-slider .slider-container-mask {
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.vco-slider .slider-container-mask .slider-container {
  position: absolute;
  top: 0;
  left: -2160px;
  width: 100%;
  height: 100%;
  text-align: center;
  display: block;
}

.vco-slider .slider-container-mask .slider-container .slider-item-container {
  display: table-cell;
  vertical-align: middle;
}

/*@noflip*/
.vco-notouch .vco-slider .nav-previous:hover,
.vco-notouch .vco-slider .nav-next:hover {
  color: #333;
  cursor: pointer;
}

/*@noflip*/
.vco-notouch .vco-slider .nav-previous:hover .icon {
  margin-left: 10px;
}

/*@noflip*/
.vco-notouch .vco-slider .nav-next:hover .icon {
  margin-left: 66px;
}

/*@noflip*/
.vco-notouch
  .vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-container
  .wikipedia
  h4
  a:hover {
  color: #08c;
  text-decoration: none;
}

/*@noflip*/
.vco-notouch
  .vco-slider
  .slider-item
  .content
  .content-container
  .created-at:hover {
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}

/*@noflip*/
.vco-notouch
  .vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments
  a:hover {
  text-decoration: none;
}

.vco-notouch
  .vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments
  a:hover
  h5 {
  text-decoration: underline;
}

/*@noflip*/
.vco-slider img,
.vco-slider embed,
.vco-slider object,
.vco-slider video,
.vco-slider iframe {
  max-width: 100%;
}

/*@noflip*/
.vco-slider .nav-previous,
.vco-slider .nav-next {
  position: absolute;
  top: 0;
  width: 100px;
  color: #dbdbdb;
  font-size: 11px;
}

.vco-slider .nav-previous .nav-container,
.vco-slider .nav-next .nav-container {
  height: 100px;
  width: 100px;
  position: absolute;
}

/*@noflip*/
.vco-slider .nav-previous .icon,
.vco-slider .nav-next .icon {
  margin-top: 12px;
  margin-bottom: 15px;
}

/*@noflip*/
.vco-slider .nav-previous .date,
.vco-slider .nav-next .date,
.vco-slider .nav-previous .title,
.vco-slider .nav-next .title {
  line-height: 14px;
}

.vco-slider .nav-previous .date a,
.vco-slider .nav-next .date a,
.vco-slider .nav-previous .title a,
.vco-slider .nav-next .title a {
  color: #999;
}

/*@noflip*/
.vco-slider .nav-previous .date small,
.vco-slider .nav-next .date small,
.vco-slider .nav-previous .title small,
.vco-slider .nav-next .title small {
  display: none;
}

/*@noflip*/
.vco-slider .nav-previous .date,
.vco-slider .nav-next .date {
  font-size: 13px;
  line-height: 13px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 5px;
}

/*@noflip*/
.vco-slider .nav-previous .title,
.vco-slider .nav-next .title {
  font-size: 11px;
  line-height: 13px;
}

/*@noflip*/
.vco-slider .nav-previous {
  float: left;
  text-align: left;
}

.vco-slider .nav-previous .icon {
  margin-left: 15px;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -160px 0;
  width: 24px;
  height: 24px;
  overflow: hidden;
}

/*@noflip*/
.vco-slider .nav-previous .date,
.vco-slider .nav-previous .title {
  text-align: left;
  padding-left: 15px;
}

/*@noflip*/
.vco-slider .nav-next {
  float: right;
  text-align: right;
}

.vco-slider .nav-next .icon {
  margin-left: 61px;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -184px 0;
  width: 24px;
  height: 24px;
  overflow: hidden;
}

/*@noflip*/
.vco-slider .nav-next .date,
.vco-slider .nav-next .title {
  text-align: right;
  padding-right: 15px;
}

/*@noflip*/
@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2) {
  .vco-slider .nav-previous .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -160px 0;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }
  .vco-slider .nav-next .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -184px 0;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }
}

.vco-slider .slider-item {
  position: absolute;
  width: 700px;
  height: 100%;
  padding: 0;
  margin: 0;
  display: table;
  overflow-y: auto;
}

.vco-slider .slider-item .content {
  display: table-cell;
  vertical-align: middle;
}

.vco-slider .slider-item .content .pad-top .text .container {
  padding-top: 15px;
}

/*@noflip*/
.vco-slider .slider-item .content .pad-right .text .container {
  padding-right: 15px;
}

/*@noflip*/
.vco-slider .slider-item .content .pad-left .text .container {
  padding-left: 30px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .pad-left
  .media.text-media
  .media-wrapper
  .media-container {
  border: none;
  background-color: #fff;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container {
  display: table;
  vertical-align: middle;
}

.vco-slider .slider-item .content .content-container .text {
  width: 40%;
  max-width: 50%;
  min-width: 120px;
  display: table-cell;
  vertical-align: middle;
}

.vco-slider .slider-item .content .content-container .text .container {
  display: table-cell;
  vertical-align: middle;
  text-align: left;
}

.vco-slider .slider-item .content .content-container .text .container p {
  -ms-hyphens: auto;
  hyphens: auto;
  word-wrap: break-word;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .text .container h2.date {
  font-size: 15px;
  line-height: 15px;
  font-weight: normal;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .text
  .container
  .slide-tag {
  font-size: 11px;
  font-weight: bold;
  color: #fff;
  background-color: #ccc;
  border-radius: 3px;
  vertical-align: baseline;
  white-space: nowrap;
  line-height: 11px;
  padding: 1px 3px 1px;
  margin-left: 7.5px;
  margin-bottom: 7.5px;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .media {
  width: 100%;
  min-width: 50%;
  float: left;
}

.vco-slider .slider-item .content .content-container .media .media-wrapper {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container {
  display: inline-block;
  line-height: 0;
  padding: 0;
  max-height: 100%;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-frame,
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-image
  img {
  border: 1px solid;
  border-color: #ccc #999 #999 #ccc;
  background-color: #fff;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-frame
  iframe {
  background-color: #fff;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .soundcloud {
  border: 0;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-image {
  display: inline-block;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-shadow {
  position: relative;
  z-index: 1;
  background: #fff;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-shadow:before,
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-shadow:after {
  z-index: -1;
  position: absolute;
  content: "";
  bottom: 15px;
  left: 10px;
  width: 50%;
  top: 80%;
  max-width: 300px;
  background: #999;
  -webkit-box-shadow: 0 15px 10px #999;
  box-shadow: 0 15px 10px #999;
  -webkit-transform: rotate(-2deg);
  -ms-transform: rotate(-2deg);
  transform: rotate(-2deg);
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .media-shadowafter {
  -webkit-transform: rotate(2deg);
  -ms-transform: rotate(2deg);
  transform: rotate(2deg);
  right: 10px;
  left: auto;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .plain-text {
  display: table;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .plain-text
  .container {
  display: table-cell;
  vertical-align: middle;
  font-size: 15px;
  line-height: 20px;
  color: #666;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .plain-text
  .container
  p {
  margin-bottom: 20px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .wikipedia {
  font-size: 15px;
  line-height: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
  clear: both;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .wikipedia
  .wiki-source {
  margin-bottom: 15px;
  font-size: 13px;
  line-height: 19px;
  font-style: italic;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .wikipedia
  h4 {
  border-bottom: 1px solid #ccc;
  margin-bottom: 5px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .wikipedia
  h4
  a {
  color: #000;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .wikipedia
  p {
  font-size: 13px;
  line-height: 19px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .map {
  line-height: normal;
  z-index: 200;
  text-align: left;
  background-color: #fff;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .map
  img {
  max-height: none !important;
  max-width: none !important;
  border: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .map
  .google-map {
  height: 100%;
  width: 100%;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .map
  .map-attribution {
  position: absolute;
  z-index: 201;
  bottom: 0;
  width: 100%;
  overflow: hidden;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .map
  .map-attribution
  .attribution-text {
  height: 19px;
  overflow: hidden;
  -webkit-user-select: none;
  line-height: 19px;
  margin-right: 60px;
  padding-left: 65px;
  font-family: Lato, sans-serif;
  font-size: 10px;
  color: #444;
  white-space: nowrap;
  color: #fff;
  text-shadow: 1px 1px 1px #333;
  text-align: center;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .map
  .map-attribution
  .attribution-text
  a {
  color: #fff !important;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .credit {
  color: #999;
  text-align: right;
  display: block;
  margin: 0 auto;
  margin-top: 6px;
  font-size: 10px;
  line-height: 13px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media
  .media-wrapper
  .media-container
  .caption {
  text-align: left;
  margin-top: 10px;
  color: #666;
  font-size: 11px;
  line-height: 14px;
  text-rendering: optimizeLegibility;
  word-wrap: break-word;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .media.text-media
  .media-wrapper
  .media-container {
  border: none;
  background-color: #fff;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .created-at {
  width: 24px;
  height: 24px;
  overflow: hidden;
  margin-left: 7.5px;
  margin-top: 2px;
  display: inline-block;
  float: right;
  filter: alpha(opacity=25);
  -khtml-opacity: 0.25;
  -moz-opacity: 0.25;
  opacity: 0.25;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .storify .created-at {
  background-repeat: no-repeat;
  background-position: -328px -96px;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .twitter .created-at {
  background-repeat: no-repeat;
  background-position: -256px -24px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content {
  font-size: 13px;
  line-height: 19px;
  margin-bottom: 6px;
  padding-top: 10px;
  background-color: #fff;
  color: #666;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  p {
  font-size: 13px;
  line-height: 19px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-title {
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 6px;
  padding-top: 10px;
  background-color: #fff;
  color: #000;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-annotation {
  font-size: 15px;
  line-height: 20px;
  color: #000;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 7.5px;
  margin-bottom: 7.5px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments {
  border-top: 1px solid #e3e3e3;
  padding-top: 15px;
  margin-top: 15px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 15px;
  margin-bottom: 15px;
  *zoom: 1;
}

.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments:before,
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments:after {
  display: table;
  content: "";
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments:after {
  clear: both;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments
  h5 {
  margin-bottom: 5px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments
  div {
  width: 50%;
  padding-left: 15px;
  display: inline-block;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments
  p {
  font-size: 11px;
  line-height: 14px;
  margin-bottom: 5px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .googleplus-content
  .googleplus-attachments
  img {
  float: left;
  display: block;
  bottom: 0;
  left: 0;
  margin: auto;
  position: relative;
  right: 0;
  top: 0;
  width: 40%;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  .proflinkPrefix {
  color: #08c;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .googleplus .created-at {
  background-repeat: no-repeat;
  background-position: -208px -72px;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .twitter,
.vco-slider .slider-item .content .content-container .plain-text-quote,
.vco-slider .slider-item .content .content-container .storify,
.vco-slider .slider-item .content .content-container .googleplus {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
  clear: both;
}

.vco-slider .slider-item .content .content-container .twitter blockquote,
.vco-slider
  .slider-item
  .content
  .content-container
  .plain-text-quote
  blockquote,
.vco-slider .slider-item .content .content-container .storify blockquote,
.vco-slider .slider-item .content .content-container .googleplus blockquote {
  color: #666;
}

.vco-slider .slider-item .content .content-container .twitter blockquote p,
.vco-slider
  .slider-item
  .content
  .content-container
  .plain-text-quote
  blockquote
  p,
.vco-slider .slider-item .content .content-container .storify blockquote p,
.vco-slider .slider-item .content .content-container .googleplus blockquote p {
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 6px;
  padding-top: 10px;
  background-color: #fff;
  color: #000;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container
  .twitter
  blockquote
  .quote-mark,
.vco-slider
  .slider-item
  .content
  .content-container
  .plain-text-quote
  blockquote
  .quote-mark,
.vco-slider
  .slider-item
  .content
  .content-container
  .storify
  blockquote
  .quote-mark,
.vco-slider
  .slider-item
  .content
  .content-container
  .googleplus
  blockquote
  .quote-mark {
  color: #666;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container .twitter blockquote {
  font-size: 15px;
}

.vco-slider .slider-item .content .content-container .twitter blockquote p {
  font-size: 24px;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container.layout-text-media
  .text-media {
  border-top: 1px solid #e3e3e3;
  padding-top: 15px;
  padding-right: 0;
}

/*@noflip*/
.vco-slider
  .slider-item
  .content
  .content-container.layout-text-media.pad-left
  .text-media {
  padding-right: 15px;
  padding-top: 0;
  border-right: 1px solid #e3e3e3;
  border-top: 0 solid #e3e3e3;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container.layout-text {
  width: 100%;
}

.vco-slider .slider-item .content .content-container.layout-text .text {
  width: 100%;
  max-width: 100%;
}

.vco-slider
  .slider-item
  .content
  .content-container.layout-text
  .text
  .container {
  display: block;
  vertical-align: middle;
  padding: 0;
  width: 90%;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container.layout-media {
  width: 100%;
}

.vco-slider .slider-item .content .content-container.layout-media .text {
  width: 100%;
  height: 100%;
  max-width: 100%;
  display: block;
  text-align: center;
}

.vco-slider
  .slider-item
  .content
  .content-container.layout-media
  .text
  .container {
  display: block;
  text-align: center;
  width: 100%;
  margin-left: none;
  margin-right: none;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container.layout-media .media {
  width: 100%;
  min-width: 50%;
  float: none;
}

.vco-slider
  .slider-item
  .content
  .content-container.layout-media
  .media
  .media-wrapper
  .media-container {
  margin-left: auto;
  margin-right: auto;
  line-height: 0;
  padding: 0;
}

/*@noflip*/
.vco-slider .slider-item .content .content-container.layout-media .twitter,
.vco-slider .slider-item .content .content-container.layout-media .wikipedia,
.vco-slider .slider-item .content .content-container.layout-media .googleplus {
  max-width: 70%;
}

/*@noflip*/
.storyjs-embed {
  background-color: #fff;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  padding-top: 20px;
  padding-bottom: 20px;
  clear: both;
  border-radius: 10px;
  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.35);
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.35);
}

/*@noflip*/
.storyjs-embed.full-embed {
  overflow: hidden;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  clear: both;
  border-radius: 0 !important;
  -webkit-box-shadow: 0 0 0 rgba(0, 0, 0, 0.25) !important;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.25) !important;
}

/*@noflip*/
.storyjs-embed.sized-embed {
  overflow: hidden;
  border: 1px solid #ccc;
  padding-top: 7px;
  padding-bottom: 7px;
  margin: 0 !important;
  clear: both;
  -webkit-box-shadow: 0 0 0 rgba(0, 0, 0, 0.25) !important;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.25) !important;
}

/*@noflip*/
.vco-storyjs {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #fff;
  position: absolute;
  z-index: 100;
  clear: both;
  overflow: hidden;
}

.vco-storyjs .vmm-clear:before,
.vco-storyjs .vmm-clear:after {
  content: "";
  display: table;
}

/*@noflip*/
.vco-storyjs .vmm-clear:after {
  clear: both;
}

/*@noflip*/
.vco-storyjs .vmm-clear {
  *zoom: 1;
}

/*@noflip*/
.vco-storyjs .vco-feature {
  width: 100%;
}

.vco-storyjs .vco-feature .slider,
.vco-storyjs .vco-feature .vco-slider {
  width: 100%;
  float: left;
  position: relative;
  z-index: 10;
  padding-top: 15px;
  -webkit-box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.3);
}

/*@noflip*/
.vco-storyjs .vco-feedback {
  position: absolute;
  display: table;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 1000000000000000013287555072;
  width: 100%;
  height: 100%;
}

/*@noflip*/
.vco-storyjs div.vco-loading,
.vco-storyjs div.vco-explainer {
  display: table;
  text-align: center;
  min-width: 100px;
  margin-top: 15px;
  height: 100%;
  width: 100%;
  background-color: #fff;
}

.vco-storyjs div.vco-loading .vco-loading-container,
.vco-storyjs div.vco-explainer .vco-loading-container,
.vco-storyjs div.vco-loading .vco-explainer-container,
.vco-storyjs div.vco-explainer .vco-explainer-container {
  display: table-cell;
  vertical-align: middle;
}

.vco-storyjs div.vco-loading .vco-loading-container .vco-loading-icon,
.vco-storyjs div.vco-explainer .vco-loading-container .vco-loading-icon,
.vco-storyjs div.vco-loading .vco-explainer-container .vco-loading-icon,
.vco-storyjs div.vco-explainer .vco-explainer-container .vco-loading-icon {
  display: block;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  background-image: url("/public/imgs/common/timeline/loading.gif");
  width: 28px;
  height: 28px;
}

/*@noflip*/
.vco-storyjs div.vco-loading .vco-loading-container .vco-gesture-icon,
.vco-storyjs div.vco-explainer .vco-loading-container .vco-gesture-icon,
.vco-storyjs div.vco-loading .vco-explainer-container .vco-gesture-icon,
.vco-storyjs div.vco-explainer .vco-explainer-container .vco-gesture-icon {
  display: block;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -160px -160px;
  height: 48px;
  width: 48px;
  height: 48px;
}

/*@noflip*/
.vco-storyjs div.vco-loading .vco-loading-container .vco-message,
.vco-storyjs div.vco-explainer .vco-loading-container .vco-message,
.vco-storyjs div.vco-loading .vco-explainer-container .vco-message,
.vco-storyjs div.vco-explainer .vco-explainer-container .vco-message {
  display: block;
}

/*@noflip*/
.vco-storyjs div.vco-loading .vco-loading-container .vco-message,
.vco-storyjs div.vco-explainer .vco-loading-container .vco-message,
.vco-storyjs div.vco-loading .vco-explainer-container .vco-message,
.vco-storyjs div.vco-explainer .vco-explainer-container .vco-message,
.vco-storyjs div.vco-loading .vco-loading-container .vco-message p,
.vco-storyjs div.vco-explainer .vco-loading-container .vco-message p,
.vco-storyjs div.vco-loading .vco-explainer-container .vco-message p,
.vco-storyjs div.vco-explainer .vco-explainer-container .vco-message p {
  text-align: center;
  font-size: 11px;
  line-height: 13px;
  text-transform: uppercase;
  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

/*@noflip*/
.vco-storyjs div.vco-explainer {
  background-color: transparent;
}

/*@noflip*/
.vco-storyjs .vco-bezel {
  background-color: #333;
  background-color: rgba(0, 0, 0, 0.8);
  width: 80px;
  height: 50px;
  padding: 50px;
  padding-top: 25px;
  padding: 25px 20px 50px 20px;
  margin: auto;
  border-radius: 10px;
}

.vco-storyjs .vco-bezel .vco-message,
.vco-storyjs .vco-bezel .vco-message p {
  color: #fff;
  font-weight: bold;
}

/*@noflip*/
.vco-storyjs .vco-container.vco-main {
  position: absolute;
  top: 0;
  left: 0;
  padding-bottom: 3px;
  width: auto;
  height: auto;
  margin: 0;
  clear: both;
}

/*@noflip*/
.vco-storyjs img,
.vco-storyjs embed,
.vco-storyjs object,
.vco-storyjs video,
.vco-storyjs iframe {
  max-width: 100%;
}

/*@noflip*/
.vco-storyjs img {
  max-height: 100%;
  border: 1px solid #999;
}

/*@noflip*/
.vco-storyjs a {
  color: #08c;
  text-decoration: none;
}

/*@noflip*/
.vco-storyjs a:hover {
  color: #005580;
  text-decoration: underline;
}

/*@noflip*/
.vco-storyjs .vcard {
  float: right;
  margin-bottom: 15px;
}

.vco-storyjs .vcard a {
  color: #333;
}

/*@noflip*/
.vco-storyjs .vcard a:hover {
  text-decoration: none;
}

.vco-storyjs .vcard a:hover .fn {
  text-decoration: underline;
}

/*@noflip*/
.vco-storyjs .vcard .fn,
.vco-storyjs .vcard .nickname {
  padding-left: 42px;
}

/*@noflip*/
.vco-storyjs .vcard .fn {
  display: block;
  font-weight: bold;
}

/*@noflip*/
.vco-storyjs .vcard .nickname {
  margin-top: 1px;
  display: block;
  color: #666;
}

/*@noflip*/
.vco-storyjs .vcard .avatar {
  float: left;
  display: block;
  width: 32px;
  height: 32px;
}

.vco-storyjs .vcard .avatar img {
  border-radius: 5px;
}

/*@noflip*/
.vco-storyjs .thumbnail {
  width: 24px;
  height: 24px;
  overflow: hidden;
  float: left;
  margin: 0;
  margin-right: 1px;
  margin-top: 6px;
  border: 0;
  padding: 0;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

/*@noflip*/
.vco-storyjs a.thumbnail:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-plaintext {
  background-repeat: no-repeat;
  background-position: -280px -48px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-quote {
  background-repeat: no-repeat;
  background-position: -232px -48px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-document {
  background-repeat: no-repeat;
  background-position: -256px -48px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-photo {
  background-repeat: no-repeat;
  background-position: -280px -24px;
  border: 0;
}

.vco-storyjs .thumbnail.thumb-photo img {
  border: 0 none #ccc !important;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-twitter {
  background-repeat: no-repeat;
  background-position: -256px -24px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-vimeo {
  background-repeat: no-repeat;
  background-position: -328px -48px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-vine {
  background-repeat: no-repeat;
  background-position: -232px -72px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-youtube {
  background-repeat: no-repeat;
  background-position: -328px -72px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-video {
  background-repeat: no-repeat;
  background-position: -328px -24px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-audio {
  background-repeat: no-repeat;
  background-position: -304px -24px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-map {
  background-repeat: no-repeat;
  background-position: -208px -48px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-website {
  background-repeat: no-repeat;
  background-position: -232px -24px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-link {
  background-repeat: no-repeat;
  background-position: -184px -72px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-wikipedia {
  background-repeat: no-repeat;
  background-position: -184px -48px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-storify {
  background-repeat: no-repeat;
  background-position: -328px -96px;
}

/*@noflip*/
.vco-storyjs .thumbnail.thumb-googleplus {
  background-repeat: no-repeat;
  background-position: -208px -72px;
}

/*@noflip*/
.vco-storyjs thumbnail.thumb-instagram {
  background-repeat: no-repeat;
  background-position: -208px -96px;
}

/*@noflip*/
.vco-storyjs thumbnail.thumb-instagram-full {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -232px -96px;
  width: 48px;
  height: 24px;
}

/*@noflip*/
.vco-storyjs .thumb-storify-full {
  height: 12px;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -280px -96px;
  width: 48px;
}

/*@noflip*/
.vco-storyjs .thumbnail-inline {
  width: 16px;
  height: 14px;
  overflow: hidden;
  display: inline-block;
  margin-right: 1px;
  margin-left: 3px;
  margin-top: 2px;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-storyjs .twitter .thumbnail-inline {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -160px -96px;
}

/*@noflip*/
.vco-storyjs .storify .thumbnail-inline {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -184px -96px;
}

/*@noflip*/
.vco-storyjs .googleplus .thumbnail-inline {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -208px -96px;
}

/*@noflip*/
.vco-storyjs .zFront {
  z-index: 204;
}

/*@noflip*/
@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2) {
  .vco-storyjs div.vco-loading .vco-loading-container .vco-loading-icon,
  .vco-storyjs div.vco-explainer .vco-loading-container .vco-loading-icon,
  .vco-storyjs div.vco-loading .vco-explainer-container .vco-loading-icon,
  .vco-storyjs div.vco-explainer .vco-explainer-container .vco-loading-icon {
    background-image: url("/public/imgs/common/timeline/loading@2x.gif");
  }
  .vco-storyjs div.vco-loading .vco-loading-container .vco-gesture-icon,
  .vco-storyjs div.vco-explainer .vco-loading-container .vco-gesture-icon,
  .vco-storyjs div.vco-loading .vco-explainer-container .vco-gesture-icon,
  .vco-storyjs div.vco-explainer .vco-explainer-container .vco-gesture-icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -160px -160px;
    width: 48px;
    height: 48px;
  }
}

.vco-notouch .vco-navigation .vco-toolbar .zoom-in:hover,
.vco-notouch .vco-navigation .vco-toolbar .zoom-out:hover,
.vco-notouch .vco-navigation .vco-toolbar .back-home:hover {
  color: #08c;
  cursor: pointer;
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}

/*@noflip*/
.vco-notouch .vco-navigation .timenav .content .marker.active:hover {
  cursor: default;
}

.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker.active:hover
  .flag
  .flag-content
  h3,
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker.active:hover
  .flag-small
  .flag-content
  h3 {
  color: #08c;
}

/*@noflip*/
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker.active:hover
  .flag
  .flag-content
  h4,
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker.active:hover
  .flag-small
  .flag-content
  h4 {
  color: #999;
}

/*@noflip*/
.vco-notouch .vco-navigation .timenav .content .marker:hover .line {
  z-index: 24;
  background: #999;
}

/*@noflip*/
.vco-notouch .vco-navigation .timenav .content .marker .flag:hover,
.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover {
  cursor: pointer;
}

.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag:hover
  .flag-content
  h3,
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small:hover
  .flag-content
  h3 {
  color: #333;
}

/*@noflip*/
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag:hover
  .flag-content
  h4,
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small:hover
  .flag-content
  h4 {
  color: #aaa;
}

/*@noflip*/
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag:hover
  .flag-content
  .thumbnail,
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small:hover
  .flag-content
  .thumbnail {
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}

/*@noflip*/
.vco-notouch .vco-navigation .timenav .content .marker .flag:hover {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 -53px;
  width: 153px;
  height: 53px;
}

/*@noflip*/
.vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover {
  height: 56px;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 -53px;
  width: 153px;
  height: 53px;
}

.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small:hover
  .flag-content {
  height: 36px;
}

.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small:hover
  .flag-content
  h3 {
  margin-top: 5px;
}

/*@noflip*/
.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small.flag-small-last:hover {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 -109px;
  width: 153px;
  height: 26px;
  height: 26px;
}

.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small.flag-small-last:hover
  .flag-content {
  height: 14px;
}

.vco-notouch
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small.flag-small-last:hover
  .flag-content
  h3 {
  margin-top: 4px;
}

/*@noflip*/
.vco-timeline .vco-navigation {
  clear: both;
  cursor: move;
  width: 100%;
  height: 200px;
  border-top: 1px solid #e3e3e3;
  position: relative;
}

.vco-timeline .vco-navigation .vco-toolbar {
  position: absolute;
  top: 45px;
  left: 0;
  z-index: 202;
  background-color: #fff;
  border: 1px solid #ccc;
  -webkit-box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
}

.vco-timeline .vco-navigation .vco-toolbar .zoom-in,
.vco-timeline .vco-navigation .vco-toolbar .zoom-out,
.vco-timeline .vco-navigation .vco-toolbar .back-home {
  font-weight: normal;
  font-size: 10px;
  line-height: 20px;
  top: 0;
  z-index: 202;
  width: 18px;
  height: 18px;
  color: #333;
  text-align: center;
  font-weight: bold;
  border: 1px solid #fff;
  padding: 5px;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar .zoom-in .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -256px 0;
  width: 24px;
  height: 24px;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar .zoom-out .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -280px 0;
  width: 24px;
  height: 24px;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar .back-home .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -328px 0;
  width: 24px;
  height: 24px;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar.touch {
  border-radius: 10px;
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-in,
.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-out,
.vco-timeline .vco-navigation .vco-toolbar.touch .back-home {
  width: 40px;
  height: 40px;
  padding: 5px;
  background-color: #fff;
  border: 1px solid #ccc;
  -webkit-box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-in .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -208px -160px;
  width: 40px;
  height: 40px;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar.touch .zoom-out .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -256px -160px;
  width: 40px;
  height: 40px;
}

/*@noflip*/
.vco-timeline .vco-navigation .vco-toolbar.touch .back-home .icon {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -304px -160px;
  width: 40px;
  height: 40px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background {
  position: absolute;
  cursor: move;
  top: 0;
  left: 0;
  height: 150px;
  width: 100%;
  background-color: #e9e9e9;
}

.vco-timeline .vco-navigation .timenav-background .timenav-interval-background {
  position: absolute;
  top: 151px;
  left: 0;
  background: #fff;
  width: 100%;
  height: 49px;
  -webkit-box-shadow: -1px -1px 7px rgba(0, 0, 0, 0.1);
  box-shadow: -1px -1px 7px rgba(0, 0, 0, 0.1);
}

.vco-timeline
  .vco-navigation
  .timenav-background
  .timenav-interval-background
  .top-highlight {
  position: absolute;
  top: -1px;
  left: 0;
  z-index: 30;
  width: 100%;
  height: 1px;
  background: #fff;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
  -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-line {
  position: absolute;
  top: 0;
  left: 50%;
  width: 3px;
  height: 150px;
  background-color: #08c;
  z-index: 1;
  -webkit-box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.3);
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-indicator {
  position: absolute;
  top: -1px;
  left: 50%;
  z-index: 202;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -160px -48px;
  width: 24px;
  height: 24px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-tag div {
  height: 50px;
  display: table;
}

.vco-timeline .vco-navigation .timenav-background .timenav-tag div h3 {
  display: table-cell;
  vertical-align: middle;
  padding-left: 65px;
  font-size: 15px;
  color: #d0d0d0;
  font-weight: bold;
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-half {
  height: 25px;
}

.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-half div {
  height: 25px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-full {
  height: 50px;
}

.vco-timeline .vco-navigation .timenav-background .timenav-tag-size-full div {
  height: 50px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-2,
.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-4,
.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-6 {
  background: #f1f1f1;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-1,
.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-3,
.vco-timeline .vco-navigation .timenav-background .timenav-tag-row-5 {
  background: #e9e9e9;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav {
  position: absolute;
  top: 0;
  left: -250px;
  z-index: 1;
}

.vco-timeline .vco-navigation .timenav .content {
  position: relative;
}

.vco-timeline .vco-navigation .timenav .content .marker.start {
  display: none;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker.active .dot {
  background: #08c;
  z-index: 200;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker.active .line {
  z-index: 199;
  background: #08c;
  width: 1px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .line
  .event-line {
  background: #08c;
  filter: alpha(opacity=75);
  -khtml-opacity: 0.75;
  -moz-opacity: 0.75;
  opacity: 0.75;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker.active .flag,
.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small {
  z-index: 200;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag
  .flag-content,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag-small
  .flag-content {
  height: 36px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag
  .flag-content
  h3,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag-small
  .flag-content
  h3 {
  color: #08c;
  margin-top: 5px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag
  .flag-content
  .thumbnail,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag-small
  .flag-content
  .thumbnail {
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker.active .flag.row1,
.vco-timeline .vco-navigation .timenav .content .marker.active .flag.row2,
.vco-timeline .vco-navigation .timenav .content .marker.active .flag.row3,
.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small.row1,
.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small.row2,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag-small.row3 {
  z-index: 200;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker.active .flag {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 -53px;
  width: 153px;
  height: 53px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker.active .flag-small {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 -109px;
  width: 153px;
  height: 26px;
  height: 26px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag-small
  .flag-content {
  height: 14px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker.active
  .flag-small
  .flag-content
  h3 {
  margin-top: 4px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker {
  position: absolute;
  top: 0;
  left: 150px;
  display: block;
}

.vco-timeline .vco-navigation .timenav .content .marker .dot {
  position: absolute;
  top: 150px;
  left: 0;
  display: block;
  width: 6px;
  height: 6px;
  background: #333;
  border-radius: 3px;
  z-index: 21;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .line {
  position: absolute;
  top: 0;
  left: 3px;
  width: 1px;
  height: 150px;
  background-color: #ccc;
  background-color: rgba(204, 204, 204, 0.5);
  -webkit-box-shadow: 1px 0 0 rgba(255, 255, 255, 0.5);
  box-shadow: 1px 0 0 rgba(255, 255, 255, 0.5);
  z-index: 22;
}

.vco-timeline .vco-navigation .timenav .content .marker .line .event-line {
  position: absolute;
  z-index: 22;
  left: 0;
  height: 1px;
  width: 1px;
  background: #08c;
  filter: alpha(opacity=15);
  -khtml-opacity: 0.15;
  -moz-opacity: 0.15;
  opacity: 0.15;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag,
.vco-timeline .vco-navigation .timenav .content .marker .flag-small {
  position: absolute;
  top: 15px;
  left: 3px;
  padding: 0;
  display: block;
  z-index: 23;
  width: 153px;
}

.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content {
  padding: 0 7px 2px 6px;
  overflow: hidden;
}

.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h3,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  h3 {
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  font-size: 11px;
  line-height: 11px;
  color: #999;
  margin-bottom: 2px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag
  .flag-content
  h3
  small,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  h3
  small {
  display: none;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h4,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  h4 {
  display: none;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  margin-top: 5px;
  font-size: 10px;
  line-height: 10px;
  color: #aaa;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag
  .flag-content
  h4
  small,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  h4
  small {
  display: none;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag
  .flag-content
  .thumbnail,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail {
  margin-bottom: 15px;
  margin-right: 3px;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag
  .flag-content
  .thumbnail
  img,
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail
  img {
  width: 22px;
  height: 22px;
  max-height: none;
  max-width: none;
  border: 0;
  border: 1px solid #999;
  padding: 0;
  margin: 0;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag {
  height: 56px;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 0;
  width: 153px;
  height: 53px;
}

.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content {
  height: 36px;
}

.vco-timeline .vco-navigation .timenav .content .marker .flag .flag-content h3 {
  margin-top: 5px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small {
  height: 26px;
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: 0 -135px;
  width: 153px;
  height: 26px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content {
  height: 14px;
}

.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  h3 {
  margin-top: 4px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail {
  width: 16px;
  height: 10px;
  margin-right: 1px;
  margin-top: 6px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-plaintext {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -280px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-quote {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -232px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-document {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -256px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-photo {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -280px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-twitter {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -256px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-vimeo {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -328px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-vine {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -160px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-youtube {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -304px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-video {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -328px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-audio {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -304px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-map {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -208px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-website {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -232px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-link {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -232px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-wikipedia {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -184px -120px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-storify {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -184px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  .thumbnail.thumb-googleplus {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -208px -130px;
}

/*@noflip*/
.vco-timeline
  .vco-navigation
  .timenav
  .content
  .marker
  .flag-small
  .flag-content
  thumbnail.thumb-instagram {
  background-image: url("/public/imgs/common/timeline/timeline.png");
  background-repeat: no-repeat;
  background-position: -208px -96px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag.row1 {
  z-index: 25;
  top: 48px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag.row2 {
  z-index: 24;
  top: 96px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag.row3 {
  z-index: 23;
  top: 1px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row1 {
  z-index: 28;
  top: 24px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row2 {
  z-index: 27;
  top: 48px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row3 {
  z-index: 26;
  top: 72px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row4 {
  z-index: 25;
  top: 96px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row5 {
  z-index: 24;
  top: 120px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.row6 {
  z-index: 23;
  top: 1px;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .marker .flag.zFront,
.vco-timeline .vco-navigation .timenav .content .marker .flag-small.zFront {
  z-index: 201;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era {
  position: absolute;
  top: 138px;
  left: 150px;
  height: 12px;
  display: block;
  overflow: hidden;
}

.vco-timeline .vco-navigation .timenav .content .era div {
  height: 50px;
  width: 100%;
  height: 100%;
  line-height: 0;
  background: #e9e9e9;
  background: rgba(233, 233, 233, 0.33);
}

.vco-timeline .vco-navigation .timenav .content .era div h3,
.vco-timeline .vco-navigation .timenav .content .era div h4 {
  position: absolute;
  bottom: 1px;
  padding-left: 15px;
  font-size: 15px;
  font-weight: bold;
  color: rgba(0, 136, 204, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era1 div {
  background: #c40;
  filter: alpha(opacity=10);
  -khtml-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
  border-left: 1px solid rgba(204, 68, 0, 0.1);
  border-right: 1px solid rgba(255, 85, 0, 0.05);
}

.vco-timeline .vco-navigation .timenav .content .era1 div h3,
.vco-timeline .vco-navigation .timenav .content .era1 div h4 {
  color: rgba(204, 68, 0, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era2 div {
  background: #c02;
  filter: alpha(opacity=10);
  -khtml-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
  border-left: 1px solid rgba(204, 0, 34, 0.1);
  border-right: 1px solid rgba(255, 0, 43, 0.05);
}

.vco-timeline .vco-navigation .timenav .content .era2 div h3,
.vco-timeline .vco-navigation .timenav .content .era2 div h4 {
  color: rgba(204, 0, 34, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era3 div {
  background: #02c;
  filter: alpha(opacity=10);
  -khtml-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
  border-left: 1px solid rgba(0, 34, 204, 0.1);
  border-right: 1px solid rgba(0, 43, 255, 0.05);
}

.vco-timeline .vco-navigation .timenav .content .era3 div h3,
.vco-timeline .vco-navigation .timenav .content .era3 div h4 {
  color: rgba(0, 34, 204, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era4 div {
  background: #ca0;
  filter: alpha(opacity=10);
  -khtml-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
  border-left: 1px solid rgba(204, 170, 0, 0.1);
  border-right: 1px solid rgba(255, 213, 0, 0.05);
}

.vco-timeline .vco-navigation .timenav .content .era4 div h3,
.vco-timeline .vco-navigation .timenav .content .era4 div h4 {
  color: rgba(204, 170, 0, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era5 div {
  background: #0ca;
  filter: alpha(opacity=10);
  -khtml-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
  border-left: 1px solid rgba(0, 204, 170, 0.1);
  border-right: 1px solid rgba(0, 255, 213, 0.05);
}

.vco-timeline .vco-navigation .timenav .content .era5 div h3,
.vco-timeline .vco-navigation .timenav .content .era5 div h4 {
  color: rgba(0, 204, 170, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .content .era6 div {
  background: #08c;
  filter: alpha(opacity=10);
  -khtml-opacity: 0.1;
  -moz-opacity: 0.1;
  opacity: 0.1;
  border-left: 1px solid rgba(0, 136, 204, 0.1);
  border-right: 1px solid rgba(0, 170, 255, 0.05);
}

.vco-timeline .vco-navigation .timenav .content .era6 div h3,
.vco-timeline .vco-navigation .timenav .content .era6 div h4 {
  color: rgba(0, 136, 204, 0.35);
  text-shadow: 0 1px 1px #fff;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time {
  position: absolute;
  left: 0;
  top: 150px;
  height: 50px;
  background-color: #fff;
  line-height: 0;
}

.vco-timeline .vco-navigation .timenav .time .time-interval-minor {
  max-width: none;
  height: 6px;
  white-space: nowrap;
  position: absolute;
  top: -2px;
  left: 8px;
  z-index: 10;
}

.vco-timeline .vco-navigation .timenav .time .time-interval-minor .minor {
  position: relative;
  top: 2px;
  display: inline-block;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAMAAACdvocfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFzMzM////040VdgAAAAJ0Uk5T/wDltzBKAAAAEklEQVR42mJgYAQCBopJgAADAAbwADHy2qHzAAAAAElFTkSuQmCC);
  width: 100px;
  height: 6px;
  background-position: center top;
  white-space: nowrap;
  color: #666;
  margin-top: 0;
  padding-top: 0;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval {
  white-space: nowrap;
  position: absolute;
  top: 5px;
  left: 0;
}

.vco-timeline .vco-navigation .timenav .time .time-interval div {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAMAAACdvocfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFzMzM////040VdgAAAAJ0Uk5T/wDltzBKAAAAEklEQVR42mJgYAQCBopJgAADAAbwADHy2qHzAAAAAElFTkSuQmCC);
  background-position: left top;
  background-repeat: no-repeat;
  padding-top: 6px;
  position: absolute;
  height: 3px;
  left: 0;
  display: block;
  font-weight: normal;
  font-size: 10px;
  line-height: 20px;
  text-transform: uppercase;
  text-align: left;
  text-indent: 0;
  white-space: nowrap;
  color: #666;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  z-index: 2;
}

.vco-timeline .vco-navigation .timenav .time .time-interval div strong {
  font-weight: bold;
  color: #000;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval div.era {
  font-weight: bold;
  padding-top: 0;
  margin-top: -3px;
  margin-left: 2px;
  background-image: none;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval .era1 {
  color: #c40;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval .era2 {
  color: #c02;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval .era3 {
  color: #02c;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval .era4 {
  color: #ca0;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval .era5 {
  color: #0ca;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval .era6 {
  color: #08c;
  filter: alpha(opacity=50);
  -khtml-opacity: 0.5;
  -moz-opacity: 0.5;
  opacity: 0.5;
}

/*@noflip*/
.vco-timeline .vco-navigation .timenav .time .time-interval-major {
  white-space: nowrap;
  position: absolute;
  top: 5px;
  left: 0;
}

.vco-timeline .vco-navigation .timenav .time .time-interval-major div {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAQAQMAAADtUYf0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyOTAzRjI3REIzNDcxMUUxQUQ3QUZCOThEODQ1NDhCNyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyOTAzRjI3RUIzNDcxMUUxQUQ3QUZCOThEODQ1NDhCNyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI5MDNGMjdCQjM0NzExRTFBRDdBRkI5OEQ4NDU0OEI3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI5MDNGMjdDQjM0NzExRTFBRDdBRkI5OEQ4NDU0OEI3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+DPWNfQAAAANQTFRFzMzMylJEJwAAAAtJREFUCB1jYMAPAAAgAAHDvpOtAAAAAElFTkSuQmCC);
  background-position: left top;
  background-repeat: no-repeat;
  padding-top: 15px;
  position: absolute;
  height: 15px;
  left: 0;
  display: block;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  text-align: left;
  text-indent: 0;
  white-space: nowrap;
  color: #333;
  margin-left: 0;
  margin-right: 0;
  margin-top: 1px;
  z-index: 5;
}

.vco-timeline .vco-navigation .timenav .time .time-interval-major div strong {
  font-weight: bold;
  color: #000;
}

/*@noflip*/
@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2) {
  .vco-notouch .vco-navigation .vco-toolbar .zoom-in .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -256px 0;
    width: 24px;
    height: 24px;
  }
  .vco-notouch .vco-navigation .vco-toolbar .zoom-out .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -280px 0;
    width: 24px;
    height: 24px;
  }
  .vco-notouch .vco-navigation .vco-toolbar .back-home .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -328px 0;
    width: 24px;
    height: 24px;
  }
  .vco-notouch .vco-navigation .vco-toolbar.touch .zoom-in .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -208px -160px;
    width: 40px;
    height: 40px;
  }
  .vco-notouch .vco-navigation .vco-toolbar.touch .zoom-out .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -256px -160px;
    width: 40px;
    height: 40px;
  }
  .vco-notouch .vco-navigation .vco-toolbar.touch .back-home .icon {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -304px -160px;
    width: 40px;
    height: 40px;
  }
  .vco-notouch .vco-navigation .timenav .content .marker .flag:hover {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: 0 -53px;
    width: 153px;
    height: 53px;
  }
  .vco-notouch .vco-navigation .timenav .content .marker .flag-small:hover {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: 0 -53px;
    width: 153px;
    height: 53px;
  }
  .vco-notouch
    .vco-navigation
    .timenav
    .content
    .marker
    .flag-small.flag-small-last:hover {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: 0 -109px;
    width: 153px;
    height: 26px;
  }
  .vco-notouch .vco-navigation .timenav-background .timenav-indicator {
    background-image: url("/public/imgs/common/timeline/timeline@2x.png");
    background-size: 352px 260px;
    background-repeat: no-repeat;
    background-position: -160px -48px;
    width: 24px;
    height: 24px;
  }
}

@media screen and (max-device-width: 480px) and (orientation: portrait) {
  .storyjs-embed.full-embed {
    height: 557px !important;
    width: 320px !important;
  }
  .storyjs-embed.full-embed .vco-feature {
    height: 356px !important;
  }
}

@media screen and (max-device-width: 480px) and (orientation: landscape) {
  .storyjs-embed.full-embed {
    height: 409px !important;
    width: 480px !important;
  }
  .storyjs-embed.full-embed .vco-feature {
    height: 208px !important;
  }
}

.dd {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  max-width: 600px;
  list-style: none;
  font-size: 13px;
  line-height: 20px;
}

.dd-list {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dd-list .dd-list {
  padding-left: 30px;
}

.dd-item,
.dd-empty,
.dd-placeholder {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
}

.dd-handle {
  display: block;
  height: 30px;
  margin: 5px 0;
  padding: 5px 10px;
  color: #333;
  text-decoration: none;
  font-weight: bold;
  border: 1px solid #ccc;
  background: #fafafa;
  border-radius: 3px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.dd-handle:hover {
  color: #2ea8e5;
  background: #fff;
}

.dd-item > button {
  position: relative;
  cursor: pointer;
  float: left;
  width: 25px;
  height: 20px;
  margin: 5px 0;
  padding: 0;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  border: 0;
  background: transparent;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  font-weight: bold;
}

.dd-item > button:before {
  display: block;
  position: absolute;
  width: 100%;
  text-align: center;
  text-indent: 0;
}

.dd-item > button.dd-expand:before {
  content: "+";
}

.dd-item > button.dd-collapse:before {
  content: "-";
}

.dd-expand {
  display: none;
}

.dd-collapsed .dd-list,
.dd-collapsed .dd-collapse {
  display: none;
}

.dd-collapsed .dd-expand {
  display: block;
}

.dd-empty,
.dd-placeholder {
  margin: 5px 0;
  padding: 0;
  min-height: 30px;
  background: #f2fbff;
  border: 1px dashed #b6bcbf;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.dd-empty {
  border: 1px dashed #bbb;
  min-height: 100px;
  background-color: #e5e5e5;
  background-size: 60px 60px;
  background-position: 0 0, 30px 30px;
}

.dd-dragel {
  position: absolute;
  pointer-events: none;
  z-index: 9999;
}

.dd-dragel > .dd-item .dd-handle {
  margin-top: 0;
}

.dd-dragel .dd-handle {
  -webkit-box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);
          box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.1);
}

.nestable {
  padding: 25px;
  padding-left: 0;
}
.nestable > .dd-list:first-child,
.nestable > .dd-list:last-child {
  margin: 0;
}

.dd {
  max-width: 100%;
}

.dd-list {
  padding-left: 25px;
}

/*! Tablesaw - v2.0.2 - 2015-10-27
* https://github.com/filamentgroup/tablesaw
* Copyright (c) 2015 Filament Group; Licensed MIT */
table.tablesaw {
  empty-cells: show;
  max-width: 100%;
  width: 100%;
}

.tablesaw {
  border-collapse: collapse;
  width: 100%;
}

/* Structure */
.tablesaw {
  border: 0;
  padding: 0;
}

.tablesaw th,
.tablesaw td {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.5em 0.7em;
}

.tablesaw thead tr:first-child th {
  padding-top: 0.9em;
  padding-bottom: 0.7em;
}

.tablesaw-enhanced .tablesaw-bar .btn {
  border: 1px solid #ccc;
  background: none;
  background-color: #fafafa;
  -webkit-box-shadow: 0 1px 0 white;
  box-shadow: 0 1px 0 white;
  color: #4a4a4a;
  clear: both;
  cursor: pointer;
  display: block;
  font: bold 20px/1 sans-serif;
  margin: 0;
  padding: 0.5em 0.85em 0.4em 0.85em;
  position: relative;
  text-align: center;
  text-decoration: none;
  text-transform: capitalize;
  text-shadow: 0 1px 0 #fff;
  width: 100%;
  /* Theming */
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  border-radius: 0.25em;
}

.tablesaw-enhanced .tablesaw-bar a.btn {
  color: #1c95d4;
}

.tablesaw-enhanced .tablesaw-bar .btn:hover {
  text-decoration: none;
}

/* Default radio/checkbox styling horizonal controlgroups. */
.tablesaw-enhanced .tablesaw-bar .btn:active {
  background-color: #ddd;
}

.tablesaw-enhanced .tablesaw-bar .btn:hover,
.tablesaw-enhanced .tablesaw-bar .btn:focus {
  color: #208de3;
  background-color: #fff;
  outline: none;
}

.tablesaw-bar .btn:focus {
  -webkit-box-shadow: 0 0 0.35em #4faeef !important;
  box-shadow: 0 0 0.35em #4faeef !important;
}

.tablesaw-bar .btn-select select {
  background: none;
  border: none;
  display: block;
  position: absolute;
  font-weight: inherit;
  left: 0;
  top: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  min-height: 1em;
}

.tablesaw-bar .btn-select select {
  opacity: 0;
  filter: alpha(opacity=0);
  display: inline-block;
  color: transparent;
}

.tablesaw-bar .btn select option {
  background: #fff;
  color: #000;
  font-family: sans-serif;
}

.tablesaw-enhanced .tablesaw-bar .btn.btn-select {
  color: #4d4d4d;
  padding-right: 2.5em;
  min-width: 7.25em;
  text-align: left;
  text-indent: 0;
}

.tablesaw-bar .btn.btn-small,
.tablesaw-bar .btn.btn-micro {
  display: inline-block;
  width: auto;
  height: auto;
  position: relative;
  top: 0;
}

.tablesaw-bar .btn.btn-small {
  font-size: 1.0625em;
  line-height: 19px;
  padding: 0.3em 1em 0.3em 1em;
}

.tablesaw-bar .btn.btn-micro {
  font-size: 0.8125em;
  padding: 0.4em 0.7em 0.25em 0.7em;
}

.tablesaw-enhanced .tablesaw-bar .btn-select {
  text-align: left;
}

.tablesaw-bar .btn-select:after {
  background: #e5e5e5;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 2px 2px rgba(255, 255, 255, 0.25);
  box-shadow: 0 2px 2px rgba(255, 255, 255, 0.25);
  content: " ";
  display: block;
  position: absolute;
}

.tablesaw-bar .btn-select.btn-small,
.tablesaw-bar .btn-select.btn-micro {
  padding-right: 1.5em;
}

.tablesaw-bar .btn-select:after {
  background: none;
  background-repeat: no-repeat;
  background-position: 0.25em 0.45em;
  content: "\\25bc";
  font-size: 0.55em;
  padding-top: 1.2em;
  padding-left: 1em;
  left: auto;
  right: 0;
  margin: 0;
  top: 0;
  bottom: 0;
  width: 1.8em;
}

.tablesaw-bar .btn-select.btn-small:after,
.tablesaw-bar .btn-select.btn-micro:after {
  width: 1.2em;
  font-size: 0.5em;
  padding-top: 1em;
  padding-right: 0.5em;
  line-height: 1.65;
  background: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-left-width: 0;
}

/* Column navigation buttons for swipe and columntoggle tables */
.tablesaw-advance .btn {
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-shadow: 0 1px 0 #fff;
  border-radius: 0.25em;
}

.tablesaw-advance .btn.btn-micro {
  font-size: 0.8125em;
  padding: 0.3em 0.7em 0.25em 0.7em;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn {
  display: inline-block;
  overflow: hidden;
  width: 1.8em;
  height: 1.8em;
  background-position: 50% 50%;
  margin-left: 0.5em;
  position: relative;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.left:before,
.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.right:before,
.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.down:before,
.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.up:before {
  content: "\\0020";
  overflow: hidden;
  width: 0;
  height: 0;
  position: absolute;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.down:before {
  left: 0.5em;
  top: 0.65em;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #808080;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.up:before {
  left: 0.5em;
  top: 0.65em;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #808080;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.left:before,
.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.right:before {
  top: 0.45em;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.left:before {
  left: 0.6em;
  border-right: 5px solid #808080;
}

.tablesaw-bar .tablesaw-advance a.tablesaw-nav-btn.right:before {
  left: 0.7em;
  border-left: 5px solid #808080;
}

.tablesaw-advance a.tablesaw-nav-btn.disabled {
  opacity: 0.25;
  filter: alpha(opacity=25);
  cursor: default;
  pointer-events: none;
}

/* Table Toolbar */
.tablesaw-bar {
  clear: both;
  font-family: sans-serif;
}

.tablesaw-toolbar {
  font-size: 0.875em;
  float: left;
}

.tablesaw-toolbar label {
  padding: 0.5em 0;
  clear: both;
  display: block;
  color: #888;
  margin-right: 0.5em;
  text-transform: uppercase;
}

.tablesaw-bar .btn,
.tablesaw-enhanced .tablesaw-bar .btn {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.tablesaw-bar .btn-select,
.tablesaw-enhanced .tablesaw-bar .btn-select {
  margin-bottom: 0;
}

.tablesaw-bar .tablesaw-toolbar .btn {
  margin-left: 0.4em;
  margin-top: 0;
  text-transform: uppercase;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: transparent;
  font-family: sans-serif;
  font-size: 1em;
  padding-left: 0.3em;
}

.tablesaw-bar .tablesaw-toolbar .btn-select {
  min-width: 0;
}

.tablesaw-bar .tablesaw-toolbar .btn-select:after {
  padding-top: 0.9em;
}

.tablesaw-bar .tablesaw-toolbar select {
  color: #888;
  text-transform: none;
  background: transparent;
}

.tablesaw-toolbar ~ table {
  clear: both;
}

.tablesaw-toolbar .a11y-sm {
  clip: rect(0 0 0 0);
  height: 1px;
  overflow: hidden;
  position: absolute;
  width: 1px;
}

@media (min-width: 24em) {
  .tablesaw-toolbar .a11y-sm {
    clip: none;
    height: auto;
    width: auto;
    position: static;
    overflow: visible;
  }
}

table.tablesaw tbody th {
  font-weight: bold;
}

table.tablesaw thead th,
table.tablesaw thead td {
  color: #444;
  font-size: 0.9em;
}

.tablesaw th,
.tablesaw td {
  line-height: 1em;
  text-align: left;
  vertical-align: middle;
}

.tablesaw td,
.tablesaw tbody th {
  vertical-align: middle;
  font-size: 1.17em;
  /* 19px */
}

.tablesaw td .btn,
.tablesaw tbody th .btn {
  margin: 0;
}

.tablesaw thead {
  border: 1px solid #e5e5e4;
  background: #e2dfdc;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#e2dfdc));
  background-image: linear-gradient(to bottom, #fff, #e2dfdc);
}

.tablesaw thead th {
  font-weight: 100;
  color: #777;
  text-transform: uppercase;
  text-shadow: 0 1px 0 #fff;
  text-align: left;
}

.tablesaw thead tr:first-child th {
  font-weight: normal;
  font-family: sans-serif;
  border-right: 1px solid #e4e1de;
}

/* Table rows have a gray bottom stroke by default */
.tablesaw tbody tr {
  border-bottom: 1px solid #dfdfdf;
}

.tablesaw caption {
  text-align: left;
  margin-bottom: 0;
  opacity: 0.5;
  filter: alpha(opacity=50);
  line-height: 2.4;
}

@media (min-width: 25em) {
  .tablesaw caption {
    margin-bottom: 0.6em;
    line-height: 1.2;
  }
}

/* Stack */
.tablesaw-cell-label-top {
  text-transform: uppercase;
  font-size: 0.9em;
  font-weight: normal;
}

.tablesaw-cell-label {
  font-size: 0.65em;
  text-transform: uppercase;
  color: #888;
  font-family: sans-serif;
}

@media (min-width: 40em) {
  .tablesaw td {
    line-height: 2em;
  }
}

@media only all {
  .tablesaw-swipe .tablesaw-cell-persist {
    border-right: 1px solid #e4e1de;
  }
  .tablesaw-swipe .tablesaw-cell-persist {
    -webkit-box-shadow: 3px 0 4px -1px #e4e1de;
    box-shadow: 3px 0 4px -1px #e4e1de;
  }
}

/* Table rows have a gray bottom stroke by default */
.tablesaw-stack tbody tr {
  border-bottom: 1px solid #dfdfdf;
}

.tablesaw-stack td .tablesaw-cell-label,
.tablesaw-stack th .tablesaw-cell-label {
  display: none;
}

/* Mobile first styles: Begin with the stacked presentation at narrow widths */
@media only all {
  /* Show the table cells as a block level element */
  .tablesaw-stack td,
  .tablesaw-stack th {
    text-align: left;
    display: block;
  }
  .tablesaw-stack tr {
    clear: both;
    display: table-row;
  }
  /* Make the label elements a percentage width */
  .tablesaw-stack td .tablesaw-cell-label,
  .tablesaw-stack th .tablesaw-cell-label {
    display: block;
    padding: 0 0.6em 0 0;
    width: 30%;
    display: inline-block;
  }
  /* For grouped headers, have a different style to visually separate the levels by classing the first label in each col group */
  .tablesaw-stack th .tablesaw-cell-label-top,
  .tablesaw-stack td .tablesaw-cell-label-top {
    display: block;
    padding: 0.4em 0;
    margin: 0.4em 0;
  }
  .tablesaw-cell-label {
    display: block;
  }
  /* Avoid double strokes when stacked */
  .tablesaw-stack tbody th.group {
    margin-top: -1px;
  }
  /* Avoid double strokes when stacked */
  .tablesaw-stack th.group b.tablesaw-cell-label {
    display: none !important;
  }
}

@media (max-width: 39.9375em) {
  .tablesaw-stack thead td,
  .tablesaw-stack thead th {
    display: none;
  }
  .tablesaw-stack tbody td,
  .tablesaw-stack tbody th {
    clear: left;
    float: left;
    width: 100%;
  }
  .tablesaw-cell-label {
    vertical-align: top;
  }
  .tablesaw-cell-content {
    max-width: 67%;
    display: inline-block;
  }
  .tablesaw-stack td:empty,
  .tablesaw-stack th:empty {
    display: none;
  }
}

/* Media query to show as a standard table at 560px (35em x 16px) or wider */
@media (min-width: 40em) {
  .tablesaw-stack tr {
    display: table-row;
  }
  /* Show the table header rows */
  .tablesaw-stack td,
  .tablesaw-stack th,
  .tablesaw-stack thead td,
  .tablesaw-stack thead th {
    display: table-cell;
    margin: 0;
  }
  /* Hide the labels in each cell */
  .tablesaw-stack td .tablesaw-cell-label,
  .tablesaw-stack th .tablesaw-cell-label {
    display: none !important;
  }
}

.tablesaw-fix-persist {
  table-layout: fixed;
}

@media only all {
  /* Unchecked manually: Always hide */
  .tablesaw-swipe th.tablesaw-cell-hidden,
  .tablesaw-swipe td.tablesaw-cell-hidden {
    display: none;
  }
}

.btn.tablesaw-columntoggle-btn span {
  text-indent: -9999px;
  display: inline-block;
}

.tablesaw-columntoggle-btnwrap {
  position: relative;
  /* for dialog positioning */
}

.tablesaw-columntoggle-btnwrap .dialog-content {
  padding: 0.5em;
}

.tablesaw-columntoggle tbody td {
  line-height: 1.5;
}

/* Remove top/bottom margins around the fieldcontain on check list */
.tablesaw-columntoggle-popup {
  display: none;
}

.tablesaw-columntoggle-btnwrap.visible .tablesaw-columntoggle-popup {
  display: block;
  position: absolute;
  top: 2em;
  right: 0;
  background-color: #fff;
  padding: 0.5em 0.8em;
  border: 1px solid #ccc;
  -webkit-box-shadow: 0 1px 2px #ccc;
  box-shadow: 0 1px 2px #ccc;
  border-radius: 0.2em;
  z-index: 1;
}

.tablesaw-columntoggle-popup fieldset {
  margin: 0;
}

/* Hide all prioritized columns by default */
@media only all {
  .tablesaw-columntoggle th.tablesaw-priority-6,
  .tablesaw-columntoggle td.tablesaw-priority-6,
  .tablesaw-columntoggle th.tablesaw-priority-5,
  .tablesaw-columntoggle td.tablesaw-priority-5,
  .tablesaw-columntoggle th.tablesaw-priority-4,
  .tablesaw-columntoggle td.tablesaw-priority-4,
  .tablesaw-columntoggle th.tablesaw-priority-3,
  .tablesaw-columntoggle td.tablesaw-priority-3,
  .tablesaw-columntoggle th.tablesaw-priority-2,
  .tablesaw-columntoggle td.tablesaw-priority-2,
  .tablesaw-columntoggle th.tablesaw-priority-1,
  .tablesaw-columntoggle td.tablesaw-priority-1 {
    display: none;
  }
}

.tablesaw-columntoggle-btnwrap .dialog-content {
  top: 0 !important;
  right: 1em;
  left: auto !important;
  width: 12em;
  max-width: 18em;
  margin: -0.5em auto 0;
}

.tablesaw-columntoggle-btnwrap .dialog-content:focus {
  outline-style: none;
}

/* Preset breakpoints if "" class added to table */
/* Show priority 1 at 320px (20em x 16px) */
@media (min-width: 20em) {
  .tablesaw-columntoggle th.tablesaw-priority-1,
  .tablesaw-columntoggle td.tablesaw-priority-1 {
    display: table-cell;
  }
}

/* Show priority 2 at 480px (30em x 16px) */
@media (min-width: 30em) {
  .tablesaw-columntoggle th.tablesaw-priority-2,
  .tablesaw-columntoggle td.tablesaw-priority-2 {
    display: table-cell;
  }
}

/* Show priority 3 at 640px (40em x 16px) */
@media (min-width: 40em) {
  .tablesaw-columntoggle th.tablesaw-priority-3,
  .tablesaw-columntoggle td.tablesaw-priority-3 {
    display: table-cell;
  }
  .tablesaw-columntoggle tbody td {
    line-height: 2;
  }
}

/* Show priority 4 at 800px (50em x 16px) */
@media (min-width: 50em) {
  .tablesaw-columntoggle th.tablesaw-priority-4,
  .tablesaw-columntoggle td.tablesaw-priority-4 {
    display: table-cell;
  }
}

/* Show priority 5 at 960px (60em x 16px) */
@media (min-width: 60em) {
  .tablesaw-columntoggle th.tablesaw-priority-5,
  .tablesaw-columntoggle td.tablesaw-priority-5 {
    display: table-cell;
  }
}

/* Show priority 6 at 1,120px (70em x 16px) */
@media (min-width: 70em) {
  .tablesaw-columntoggle th.tablesaw-priority-6,
  .tablesaw-columntoggle td.tablesaw-priority-6 {
    display: table-cell;
  }
}

@media only all {
  /* Unchecked manually: Always hide */
  .tablesaw-columntoggle th.tablesaw-cell-hidden,
  .tablesaw-columntoggle td.tablesaw-cell-hidden {
    display: none;
  }
  /* Checked manually: Always show */
  .tablesaw-columntoggle th.tablesaw-cell-visible,
  .tablesaw-columntoggle td.tablesaw-cell-visible {
    display: table-cell;
  }
}

.tablesaw-columntoggle-popup .btn-group > label {
  display: block;
  padding: 0.2em 0;
  white-space: nowrap;
}

.tablesaw-columntoggle-popup .btn-group > label input {
  margin-right: 0.8em;
}

.tablesaw-sortable,
.tablesaw-sortable thead,
.tablesaw-sortable thead tr,
.tablesaw-sortable thead tr th {
  position: relative;
}

.tablesaw-sortable thead tr th {
  padding-right: 1.6em;
  vertical-align: top;
}

.tablesaw-sortable th.tablesaw-sortable-head,
.tablesaw-sortable tr:first-child th.tablesaw-sortable-head {
  padding: 0;
}

.tablesaw-sortable th.tablesaw-sortable-head button {
  padding-top: 0.9em;
  padding-bottom: 0.7em;
  padding-left: 0.6em;
  padding-right: 1.6em;
}

.tablesaw-sortable .tablesaw-sortable-head button {
  min-width: 100%;
  color: inherit;
  background: transparent;
  border: 0;
  padding: 0;
  text-align: left;
  font: inherit;
  text-transform: inherit;
  position: relative;
}

.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-ascending
  button:after,
.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-descending
  button:after {
  width: 7px;
  height: 10px;
  content: "\\0020";
  position: absolute;
  right: 0.5em;
}

.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-ascending
  button:after {
  content: "\\2191";
}

.tablesaw-sortable
  .tablesaw-sortable-head.tablesaw-sortable-descending
  button:after {
  content: "\\2193";
}

.tablesaw-sortable .not-applicable:after {
  content: "--";
  display: block;
}

.tablesaw-sortable .not-applicable span {
  display: none;
}

.tablesaw-advance {
  float: right;
}

.tablesaw-advance.minimap {
  margin-right: 0.4em;
}

.tablesaw-advance-dots {
  float: left;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tablesaw-advance-dots li {
  display: table-cell;
  margin: 0;
  padding: 0.4em 0.2em;
}

.tablesaw-advance-dots li i {
  width: 0.25em;
  height: 0.25em;
  background: #555;
  border-radius: 100%;
  display: inline-block;
}

.tablesaw-advance-dots-hide {
  opacity: 0.25;
  filter: alpha(opacity=25);
  cursor: default;
  pointer-events: none;
}

.tablesaw th {
  background: white;
}

/*! X-editable - v1.5.0
* In-place editing with Twitter Bootstrap, jQuery UI or pure jQuery
* http://github.com/vitalets/x-editable
* Copyright (c) 2013 Vitaliy Potapov; Licensed MIT */
.editableform {
  margin-bottom: 0;
  /* overwrites bootstrap margin */
}

.editableform .control-group {
  margin-bottom: 0;
  /* overwrites bootstrap margin */
  white-space: nowrap;
  /* prevent wrapping buttons on new line */
  line-height: 20px;
  /* overwriting bootstrap line-height. See #133 */
}

.editable-buttons {
  display: inline-block;
  /* should be inline to take effect of parent's white-space: nowrap */
  vertical-align: top;
  margin-left: 7px;
  /* inline-block emulation for IE7*/
  zoom: 1;
  *display: inline;
}

.editable-buttons.editable-buttons-bottom {
  display: block;
  margin-top: 7px;
  margin-left: 0;
}

.editable-input {
  vertical-align: top;
  display: inline-block;
  /* should be inline to take effect of parent's white-space: nowrap */
  width: auto;
  /* bootstrap-responsive has width: 100% that breakes layout */
  white-space: normal;
  /* reset white-space decalred in parent*/
  /* display-inline emulation for IE7*/
  zoom: 1;
  *display: inline;
}

.editable-input input,
.editable-input select {
  margin-top: 0px;
}

.editable-buttons .editable-cancel {
  margin-left: 7px;
}

/*for jquery-ui buttons need set height to look more pretty*/
.editable-buttons button.ui-button-icon-only {
  height: 24px;
  width: 30px;
}

.editableform-loading {
  background: url("/public/imgs/common/xeditable/loading.gif") center center
    no-repeat;
  height: 25px;
  width: auto;
  min-width: 25px;
}

.editable-inline .editableform-loading {
  background-position: left 5px;
}

.editable-error-block {
  max-width: 300px;
  margin: 5px 0 0 0;
  width: auto;
  white-space: normal;
}

/*add padding for jquery ui*/
.editable-error-block.ui-state-error {
  padding: 3px;
}

.editable-error {
  color: red;
}

/* ---- For specific types ---- */
.editableform .editable-date {
  padding: 0;
  margin: 0;
  float: left;
}

/* move datepicker icon to center of add-on button. See https://github.com/vitalets/x-editable/issues/183 */
.editable-inline .add-on .icon-th {
  margin-top: 3px;
  margin-left: 1px;
}

/* checklist vertical alignment */
.editable-checklist label input[type="checkbox"],
.editable-checklist label span {
  vertical-align: middle;
  margin: 0;
}

.editable-checklist label {
  white-space: nowrap;
}

/* set exact width of textarea to fit buttons toolbar */
.editable-wysihtml5 {
  width: 566px;
  height: 250px;
}

/* clear button shown as link in date inputs */
.editable-clear {
  clear: both;
  font-size: 0.9em;
  text-decoration: none;
  text-align: right;
}

/* IOS-style clear button for text inputs */
.editable-clear-x {
  background: url("/public/imgs/common/xeditable/clear.png") center center
    no-repeat;
  display: block;
  width: 13px;
  height: 13px;
  position: absolute;
  opacity: 0.6;
  z-index: 100;
  top: 50%;
  right: 6px;
  margin-top: -6px;
}

.editable-clear-x:hover {
  opacity: 1;
}

.editable-pre-wrapped {
  white-space: pre-wrap;
}

.editable-container.editable-popup {
  max-width: none !important;
  /* without this rule poshytip/tooltip does not stretch */
}

.editable-container.popover {
  width: auto;
  /* without this rule popover does not stretch */
}

.editable-container.editable-inline {
  display: inline-block;
  vertical-align: middle;
  width: auto;
  /* inline-block emulation for IE7*/
  zoom: 1;
  *display: inline;
}

.editable-container.ui-widget {
  font-size: inherit;
  /* jqueryui widget font 1.1em too big, overwrite it */
  z-index: 9990;
  /* should be less than select2 dropdown z-index to close dropdown first when click */
}

.editable-click,
a.editable-click,
a.editable-click:hover {
  text-decoration: none;
  border-bottom: dashed 1px #0088cc;
}

.editable-click.editable-disabled,
a.editable-click.editable-disabled,
a.editable-click.editable-disabled:hover {
  color: #585858;
  cursor: default;
  border-bottom: none;
}

.editable-empty,
.editable-empty:hover,
.editable-empty:focus {
  font-style: italic;
  color: #dd1144;
  /* border-bottom: none; */
  text-decoration: none;
}

.editable-unsaved {
  font-weight: bold;
}

.editable-unsaved:after {
  /*    content: '*'*/
}

.editable-bg-transition {
  -webkit-transition: background-color 1400ms ease-out;
  transition: background-color 1400ms ease-out;
}

/*see https://github.com/vitalets/x-editable/issues/139 */
.form-horizontal .editable {
  padding-top: 5px;
  display: inline-block;
}

/*!
 * Datepicker for Bootstrap
 *
 * Copyright 2012 Stefan Petre
 * Improvements by Andrew Rowls
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 */
.datepicker {
  padding: 4px;
  border-radius: 4px;
  direction: ltr;
  /*.dow {
    border-top: 1px solid #ddd !important;
  }*/
}

.datepicker-inline {
  width: 220px;
}

.datepicker.datepicker-rtl {
  direction: rtl;
}

.datepicker.datepicker-rtl table tr td span {
  float: right;
}

.datepicker-dropdown {
  top: 0;
  left: 0;
}

.datepicker-dropdown:before {
  content: "";
  display: inline-block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ccc;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: -7px;
  left: 6px;
}

.datepicker-dropdown:after {
  content: "";
  display: inline-block;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #ffffff;
  position: absolute;
  top: -6px;
  left: 7px;
}

.datepicker > div {
  display: none;
}

.datepicker.days div.datepicker-days {
  display: block;
}

.datepicker.months div.datepicker-months {
  display: block;
}

.datepicker.years div.datepicker-years {
  display: block;
}

.datepicker table {
  margin: 0;
}

.datepicker td,
.datepicker th {
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: none;
}

.table-spatiented .datepicker table tr td,
.table-spatiented .datepicker table tr th {
  background-color: transparent;
}

.datepicker table tr td.day:hover {
  background: #eeeeee;
  cursor: pointer;
}

.datepicker table tr td.old,
.datepicker table tr td.new {
  color: #999999;
}

.datepicker table tr td.disabled,
.datepicker table tr td.disabled:hover {
  background: none;
  color: #999999;
  cursor: default;
}

.datepicker table tr td.today,
.datepicker table tr td.today:hover,
.datepicker table tr td.today.disabled,
.datepicker table tr td.today.disabled:hover {
  background-color: #fde19a;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #000;
}

.datepicker table tr td.today:hover,
.datepicker table tr td.today:hover:hover,
.datepicker table tr td.today.disabled:hover,
.datepicker table tr td.today.disabled:hover:hover,
.datepicker table tr td.today:active,
.datepicker table tr td.today:hover:active,
.datepicker table tr td.today.disabled:active,
.datepicker table tr td.today.disabled:hover:active,
.datepicker table tr td.today.active,
.datepicker table tr td.today:hover.active,
.datepicker table tr td.today.disabled.active,
.datepicker table tr td.today.disabled:hover.active,
.datepicker table tr td.today.disabled,
.datepicker table tr td.today:hover.disabled,
.datepicker table tr td.today.disabled.disabled,
.datepicker table tr td.today.disabled:hover.disabled,
.datepicker table tr td.today[disabled],
.datepicker table tr td.today:hover[disabled],
.datepicker table tr td.today.disabled[disabled],
.datepicker table tr td.today.disabled:hover[disabled] {
  background-color: #fdf59a;
}

.datepicker table tr td.today:active,
.datepicker table tr td.today:hover:active,
.datepicker table tr td.today.disabled:active,
.datepicker table tr td.today.disabled:hover:active,
.datepicker table tr td.today.active,
.datepicker table tr td.today:hover.active,
.datepicker table tr td.today.disabled.active,
.datepicker table tr td.today.disabled:hover.active {
  background-color: #fbf069 \\9;
}

.datepicker table tr td.today:hover:hover {
  color: #000;
}

.datepicker table tr td.today.active:hover {
  color: #fff;
}

.datepicker table tr td.range,
.datepicker table tr td.range:hover,
.datepicker table tr td.range.disabled,
.datepicker table tr td.range.disabled:hover {
  background: #eeeeee;
  border-radius: 0;
}

.datepicker table tr td.range.today,
.datepicker table tr td.range.today:hover,
.datepicker table tr td.range.today.disabled,
.datepicker table tr td.range.today.disabled:hover {
  background-color: #f3d17a;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  border-radius: 0;
}

.datepicker table tr td.range.today:hover,
.datepicker table tr td.range.today:hover:hover,
.datepicker table tr td.range.today.disabled:hover,
.datepicker table tr td.range.today.disabled:hover:hover,
.datepicker table tr td.range.today:active,
.datepicker table tr td.range.today:hover:active,
.datepicker table tr td.range.today.disabled:active,
.datepicker table tr td.range.today.disabled:hover:active,
.datepicker table tr td.range.today.active,
.datepicker table tr td.range.today:hover.active,
.datepicker table tr td.range.today.disabled.active,
.datepicker table tr td.range.today.disabled:hover.active,
.datepicker table tr td.range.today.disabled,
.datepicker table tr td.range.today:hover.disabled,
.datepicker table tr td.range.today.disabled.disabled,
.datepicker table tr td.range.today.disabled:hover.disabled,
.datepicker table tr td.range.today[disabled],
.datepicker table tr td.range.today:hover[disabled],
.datepicker table tr td.range.today.disabled[disabled],
.datepicker table tr td.range.today.disabled:hover[disabled] {
  background-color: #f3e97a;
}

.datepicker table tr td.range.today:active,
.datepicker table tr td.range.today:hover:active,
.datepicker table tr td.range.today.disabled:active,
.datepicker table tr td.range.today.disabled:hover:active,
.datepicker table tr td.range.today.active,
.datepicker table tr td.range.today:hover.active,
.datepicker table tr td.range.today.disabled.active,
.datepicker table tr td.range.today.disabled:hover.active {
  background-color: #efe24b \\9;
}

.datepicker table tr td.selected,
.datepicker table tr td.selected:hover,
.datepicker table tr td.selected.disabled,
.datepicker table tr td.selected.disabled:hover {
  background-color: #9e9e9e;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #fff;
}

.datepicker table tr td.selected:hover,
.datepicker table tr td.selected:hover:hover,
.datepicker table tr td.selected.disabled:hover,
.datepicker table tr td.selected.disabled:hover:hover,
.datepicker table tr td.selected:active,
.datepicker table tr td.selected:hover:active,
.datepicker table tr td.selected.disabled:active,
.datepicker table tr td.selected.disabled:hover:active,
.datepicker table tr td.selected.active,
.datepicker table tr td.selected:hover.active,
.datepicker table tr td.selected.disabled.active,
.datepicker table tr td.selected.disabled:hover.active,
.datepicker table tr td.selected.disabled,
.datepicker table tr td.selected:hover.disabled,
.datepicker table tr td.selected.disabled.disabled,
.datepicker table tr td.selected.disabled:hover.disabled,
.datepicker table tr td.selected[disabled],
.datepicker table tr td.selected:hover[disabled],
.datepicker table tr td.selected.disabled[disabled],
.datepicker table tr td.selected.disabled:hover[disabled] {
  background-color: #808080;
}

.datepicker table tr td.selected:active,
.datepicker table tr td.selected:hover:active,
.datepicker table tr td.selected.disabled:active,
.datepicker table tr td.selected.disabled:hover:active,
.datepicker table tr td.selected.active,
.datepicker table tr td.selected:hover.active,
.datepicker table tr td.selected.disabled.active,
.datepicker table tr td.selected.disabled:hover.active {
  background-color: #666666 \\9;
}

.datepicker table tr td.active,
.datepicker table tr td.active:hover,
.datepicker table tr td.active.disabled,
.datepicker table tr td.active.disabled:hover {
  background-color: #006dcc;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #fff;
}

.datepicker table tr td.active:hover,
.datepicker table tr td.active:hover:hover,
.datepicker table tr td.active.disabled:hover,
.datepicker table tr td.active.disabled:hover:hover,
.datepicker table tr td.active:active,
.datepicker table tr td.active:hover:active,
.datepicker table tr td.active.disabled:active,
.datepicker table tr td.active.disabled:hover:active,
.datepicker table tr td.active.active,
.datepicker table tr td.active:hover.active,
.datepicker table tr td.active.disabled.active,
.datepicker table tr td.active.disabled:hover.active,
.datepicker table tr td.active.disabled,
.datepicker table tr td.active:hover.disabled,
.datepicker table tr td.active.disabled.disabled,
.datepicker table tr td.active.disabled:hover.disabled,
.datepicker table tr td.active[disabled],
.datepicker table tr td.active:hover[disabled],
.datepicker table tr td.active.disabled[disabled],
.datepicker table tr td.active.disabled:hover[disabled] {
  background-color: #0044cc;
}

.datepicker table tr td.active:active,
.datepicker table tr td.active:hover:active,
.datepicker table tr td.active.disabled:active,
.datepicker table tr td.active.disabled:hover:active,
.datepicker table tr td.active.active,
.datepicker table tr td.active:hover.active,
.datepicker table tr td.active.disabled.active,
.datepicker table tr td.active.disabled:hover.active {
  background-color: #003399 \\9;
}

.datepicker table tr td span {
  display: block;
  width: 23%;
  height: 54px;
  line-height: 54px;
  float: left;
  margin: 1%;
  cursor: pointer;
  border-radius: 4px;
}

.datepicker table tr td span:hover {
  background: #eeeeee;
}

.datepicker table tr td span.disabled,
.datepicker table tr td span.disabled:hover {
  background: none;
  color: #999999;
  cursor: default;
}

.datepicker table tr td span.active,
.datepicker table tr td span.active:hover,
.datepicker table tr td span.active.disabled,
.datepicker table tr td span.active.disabled:hover {
  background-color: #006dcc;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #fff;
}

.datepicker table tr td span.active:hover,
.datepicker table tr td span.active:hover:hover,
.datepicker table tr td span.active.disabled:hover,
.datepicker table tr td span.active.disabled:hover:hover,
.datepicker table tr td span.active:active,
.datepicker table tr td span.active:hover:active,
.datepicker table tr td span.active.disabled:active,
.datepicker table tr td span.active.disabled:hover:active,
.datepicker table tr td span.active.active,
.datepicker table tr td span.active:hover.active,
.datepicker table tr td span.active.disabled.active,
.datepicker table tr td span.active.disabled:hover.active,
.datepicker table tr td span.active.disabled,
.datepicker table tr td span.active:hover.disabled,
.datepicker table tr td span.active.disabled.disabled,
.datepicker table tr td span.active.disabled:hover.disabled,
.datepicker table tr td span.active[disabled],
.datepicker table tr td span.active:hover[disabled],
.datepicker table tr td span.active.disabled[disabled],
.datepicker table tr td span.active.disabled:hover[disabled] {
  background-color: #0044cc;
}

.datepicker table tr td span.active:active,
.datepicker table tr td span.active:hover:active,
.datepicker table tr td span.active.disabled:active,
.datepicker table tr td span.active.disabled:hover:active,
.datepicker table tr td span.active.active,
.datepicker table tr td span.active:hover.active,
.datepicker table tr td span.active.disabled.active,
.datepicker table tr td span.active.disabled:hover.active {
  background-color: #003399 \\9;
}

.datepicker table tr td span.old,
.datepicker table tr td span.new {
  color: #999999;
}

.datepicker th.datepicker-switch {
  width: 145px;
}

.datepicker thead tr:first-child th,
.datepicker tfoot tr th {
  cursor: pointer;
}

.datepicker thead tr:first-child th:hover,
.datepicker tfoot tr th:hover {
  background: #eeeeee;
}

.datepicker .cw {
  font-size: 10px;
  width: 12px;
  padding: 0 2px 0 5px;
  vertical-align: middle;
}

.datepicker thead tr:first-child th.cw {
  cursor: default;
  background-color: transparent;
}

.input-append.date .add-on i,
.input-prepend.date .add-on i {
  display: block;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.input-daterange input {
  text-align: center;
}

.input-daterange input:first-child {
  border-radius: 3px 0 0 3px;
}

.input-daterange input:last-child {
  border-radius: 0 3px 3px 0;
}

.input-daterange .add-on {
  display: inline-block;
  width: auto;
  min-width: 16px;
  height: 18px;
  padding: 4px 5px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  vertical-align: middle;
  background-color: #eeeeee;
  border: 1px solid #ccc;
  margin-left: -5px;
  margin-right: -5px;
}

.editable-address {
  display: block;
  margin-bottom: 5px;
}

.editable-address span {
  width: 70px;
  display: inline-block;
}

.twitter-typeahead .tt-query,
.twitter-typeahead .tt-hint {
  margin-bottom: 0;
}

.tt-dropdown-menu {
  min-width: 160px;
  margin-top: 2px;
  padding: 5px 0;
  border-radius: 6px;
  background-color: #fff;
  background-clip: padding-box;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.tt-suggestion {
  display: block;
  padding: 3px 20px;
}

.tt-suggestion.tt-is-under-cursor {
  color: #fff;
  background-color: #0081c2;
}

.tt-suggestion.tt-is-under-cursor a {
  color: #fff;
}

.tt-suggestion p {
  margin: 0;
}

/*
 *
 * Main stylesheet for Switchery.
 * http://abpetkov.github.io/switchery/
 *
 */
.switchery {
  background-color: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 20px;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  position: relative;
  vertical-align: middle;
  width: 50px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.switchery > small {
  background: #fff;
  border-radius: 100%;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  height: 30px;
  position: absolute;
  top: 0;
  width: 30px;
}

ul.messenger {
  margin: 0;
  padding: 0;
}

ul.messenger > li {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul.messenger.messenger-empty {
  display: none;
}

ul.messenger .messenger-message {
  overflow: hidden;
  *zoom: 1;
}

ul.messenger .messenger-message.messenger-hidden {
  display: none;
}

ul.messenger .messenger-message .messenger-phrase,
ul.messenger .messenger-message .messenger-actions a {
  border: none;
  padding-right: 5px;
}

ul.messenger .messenger-message .messenger-actions {
  float: right;
}

ul.messenger .messenger-message .messenger-actions a {
  cursor: pointer;
  padding-bottom: 3px;
  text-decoration: none;
  padding-right: 12.5px;
}

ul.messenger .messenger-message ul,
ul.messenger .messenger-message ol {
  margin: 10px 18px 0;
}

ul.messenger.messenger-fixed {
  position: fixed;
  z-index: 9999999999999999999999999999999;
}

ul.messenger.messenger-fixed .messenger-message {
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

ul.messenger.messenger-fixed .message .messenger-actions {
  float: left;
}

ul.messenger.messenger-fixed.messenger-on-top {
  top: 20px;
}

ul.messenger.messenger-fixed.messenger-on-bottom {
  bottom: 20px;
}

ul.messenger.messenger-fixed.messenger-on-top,
ul.messenger.messenger-fixed.messenger-on-bottom {
  left: 50%;
  width: 800px;
  margin-left: -400px;
}

@media (max-width: 960px) {
  ul.messenger.messenger-fixed.messenger-on-top,
  ul.messenger.messenger-fixed.messenger-on-bottom {
    left: 10%;
    width: 80%;
    margin-left: 0px;
  }
}

ul.messenger.messenger-fixed.messenger-on-top.messenger-on-right,
ul.messenger.messenger-fixed.messenger-on-bottom.messenger-on-right {
  right: 20px;
  left: auto;
}

ul.messenger.messenger-fixed.messenger-on-top.messenger-on-left,
ul.messenger.messenger-fixed.messenger-on-bottom.messenger-on-left {
  left: 20px;
  margin-left: 0px;
}

ul.messenger.messenger-fixed.messenger-on-right,
ul.messenger.messenger-fixed.messenger-on-left {
  width: 350px;
}

ul.messenger.messenger-fixed.messenger-on-right .messenger-actions,
ul.messenger.messenger-fixed.messenger-on-left .messenger-actions {
  float: left;
}

ul.messenger .messenger-spinner {
  display: none;
}

@-webkit-keyframes ui-spinner-rotate-right {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes ui-spinner-rotate-left {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes ui-spinner-rotate-right {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

@keyframes ui-spinner-rotate-left {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}

.messenger-spinner {
  position: relative;
  border-radius: 100%;
}

ul.messenger.messenger-spinner-active .messenger-spinner .messenger-spinner {
  display: block;
}

.messenger-spinner .messenger-spinner-side {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}

.messenger-spinner .messenger-spinner-side .messenger-spinner-fill {
  border-radius: 999px;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
}

.messenger-spinner .messenger-spinner-side-left {
  left: 0;
}

.messenger-spinner .messenger-spinner-side-left .messenger-spinner-fill {
  left: 100%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  -webkit-animation-name: ui-spinner-rotate-left;
  animation-name: ui-spinner-rotate-left;
  -webkit-transform-origin: 0 50%;
  -ms-transform-origin: 0 50%;
  transform-origin: 0 50%;
}

.messenger-spinner .messenger-spinner-side-right {
  left: 50%;
}

.messenger-spinner .messenger-spinner-side-right .messenger-spinner-fill {
  left: -100%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  -webkit-animation-name: ui-spinner-rotate-right;
  animation-name: ui-spinner-rotate-right;
  -webkit-transform-origin: 100% 50%;
  -ms-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
}

/**
 * Trumbowyg v2.1.0 - A lightweight WYSIWYG editor
 * Default stylesheet for Trumbowyg editor
 * ------------------------
 * @link http://alex-d.github.io/Trumbowyg
 * @license MIT
 * @author Alexandre Demode (Alex-D)
 *         Twitter : @AlexandreDemode
 *         Website : alex-d.fr
 */
#trumbowyg-icons {
  overflow: hidden;
  visibility: hidden;
  height: 0;
  width: 0;
}

#trumbowyg-icons svg {
  height: 0;
  width: 0;
}

.trumbowyg-box *,
.trumbowyg-box *before,
.trumbowyg-box *after {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.trumbowyg-box svg {
  width: 17px;
  height: 100%;
  fill: #222;
}

.trumbowyg-box,
.trumbowyg-editor {
  display: block;
  position: relative;
  border: 1px solid #ddd;
  width: 100%;
  min-height: 300px;
  margin: 17px auto;
}

.trumbowyg-box .trumbowyg-editor {
  margin: 0 auto;
}

.trumbowyg-box.trumbowyg-fullscreen {
  background: #fefefe;
  border: none !important;
}

.trumbowyg-editor,
.trumbowyg-textarea {
  position: relative;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 20px;
  min-height: 300px;
  width: 100%;
  border-style: none;
  resize: none;
  outline: none;
  overflow: auto;
}

.trumbowyg-box-blur .trumbowyg-editor *,
.trumbowyg-box-blur .trumbowyg-editorbefore {
  color: transparent !important;
  text-shadow: 0 0 7px #333;
}

@media screen and (min-width: 0 \\0) {
  .trumbowyg-box-blur .trumbowyg-editor *,
  .trumbowyg-box-blur .trumbowyg-editorbefore {
    color: rgba(200, 200, 200, 0.6) !important;
  }
}

@supports (-ms-accelerator: true) {
  .trumbowyg-box-blur .trumbowyg-editor *,
  .trumbowyg-box-blur .trumbowyg-editorbefore {
    color: rgba(200, 200, 200, 0.6) !important;
  }
}

.trumbowyg-box-blur .trumbowyg-editor img,
.trumbowyg-box-blur .trumbowyg-editor hr {
  opacity: 0.2;
}

.trumbowyg-textarea {
  position: relative;
  display: block;
  overflow: auto;
  border: none;
  white-space: normal;
  font-size: 14px;
  font-family: "Inconsolata", "Consolas", "Courier", "Courier New", sans-serif;
  line-height: 18px;
}

.trumbowyg-box.trumbowyg-editor-visible .trumbowyg-textarea {
  height: 1px !important;
  width: 25%;
  min-height: 0 !important;
  padding: 0 !important;
  background: none;
  opacity: 0 !important;
}

.trumbowyg-box.trumbowyg-editor-hidden .trumbowyg-textarea {
  display: block;
}

.trumbowyg-box.trumbowyg-editor-hidden .trumbowyg-editor {
  display: none;
}

.trumbowyg-box.trumbowyg-disabled .trumbowyg-textarea {
  opacity: 0.8;
  background: none;
}

.trumbowyg-editor[contenteditable="true"]:emptybefore {
  content: attr(placeholder);
  color: #999;
  pointer-events: none;
}

.trumbowyg-button-pane {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  width: 100%;
  min-height: 36px;
  background: #ecf0f1;
  border-bottom: 1px solid #d7e0e2;
  margin: 0;
  padding: 0 5px;
  list-style-type: none;
  line-height: 10px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.trumbowyg-button-paneafter {
  content: " ";
  display: block;
  position: absolute;
  top: 36px;
  left: 0;
  right: 0;
  width: 100%;
  height: 1px;
  background: #d7e0e2;
}

.trumbowyg-button-pane .trumbowyg-button-group {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}

.trumbowyg-button-pane
  .trumbowyg-button-group
  .trumbowyg-fullscreen-button
  svg {
  color: transparent;
}

.trumbowyg-button-pane
  .trumbowyg-button-group:not(:empty)
  + .trumbowyg-button-groupbefore {
  content: " ";
  display: block;
  width: 1px;
  background: #d7e0e2;
  margin: 0 5px;
  height: 35px;
}

.trumbowyg-button-pane button {
  display: block;
  position: relative;
  width: 35px;
  height: 35px;
  padding: 1px 6px !important;
  margin-bottom: 1px;
  overflow: hidden;
  border: none;
  cursor: pointer;
  background: none;
  -webkit-transition: background-color 150ms, opacity 150ms;
  transition: background-color 150ms, opacity 150ms;
}

.trumbowyg-button-pane.trumbowyg-disable
  button:not(.trumbowyg-not-disable):not(.trumbowyg-active),
.trumbowyg-disabled
  .trumbowyg-button-pane
  button:not(.trumbowyg-not-disable):not(.trumbowyg-viewHTML-button) {
  opacity: 0.2;
  cursor: default;
}

.trumbowyg-button-pane.trumbowyg-disable .trumbowyg-button-groupbefore,
.trumbowyg-disabled .trumbowyg-button-pane .trumbowyg-button-groupbefore {
  background: #e3e9eb;
}

.trumbowyg-button-pane button:not(.trumbowyg-disable):hover,
.trumbowyg-button-pane button:not(.trumbowyg-disable):focus,
.trumbowyg-button-pane button.trumbowyg-active {
  background-color: #fff;
  outline: none;
}

.trumbowyg-button-pane .trumbowyg-open-dropdownafter {
  display: block;
  content: " ";
  position: absolute;
  top: 25px;
  right: 3px;
  height: 0;
  width: 0;
  border: 3px solid transparent;
  border-top-color: #555;
}

.trumbowyg-button-pane .trumbowyg-right {
  margin-left: auto;
}

.trumbowyg-button-pane .trumbowyg-rightbefore {
  display: none !important;
}

.trumbowyg-dropdown {
  width: 200px;
  border: 1px solid #ecf0f1;
  padding: 5px 0;
  border-top: none;
  background: #fff;
  margin-left: -1px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0 2px 3px;
          box-shadow: rgba(0, 0, 0, 0.1) 0 2px 3px;
}

.trumbowyg-dropdown button {
  display: block;
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-decoration: none;
  background: #fff;
  padding: 0 10px;
  color: #333 !important;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 15px;
  -webkit-transition: all 150ms;
  transition: all 150ms;
}

.trumbowyg-dropdown button:hover,
.trumbowyg-dropdown button:focus {
  background: #ecf0f1;
}

.trumbowyg-dropdown button svg {
  float: left;
  margin-right: 14px;
}

/* Modal box */
.trumbowyg-modal {
  position: absolute;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
      transform: translateX(-50%);
  max-width: 520px;
  width: 100%;
  height: 350px;
  z-index: 11;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.trumbowyg-modal-box {
  position: absolute;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
      transform: translateX(-50%);
  max-width: 500px;
  width: calc(100% - 20px);
  padding-bottom: 45px;
  z-index: 1;
  background-color: #fff;
  text-align: center;
  font-size: 14px;
  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 0 2px 3px;
          box-shadow: rgba(0, 0, 0, 0.2) 0 2px 3px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.trumbowyg-modal-box .trumbowyg-modal-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 20px;
  padding: 15px 0 13px;
  display: block;
  border-bottom: 1px solid #eee;
  color: #333;
  background: #fbfcfc;
}

.trumbowyg-modal-box .trumbowyg-progress {
  width: 100%;
  height: 3px;
  position: absolute;
  top: 58px;
}

.trumbowyg-modal-box .trumbowyg-progress .trumbowyg-progress-bar {
  background: #2bc06a;
  height: 100%;
  -webkit-transition: width 150ms linear;
  transition: width 150ms linear;
}

.trumbowyg-modal-box label {
  display: block;
  position: relative;
  margin: 15px 12px;
  height: 27px;
  line-height: 27px;
  overflow: hidden;
}

.trumbowyg-modal-box label .trumbowyg-input-infos {
  display: block;
  text-align: left;
  height: 25px;
  line-height: 25px;
  -webkit-transition: all 150ms;
  transition: all 150ms;
}

.trumbowyg-modal-box label .trumbowyg-input-infos span {
  display: block;
  color: #69878f;
  background-color: #fbfcfc;
  border: 1px solid #dedede;
  padding: 0 7px;
  width: 150px;
}

.trumbowyg-modal-box label .trumbowyg-input-infos span.trumbowyg-msg-error {
  color: #e74c3c;
}

.trumbowyg-modal-box label.trumbowyg-input-error input,
.trumbowyg-modal-box label.trumbowyg-input-error textarea {
  border: 1px solid #e74c3c;
}

.trumbowyg-modal-box label.trumbowyg-input-error .trumbowyg-input-infos {
  margin-top: -27px;
}

.trumbowyg-modal-box label input {
  position: absolute;
  top: 0;
  right: 0;
  height: 27px;
  line-height: 27px;
  border: 1px solid #dedede;
  background: #fff;
  font-size: 14px;
  max-width: 330px;
  width: 70%;
  padding: 0 7px;
  -webkit-transition: all 150ms;
  transition: all 150ms;
}

.trumbowyg-modal-box label input:hover,
.trumbowyg-modal-box label input:focus {
  outline: none;
  border: 1px solid #95a5a6;
}

.trumbowyg-modal-box label input:focus {
  background: #fbfcfc;
}

.trumbowyg-modal-box .error {
  margin-top: 25px;
  display: block;
  color: red;
}

.trumbowyg-modal-box .trumbowyg-modal-button {
  position: absolute;
  bottom: 10px;
  right: 0;
  text-decoration: none;
  color: #fff;
  display: block;
  width: 100px;
  height: 35px;
  line-height: 33px;
  margin: 0 10px;
  background-color: #333;
  border: none;
  cursor: pointer;
  font-family: "Trebuchet MS", Helvetica, Verdana, sans-serif;
  font-size: 16px;
  -webkit-transition: all 150ms;
  transition: all 150ms;
}

.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit {
  right: 110px;
  background: #2bc06a;
}

.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:hover,
.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:focus {
  background: #40d47e;
  outline: none;
}

.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-submit:active {
  background: #25a25a;
}

.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset {
  color: #555;
  background: #e6e6e6;
}

.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:hover,
.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:focus {
  background: #fbfbfb;
  outline: none;
}

.trumbowyg-modal-box .trumbowyg-modal-button.trumbowyg-modal-reset:active {
  background: #d5d5d5;
}

.trumbowyg-overlay {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.5);
  width: 100%;
  left: 0;
  display: none;
  z-index: 10;
}

/**
 * Fullscreen
 */
body.trumbowyg-body-fullscreen {
  overflow: hidden;
}

.trumbowyg-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  z-index: 99999;
}

.trumbowyg-fullscreen.trumbowyg-box,
.trumbowyg-fullscreen .trumbowyg-editor {
  border: none;
}

.trumbowyg-fullscreen .trumbowyg-editor,
.trumbowyg-fullscreen .trumbowyg-textarea {
  height: calc(100% - 37px) !important;
  overflow: auto;
}

.trumbowyg-fullscreen .trumbowyg-overlay {
  height: 100% !important;
}

.trumbowyg-fullscreen .trumbowyg-button-group .trumbowyg-fullscreen-button svg {
  color: #222;
  fill: transparent;
}

.trumbowyg-editor {
  /*
     * lset for resetCss option
     */
}

.trumbowyg-editor object,
.trumbowyg-editor embed,
.trumbowyg-editor video,
.trumbowyg-editor img {
  max-width: 100%;
}

.trumbowyg-editor video,
.trumbowyg-editor img {
  height: auto;
}

.trumbowyg-editor img {
  cursor: move;
}

.trumbowyg-editor.trumbowyg-reset-css {
  background: #fefefe !important;
  font-family: "Trebuchet MS", Helvetica, Verdana, sans-serif !important;
  font-size: 14px !important;
  line-height: 1.45em !important;
  white-space: normal !important;
  color: #333;
}

.trumbowyg-editor.trumbowyg-reset-css a {
  color: #15c !important;
  text-decoration: underline !important;
}

.trumbowyg-editor.trumbowyg-reset-css div,
.trumbowyg-editor.trumbowyg-reset-css p,
.trumbowyg-editor.trumbowyg-reset-css ul,
.trumbowyg-editor.trumbowyg-reset-css ol,
.trumbowyg-editor.trumbowyg-reset-css blockquote {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  background: none !important;
  margin: 0 !important;
  margin-bottom: 15px !important;
  line-height: 1.4em !important;
  font-family: "Trebuchet MS", Helvetica, Verdana, sans-serif !important;
  font-size: 14px !important;
  border: none;
}

.trumbowyg-editor.trumbowyg-reset-css iframe,
.trumbowyg-editor.trumbowyg-reset-css object,
.trumbowyg-editor.trumbowyg-reset-css hr {
  margin-bottom: 15px !important;
}

.trumbowyg-editor.trumbowyg-reset-css blockquote {
  margin-left: 32px !important;
  font-style: italic !important;
  color: #555;
}

.trumbowyg-editor.trumbowyg-reset-css ul,
.trumbowyg-editor.trumbowyg-reset-css ol {
  padding-left: 20px !important;
}

.trumbowyg-editor.trumbowyg-reset-css ul ul,
.trumbowyg-editor.trumbowyg-reset-css ol ol,
.trumbowyg-editor.trumbowyg-reset-css ul ol,
.trumbowyg-editor.trumbowyg-reset-css ol ul {
  border: none;
  margin: 2px !important;
  padding: 0 !important;
  padding-left: 24px !important;
}

.trumbowyg-editor.trumbowyg-reset-css hr {
  display: block;
  height: 1px;
  border: none;
  border-top: 1px solid #ccc;
}

.trumbowyg-editor.trumbowyg-reset-css h1,
.trumbowyg-editor.trumbowyg-reset-css h2,
.trumbowyg-editor.trumbowyg-reset-css h3,
.trumbowyg-editor.trumbowyg-reset-css h4 {
  color: #111;
  background: none;
  margin: 0 !important;
  padding: 0 !important;
  font-weight: bold;
}

.trumbowyg-editor.trumbowyg-reset-css h1 {
  font-size: 32px !important;
  line-height: 38px !important;
  margin-bottom: 20px !important;
}

.trumbowyg-editor.trumbowyg-reset-css h2 {
  font-size: 26px !important;
  line-height: 34px !important;
  margin-bottom: 15px !important;
}

.trumbowyg-editor.trumbowyg-reset-css h3 {
  font-size: 22px !important;
  line-height: 28px !important;
  margin-bottom: 7px !important;
}

.trumbowyg-editor.trumbowyg-reset-css h4 {
  font-size: 16px !important;
  line-height: 22px !important;
  margin-bottom: 7px !important;
}

/*
 * Dark theme
 */
.trumbowyg-dark .trumbowyg-textarea {
  background: #111;
  color: #ddd;
}

.trumbowyg-dark .trumbowyg-box {
  border: 1px solid #343434;
}

.trumbowyg-dark .trumbowyg-box.trumbowyg-fullscreen {
  background: #111;
}

.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor *,
.trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editorbefore {
  text-shadow: 0 0 7px #ccc;
}

@media screen and (min-width: 0 \\0) {
  .trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor *,
  .trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editorbefore {
    color: rgba(20, 20, 20, 0.6) !important;
  }
}

@supports (-ms-accelerator: true) {
  .trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editor *,
  .trumbowyg-dark .trumbowyg-box.trumbowyg-box-blur .trumbowyg-editorbefore {
    color: rgba(20, 20, 20, 0.6) !important;
  }
}

.trumbowyg-dark .trumbowyg-box svg {
  fill: #ecf0f1;
  color: #ecf0f1;
}

.trumbowyg-dark .trumbowyg-button-pane {
  background-color: #222;
  border-bottom-color: #343434;
}

.trumbowyg-dark .trumbowyg-button-paneafter {
  background: #343434;
}

.trumbowyg-dark
  .trumbowyg-button-pane
  .trumbowyg-button-group:not(:empty)before {
  background-color: #343434;
}

.trumbowyg-dark
  .trumbowyg-button-pane
  .trumbowyg-button-group:not(:empty)
  .trumbowyg-fullscreen-button
  svg {
  color: transparent;
}

.trumbowyg-dark
  .trumbowyg-button-pane.trumbowyg-disable
  .trumbowyg-button-groupbefore {
  background-color: #2a2a2a;
}

.trumbowyg-dark .trumbowyg-button-pane button:not(.trumbowyg-disable):hover,
.trumbowyg-dark .trumbowyg-button-pane button:not(.trumbowyg-disable):focus,
.trumbowyg-dark .trumbowyg-button-pane button.trumbowyg-active {
  background-color: #333;
}

.trumbowyg-dark .trumbowyg-button-pane .trumbowyg-open-dropdownafter {
  border-top-color: #fff;
}

.trumbowyg-dark
  .trumbowyg-fullscreen
  .trumbowyg-button-group
  .trumbowyg-fullscreen-button
  svg {
  color: #ecf0f1;
  fill: transparent;
}

.trumbowyg-dark .trumbowyg-dropdown {
  border-color: #222;
  background: #333;
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 2px 3px;
          box-shadow: rgba(0, 0, 0, 0.3) 0 2px 3px;
}

.trumbowyg-dark .trumbowyg-dropdown button {
  background: #333;
  color: #fff !important;
}

.trumbowyg-dark .trumbowyg-dropdown button:hover,
.trumbowyg-dark .trumbowyg-dropdown button:focus {
  background: #222;
}

.trumbowyg-dark .trumbowyg-modal-box {
  background-color: #222;
}

.trumbowyg-dark .trumbowyg-modal-box .trumbowyg-modal-title {
  border-bottom: 1px solid #555;
  color: #fff;
  background: #3c3c3c;
}

.trumbowyg-dark .trumbowyg-modal-box label {
  display: block;
  position: relative;
  margin: 15px 12px;
  height: 27px;
  line-height: 27px;
  overflow: hidden;
}

.trumbowyg-dark .trumbowyg-modal-box label .trumbowyg-input-infos span {
  color: #eee;
  background-color: #2f2f2f;
  border-color: #222;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  label
  .trumbowyg-input-infos
  span.trumbowyg-msg-error {
  color: #e74c3c;
}

.trumbowyg-dark .trumbowyg-modal-box label.trumbowyg-input-error input,
.trumbowyg-dark .trumbowyg-modal-box label.trumbowyg-input-error textarea {
  border-color: #e74c3c;
}

.trumbowyg-dark .trumbowyg-modal-box label input {
  border-color: #222;
  color: #eee;
  background: #333;
}

.trumbowyg-dark .trumbowyg-modal-box label input:hover,
.trumbowyg-dark .trumbowyg-modal-box label input:focus {
  border-color: #626262;
}

.trumbowyg-dark .trumbowyg-modal-box label input:focus {
  background-color: #2f2f2f;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-submit {
  background: #1b7943;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-submit:hover,
.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-submit:focus {
  background: #25a25a;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-submit:active {
  background: #176437;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-reset {
  background: #333;
  color: #ccc;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-reset:hover,
.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-reset:focus {
  background: #444;
}

.trumbowyg-dark
  .trumbowyg-modal-box
  .trumbowyg-modal-button.trumbowyg-modal-reset:active {
  background: #111;
}

.trumbowyg-dark .trumbowyg-overlay {
  background-color: rgba(15, 15, 15, 0.6);
}

/* BASICS */
.CodeMirror {
  /* Set height, width, borders, and global font properties here */
  font-family: monospace;
  height: 300px;
  color: black;
}

/* PADDING */
.CodeMirror-lines {
  padding: 4px 0;
  /* Vertical padding around content */
}

.CodeMirror pre {
  padding: 0 4px;
  /* Horizontal padding of content */
}

.CodeMirror-scrollbar-filler,
.CodeMirror-gutter-filler {
  background-color: white;
  /* The little square between H and V scrollbars */
}

/* GUTTER */
.CodeMirror-gutters {
  border-right: 1px solid #ddd;
  background-color: #f7f7f7;
  white-space: nowrap;
}

.CodeMirror-linenumber {
  padding: 0 3px 0 5px;
  min-width: 20px;
  text-align: right;
  color: #999;
  white-space: nowrap;
}

.CodeMirror-guttermarker {
  color: black;
}

.CodeMirror-guttermarker-subtle {
  color: #999;
}

/* CURSOR */
.CodeMirror-cursor {
  border-left: 1px solid black;
  border-right: none;
  width: 0;
}

/* Shown when moving in bi-directional text */
.CodeMirror div.CodeMirror-secondarycursor {
  border-left: 1px solid silver;
}

.cm-fat-cursor .CodeMirror-cursor {
  width: auto;
  border: 0 !important;
  background: #7e7;
}

.cm-fat-cursor div.CodeMirror-cursors {
  z-index: 1;
}

.cm-animate-fat-cursor {
  width: auto;
  border: 0;
  -webkit-animation: blink 1.06s steps(1) infinite;
  animation: blink 1.06s steps(1) infinite;
  background-color: #7e7;
}

@-webkit-keyframes blink {
  0% {
  }
  50% {
    background-color: transparent;
  }
  100% {
  }
}

@keyframes blink {
  0% {
  }
  50% {
    background-color: transparent;
  }
  100% {
  }
}

/* Can style cursor different in overwrite (non-insert) mode */
.cm-tab {
  display: inline-block;
  text-decoration: inherit;
}

.CodeMirror-rulers {
  position: absolute;
  left: 0;
  right: 0;
  top: -50px;
  bottom: -20px;
  overflow: hidden;
}

.CodeMirror-ruler {
  border-left: 1px solid #ccc;
  top: 0;
  bottom: 0;
  position: absolute;
}

/* DEFAULT THEME */
.cm-s-default .cm-header {
  color: blue;
}

.cm-s-default .cm-quote {
  color: #090;
}

.cm-negative {
  color: #d44;
}

.cm-positive {
  color: #292;
}

.cm-header,
.cm-strong {
  font-weight: bold;
}

.cm-em {
  font-style: italic;
}

.cm-link {
  text-decoration: underline;
}

.cm-strikethrough {
  text-decoration: line-through;
}

.cm-s-default .cm-keyword {
  color: #708;
}

.cm-s-default .cm-atom {
  color: #219;
}

.cm-s-default .cm-number {
  color: #164;
}

.cm-s-default .cm-def {
  color: #00f;
}

.cm-s-default .cm-variable-2 {
  color: #05a;
}

.cm-s-default .cm-variable-3 {
  color: #085;
}

.cm-s-default .cm-comment {
  color: #a50;
}

.cm-s-default .cm-string {
  color: #a11;
}

.cm-s-default .cm-string-2 {
  color: #f50;
}

.cm-s-default .cm-meta {
  color: #555;
}

.cm-s-default .cm-qualifier {
  color: #555;
}

.cm-s-default .cm-builtin {
  color: #30a;
}

.cm-s-default .cm-bracket {
  color: #997;
}

.cm-s-default .cm-tag {
  color: #170;
}

.cm-s-default .cm-attribute {
  color: #00c;
}

.cm-s-default .cm-hr {
  color: #999;
}

.cm-s-default .cm-link {
  color: #00c;
}

.cm-s-default .cm-error {
  color: #f00;
}

.cm-invalidchar {
  color: #f00;
}

.CodeMirror-composing {
  border-bottom: 2px solid;
}

/* Default styles for common addons */
div.CodeMirror span.CodeMirror-matchingbracket {
  color: #0f0;
}

div.CodeMirror span.CodeMirror-nonmatchingbracket {
  color: #f22;
}

.CodeMirror-matchingtag {
  background: rgba(255, 150, 0, 0.3);
}

.CodeMirror-activeline-background {
  background: #e8f2ff;
}

/* STOP */
/* The rest of this file contains styles related to the mechanics of
   the editor. You probably shouldn't touch them. */
.CodeMirror {
  position: relative;
  overflow: hidden;
  background: white;
}

.CodeMirror-scroll {
  overflow: scroll !important;
  /* Things will break if this is overridden */
  /* 30px is the magic margin used to hide the element's real scrollbars */
  /* See overflow: hidden in .CodeMirror */
  margin-bottom: -30px;
  margin-right: -30px;
  padding-bottom: 30px;
  height: 100%;
  outline: none;
  /* Prevent dragging from highlighting the element */
  position: relative;
}

.CodeMirror-sizer {
  position: relative;
  border-right: 30px solid transparent;
}

/* The fake, visible scrollbars. Used to force redraw during scrolling
   before actual scrolling happens, thus preventing shaking and
   flickering artifacts. */
.CodeMirror-vscrollbar,
.CodeMirror-hscrollbar,
.CodeMirror-scrollbar-filler,
.CodeMirror-gutter-filler {
  position: absolute;
  z-index: 6;
  display: none;
}

.CodeMirror-vscrollbar {
  right: 0;
  top: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}

.CodeMirror-hscrollbar {
  bottom: 0;
  left: 0;
  overflow-y: hidden;
  overflow-x: scroll;
}

.CodeMirror-scrollbar-filler {
  right: 0;
  bottom: 0;
}

.CodeMirror-gutter-filler {
  left: 0;
  bottom: 0;
}

.CodeMirror-gutters {
  position: absolute;
  left: 0;
  top: 0;
  min-height: 100%;
  z-index: 3;
}

.CodeMirror-gutter {
  white-space: normal;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  margin-bottom: -30px;
  /* Hack to make IE7 behave */
  *zoom: 1;
  *display: inline;
}

.CodeMirror-gutter-wrapper {
  position: absolute;
  z-index: 4;
  background: none !important;
  border: none !important;
}

.CodeMirror-gutter-background {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 4;
}

.CodeMirror-gutter-elt {
  position: absolute;
  cursor: default;
  z-index: 4;
}

.CodeMirror-gutter-wrapper {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
      user-select: none;
}

.CodeMirror-lines {
  cursor: text;
  min-height: 1px;
  /* prevents collapsing before first draw */
}

.CodeMirror pre {
  /* Reset some styles that the rest of the page might have set */
  border-radius: 0;
  border-width: 0;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  white-space: pre;
  word-wrap: normal;
  line-height: inherit;
  color: inherit;
  z-index: 2;
  position: relative;
  overflow: visible;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
}

.CodeMirror-wrap pre {
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: normal;
}

.CodeMirror-linebackground {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
}

.CodeMirror-linewidget {
  position: relative;
  z-index: 2;
  overflow: auto;
}

.CodeMirror-code {
  outline: none;
}

/* Force content-box sizing for the elements where we expect it */
.CodeMirror-scroll,
.CodeMirror-sizer,
.CodeMirror-gutter,
.CodeMirror-gutters,
.CodeMirror-linenumber {
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
}

.CodeMirror-measure {
  position: absolute;
  width: 100%;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.CodeMirror-cursor {
  position: absolute;
  pointer-events: none;
}

.CodeMirror-measure pre {
  position: static;
}

div.CodeMirror-cursors {
  visibility: hidden;
  position: relative;
  z-index: 3;
}

div.CodeMirror-dragcursors {
  visibility: visible;
}

.CodeMirror-focused div.CodeMirror-cursors {
  visibility: visible;
}

.CodeMirror-selected {
  background: #d9d9d9;
}

.CodeMirror-focused .CodeMirror-selected {
  background: #d7d4f0;
}

.CodeMirror-crosshair {
  cursor: crosshair;
}

.CodeMirror-lineselection,
.CodeMirror-line > spanselection,
.CodeMirror-line > span > spanselection {
  background: #d7d4f0;
}

.CodeMirror-line-moz-selection,
.CodeMirror-line > span-moz-selection,
.CodeMirror-line > span > span-moz-selection {
  background: #d7d4f0;
}

.cm-searching {
  background: #ffa;
  background: rgba(255, 255, 0, 0.4);
}

/* IE7 hack to prevent it from returning funny offsetTops on the spans */
.CodeMirror span {
  *vertical-align: text-bottom;
}

/* Used to force a border model for a node */
.cm-force-border {
  padding-right: 0.1px;
}

@media print {
  /* Hide the cursor when printing */
  .CodeMirror div.CodeMirror-cursors {
    visibility: hidden;
  }
}

/* See issue #2901 */
.cm-tab-wrap-hack:after {
  content: "";
}

/* Help users use markselection to safely style text background */
span.CodeMirror-selectedtext {
  background: none;
}

/*
 * Table styles
 */
table.dataTable {
  width: 100%;
  margin: 0 auto;
  clear: both;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 25px;
  /*
   * Header and footer styles
   */
  /*
   * Body styles
   */
}

table.dataTable thead th,
table.dataTable tfoot th {
  font-weight: bold;
}

table.dataTable thead th,
table.dataTable thead td {
  padding: 10px 18px;
  border-bottom: 1px solid #111111;
}

table.dataTable thead th:active,
table.dataTable thead td:active {
  outline: none;
}

table.dataTable tfoot th,
table.dataTable tfoot td {
  padding: 10px 18px 6px 18px;
  border-top: 1px solid #111111;
}

table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting {
  cursor: pointer;
  *cursor: hand;
}

table.dataTable thead .sorting {
  background: url("/public/imgs/common/datatables/sort_both.png") no-repeat
    center right;
}

table.dataTable thead .sorting_asc {
  background: url("/public/imgs/common/datatables/sort_asc.png") no-repeat
    center right;
}

table.dataTable thead .sorting_desc {
  background: url("/public/imgs/common/datatables/sort_desc.png") no-repeat
    center right;
}

table.dataTable thead .sorting_asc_disabled {
  background: url("/public/imgs/common/datatables/sort_asc_disabled.png")
    no-repeat center right;
}

table.dataTable thead .sorting_desc_disabled {
  background: url("/public/imgs/common/datatables/sort_desc_disabled.png")
    no-repeat center right;
}

table.dataTable tbody tr {
  background-color: white;
}

table.dataTable tbody tr.selected {
  background-color: #b0bed9;
}

table.dataTable tbody th,
table.dataTable tbody td {
  padding: 8px 10px;
}

table.dataTable.row-border tbody th,
table.dataTable.row-border tbody td,
table.dataTable.display tbody th,
table.dataTable.display tbody td {
  border-top: 1px solid #dddddd;
}

table.dataTable.row-border tbody tr:first-child th,
table.dataTable.row-border tbody tr:first-child td,
table.dataTable.display tbody tr:first-child th,
table.dataTable.display tbody tr:first-child td {
  border-top: none;
}

table.dataTable.cell-border tbody th,
table.dataTable.cell-border tbody td {
  border-top: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
}

table.dataTable.cell-border tbody tr th:first-child,
table.dataTable.cell-border tbody tr td:first-child {
  border-left: 1px solid #dddddd;
}

table.dataTable.cell-border tbody tr:first-child th,
table.dataTable.cell-border tbody tr:first-child td {
  border-top: none;
}

table.dataTable.spatiente tbody tr.odd,
table.dataTable.display tbody tr.odd {
  background-color: #f9f9f9;
}

table.dataTable.spatiente tbody tr.odd.selected,
table.dataTable.display tbody tr.odd.selected {
  background-color: #abb9d3;
}

table.dataTable.hover tbody tr:hover,
table.dataTable.hover tbody tr.odd:hover,
table.dataTable.hover tbody tr.even:hover,
table.dataTable.display tbody tr:hover,
table.dataTable.display tbody tr.odd:hover,
table.dataTable.display tbody tr.even:hover {
  background-color: whitesmoke;
}

table.dataTable.hover tbody tr:hover.selected,
table.dataTable.hover tbody tr.odd:hover.selected,
table.dataTable.hover tbody tr.even:hover.selected,
table.dataTable.display tbody tr:hover.selected,
table.dataTable.display tbody tr.odd:hover.selected,
table.dataTable.display tbody tr.even:hover.selected {
  background-color: #a9b7d1;
}

table.dataTable.order-column tbody tr > .sorting_1,
table.dataTable.order-column tbody tr > .sorting_2,
table.dataTable.order-column tbody tr > .sorting_3,
table.dataTable.display tbody tr > .sorting_1,
table.dataTable.display tbody tr > .sorting_2,
table.dataTable.display tbody tr > .sorting_3 {
  background-color: #f9f9f9;
}

table.dataTable.order-column tbody tr.selected > .sorting_1,
table.dataTable.order-column tbody tr.selected > .sorting_2,
table.dataTable.order-column tbody tr.selected > .sorting_3,
table.dataTable.display tbody tr.selected > .sorting_1,
table.dataTable.display tbody tr.selected > .sorting_2,
table.dataTable.display tbody tr.selected > .sorting_3 {
  background-color: #acbad4;
}

table.dataTable.display tbody tr.odd > .sorting_1,
table.dataTable.order-column.spatiente tbody tr.odd > .sorting_1 {
  background-color: #f1f1f1;
}

table.dataTable.display tbody tr.odd > .sorting_2,
table.dataTable.order-column.spatiente tbody tr.odd > .sorting_2 {
  background-color: #f3f3f3;
}

table.dataTable.display tbody tr.odd > .sorting_3,
table.dataTable.order-column.spatiente tbody tr.odd > .sorting_3 {
  background-color: whitesmoke;
}

table.dataTable.display tbody tr.odd.selected > .sorting_1,
table.dataTable.order-column.spatiente tbody tr.odd.selected > .sorting_1 {
  background-color: #a6b3cd;
}

table.dataTable.display tbody tr.odd.selected > .sorting_2,
table.dataTable.order-column.spatiente tbody tr.odd.selected > .sorting_2 {
  background-color: #a7b5ce;
}

table.dataTable.display tbody tr.odd.selected > .sorting_3,
table.dataTable.order-column.spatiente tbody tr.odd.selected > .sorting_3 {
  background-color: #a9b6d0;
}

table.dataTable.display tbody tr.even > .sorting_1,
table.dataTable.order-column.spatiente tbody tr.even > .sorting_1 {
  background-color: #f9f9f9;
}

table.dataTable.display tbody tr.even > .sorting_2,
table.dataTable.order-column.spatiente tbody tr.even > .sorting_2 {
  background-color: #fbfbfb;
}

table.dataTable.display tbody tr.even > .sorting_3,
table.dataTable.order-column.spatiente tbody tr.even > .sorting_3 {
  background-color: #fdfdfd;
}

table.dataTable.display tbody tr.even.selected > .sorting_1,
table.dataTable.order-column.spatiente tbody tr.even.selected > .sorting_1 {
  background-color: #acbad4;
}

table.dataTable.display tbody tr.even.selected > .sorting_2,
table.dataTable.order-column.spatiente tbody tr.even.selected > .sorting_2 {
  background-color: #adbbd6;
}

table.dataTable.display tbody tr.even.selected > .sorting_3,
table.dataTable.order-column.spatiente tbody tr.even.selected > .sorting_3 {
  background-color: #afbdd8;
}

table.dataTable.display tbody tr:hover > .sorting_1,
table.dataTable.display tbody tr.odd:hover > .sorting_1,
table.dataTable.display tbody tr.even:hover > .sorting_1,
table.dataTable.order-column.hover tbody tr:hover > .sorting_1,
table.dataTable.order-column.hover tbody tr.odd:hover > .sorting_1,
table.dataTable.order-column.hover tbody tr.even:hover > .sorting_1 {
  background-color: #eaeaea;
}

table.dataTable.display tbody tr:hover > .sorting_2,
table.dataTable.display tbody tr.odd:hover > .sorting_2,
table.dataTable.display tbody tr.even:hover > .sorting_2,
table.dataTable.order-column.hover tbody tr:hover > .sorting_2,
table.dataTable.order-column.hover tbody tr.odd:hover > .sorting_2,
table.dataTable.order-column.hover tbody tr.even:hover > .sorting_2 {
  background-color: #ebebeb;
}

table.dataTable.display tbody tr:hover > .sorting_3,
table.dataTable.display tbody tr.odd:hover > .sorting_3,
table.dataTable.display tbody tr.even:hover > .sorting_3,
table.dataTable.order-column.hover tbody tr:hover > .sorting_3,
table.dataTable.order-column.hover tbody tr.odd:hover > .sorting_3,
table.dataTable.order-column.hover tbody tr.even:hover > .sorting_3 {
  background-color: #eeeeee;
}

table.dataTable.display tbody tr:hover.selected > .sorting_1,
table.dataTable.display tbody tr.odd:hover.selected > .sorting_1,
table.dataTable.display tbody tr.even:hover.selected > .sorting_1,
table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_1,
table.dataTable.order-column.hover tbody tr.odd:hover.selected > .sorting_1,
table.dataTable.order-column.hover tbody tr.even:hover.selected > .sorting_1 {
  background-color: #a1aec7;
}

table.dataTable.display tbody tr:hover.selected > .sorting_2,
table.dataTable.display tbody tr.odd:hover.selected > .sorting_2,
table.dataTable.display tbody tr.even:hover.selected > .sorting_2,
table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_2,
table.dataTable.order-column.hover tbody tr.odd:hover.selected > .sorting_2,
table.dataTable.order-column.hover tbody tr.even:hover.selected > .sorting_2 {
  background-color: #a2afc8;
}

table.dataTable.display tbody tr:hover.selected > .sorting_3,
table.dataTable.display tbody tr.odd:hover.selected > .sorting_3,
table.dataTable.display tbody tr.even:hover.selected > .sorting_3,
table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_3,
table.dataTable.order-column.hover tbody tr.odd:hover.selected > .sorting_3,
table.dataTable.order-column.hover tbody tr.even:hover.selected > .sorting_3 {
  background-color: #a4b2cb;
}

table.dataTable.no-footer {
  border-bottom: 1px solid #111111;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

table.dataTable.compact thead th,
table.dataTable.compact thead td {
  padding: 5px 9px;
}

table.dataTable.compact tfoot th,
table.dataTable.compact tfoot td {
  padding: 5px 9px 3px 9px;
}

table.dataTable.compact tbody th,
table.dataTable.compact tbody td {
  padding: 4px 5px;
}

table.dataTable th.dt-left,
table.dataTable td.dt-left {
  text-align: left;
}

table.dataTable th.dt-center,
table.dataTable td.dt-center,
table.dataTable td.dataTables_empty {
  text-align: center;
}

table.dataTable th.dt-right,
table.dataTable td.dt-right {
  text-align: right;
}

table.dataTable th.dt-justify,
table.dataTable td.dt-justify {
  text-align: justify;
}

table.dataTable th.dt-nowrap,
table.dataTable td.dt-nowrap {
  white-space: nowrap;
}

table.dataTable thead th.dt-head-left,
table.dataTable thead td.dt-head-left,
table.dataTable tfoot th.dt-head-left,
table.dataTable tfoot td.dt-head-left {
  text-align: left;
}

table.dataTable thead th.dt-head-center,
table.dataTable thead td.dt-head-center,
table.dataTable tfoot th.dt-head-center,
table.dataTable tfoot td.dt-head-center {
  text-align: center;
}

table.dataTable thead th.dt-head-right,
table.dataTable thead td.dt-head-right,
table.dataTable tfoot th.dt-head-right,
table.dataTable tfoot td.dt-head-right {
  text-align: right;
}

table.dataTable thead th.dt-head-justify,
table.dataTable thead td.dt-head-justify,
table.dataTable tfoot th.dt-head-justify,
table.dataTable tfoot td.dt-head-justify {
  text-align: justify;
}

table.dataTable thead th.dt-head-nowrap,
table.dataTable thead td.dt-head-nowrap,
table.dataTable tfoot th.dt-head-nowrap,
table.dataTable tfoot td.dt-head-nowrap {
  white-space: nowrap;
}

table.dataTable tbody th.dt-body-left,
table.dataTable tbody td.dt-body-left {
  text-align: left;
}

table.dataTable tbody th.dt-body-center,
table.dataTable tbody td.dt-body-center {
  text-align: center;
}

table.dataTable tbody th.dt-body-right,
table.dataTable tbody td.dt-body-right {
  text-align: right;
}

table.dataTable tbody th.dt-body-justify,
table.dataTable tbody td.dt-body-justify {
  text-align: justify;
}

table.dataTable tbody th.dt-body-nowrap,
table.dataTable tbody td.dt-body-nowrap {
  white-space: nowrap;
}

table.dataTable,
table.dataTable th,
table.dataTable td {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

/*
 * Control feature layout
 */
.dataTables_wrapper {
  position: relative;
  clear: both;
  *zoom: 1;
  zoom: 1;
}

.dataTables_wrapper .dataTables_length {
  float: left;
}

.dataTables_wrapper .dataTables_length select {
  width: auto;
  display: inline-block;
}

.dataTables_wrapper .dataTables_filter {
  float: right;
  text-align: right;
}

.dataTables_wrapper .dataTables_filter input {
  width: auto;
  margin-left: 0.5em;
  display: inline-block;
}

.dataTables_wrapper .dataTables_info {
  clear: both;
  float: left;
  padding-top: 5px;
}

.dataTables_wrapper .dataTables_paginate {
  float: right;
  text-align: right;
  padding-top: 0.25em;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  display: inline-block;
  min-width: 1.5em;
  padding: 0.25em 1em 0.5em 1em;
  margin-left: 2px;
  text-align: center;
  cursor: pointer;
  *cursor: hand;
  border-color: transparent;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.current,
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
  background-color: white;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.disabled,
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active {
  cursor: default;
  color: #666 !important;
  border: 1px solid transparent;
  background: transparent;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.dataTables_wrapper .dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 40px;
  margin-left: -50%;
  margin-top: -25px;
  padding-top: 20px;
  text-align: center;
  font-size: 1.2em;
  background-color: white;
  /* Opera 11.10+ */
  background: -webkit-gradient(
    linear,
    right top, left top,
    from(rgba(255, 255, 255, 0)),
    color-stop(25%, rgba(255, 255, 255, 0.9)),
    color-stop(75%, rgba(255, 255, 255, 0.9)),
    to(rgba(255, 255, 255, 0))
  );
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.9) 25%,
    rgba(255, 255, 255, 0.9) 75%,
    rgba(255, 255, 255, 0) 100%
  );
  /* W3C */
}

.dataTables_wrapper .dataTables_length,
.dataTables_wrapper .dataTables_filter,
.dataTables_wrapper .dataTables_info,
.dataTables_wrapper .dataTables_processing,
.dataTables_wrapper .dataTables_paginate {
  color: #333333;
}

.dataTables_wrapper .dataTables_scroll {
  clear: both;
}

.dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody {
  *margin-top: -1px;
  -webkit-overflow-scrolling: touch;
}

.dataTables_wrapper
  .dataTables_scroll
  div.dataTables_scrollBody
  th
  > div.dataTables_sizing,
.dataTables_wrapper
  .dataTables_scroll
  div.dataTables_scrollBody
  td
  > div.dataTables_sizing {
  height: 0;
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
}

.dataTables_wrapper.no-footer .dataTables_scrollBody {
  border-bottom: 1px solid #111111;
}

.dataTables_wrapper.no-footer div.dataTables_scrollHead table,
.dataTables_wrapper.no-footer div.dataTables_scrollBody table {
  border-bottom: none;
}

.dataTables_wrapper:after {
  visibility: hidden;
  display: block;
  content: "";
  clear: both;
  height: 0;
}

@media screen and (max-width: 767px) {
  .dataTables_wrapper .dataTables_info,
  .dataTables_wrapper .dataTables_paginate {
    float: none;
    text-align: center;
  }
  .dataTables_wrapper .dataTables_paginate {
    margin-top: 0.5em;
  }
}

@media screen and (max-width: 640px) {
  .dataTables_wrapper .dataTables_length,
  .dataTables_wrapper .dataTables_filter {
    float: none;
    text-align: center;
  }
  .dataTables_wrapper .dataTables_filter {
    margin-top: 0.5em;
  }
}

table.dataTable.dtr-inline.collapsed tbody td:first-child,
table.dataTable.dtr-inline.collapsed tbody th:first-child {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

table.dataTable.dtr-inline.collapsed tbody td:first-child:before,
table.dataTable.dtr-inline.collapsed tbody th:first-child:before {
  top: 8px;
  left: 4px;
  height: 16px;
  width: 16px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 16px;
  text-align: center;
  line-height: 14px;
  -webkit-box-shadow: 0 0 3px #444;
          box-shadow: 0 0 3px #444;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  content: "+";
  background-color: #31b131;
}

table.dataTable.dtr-inline.collapsed tbody tr.parent td:first-child:before,
table.dataTable.dtr-inline.collapsed tbody tr.parent th:first-child:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable.dtr-inline.collapsed tbody tr.child td:before {
  display: none;
}

table.dataTable.dtr-column tbody td.control,
table.dataTable.dtr-column tbody th.control {
  position: relative;
  cursor: pointer;
}

table.dataTable.dtr-column tbody td.control:before,
table.dataTable.dtr-column tbody th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 16px;
  text-align: center;
  line-height: 14px;
  -webkit-box-shadow: 0 0 3px #444;
          box-shadow: 0 0 3px #444;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  content: "+";
  background-color: #31b131;
}

table.dataTable.dtr-column tbody tr.parent td.control:before,
table.dataTable.dtr-column tbody tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable tr.child {
  padding: 0.5em 1em;
}

table.dataTable tr.child:hover {
  background: transparent !important;
}

table.dataTable tr.child ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

table.dataTable tr.child ul li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}

table.dataTable tr.child ul li:first-child {
  padding-top: 0;
}

table.dataTable tr.child ul li:last-child {
  border-bottom: none;
}

table.dataTable tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

/* Ion.RangeSlider
// css version 1.9.2
// © 2013-2014 Denis Ineshin | IonDen.com
// ===================================================================================================================*/
/* =====================================================================================================================
// RangeSlider */
/*@noflip*/
.irs {
  position: relative;
  display: block;
}

/*@noflip*/
.irs-line {
  position: relative;
  display: block;
  overflow: hidden;
}

/*@noflip*/
.irs-line-left,
.irs-line-mid,
.irs-line-right {
  position: absolute;
  display: block;
  top: 0;
}

/*@noflip*/
.irs-line-left {
  left: 0;
  width: 10%;
}

/*@noflip*/
.irs-line-mid {
  left: 9%;
  width: 82%;
}

/*@noflip*/
.irs-line-right {
  right: 0;
  width: 10%;
}

/*@noflip*/
.irs-diapason {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
}

/*@noflip*/
.irs-slider {
  position: absolute;
  display: block;
  cursor: default;
  z-index: 1;
}

/*@noflip*/
.irs-slider.single {
  left: 10px;
}

/*@noflip*/
.irs-slider.single:before {
  position: absolute;
  display: block;
  content: "";
  top: -30%;
  left: -30%;
  width: 160%;
  height: 160%;
  background: transparent;
}

/*@noflip*/
.irs-slider.from {
  left: 100px;
}

/*@noflip*/
.irs-slider.from:before {
  position: absolute;
  display: block;
  content: "";
  top: -30%;
  left: -30%;
  width: 130%;
  height: 160%;
  background: transparent;
}

/*@noflip*/
.irs-slider.to {
  left: 300px;
}

/*@noflip*/
.irs-slider.to:before {
  position: absolute;
  display: block;
  content: "";
  top: -30%;
  left: 0;
  width: 130%;
  height: 160%;
  background: transparent;
}

/*@noflip*/
.irs-slider.last {
  z-index: 2;
}

/*@noflip*/
.irs-min {
  position: absolute;
  display: block;
  left: 0;
  cursor: default;
}

/*@noflip*/
.irs-max {
  position: absolute;
  display: block;
  right: 0;
  cursor: default;
}

/*@noflip*/
.irs-from,
.irs-to,
.irs-single {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  cursor: default;
  white-space: nowrap;
}

/*@noflip*/
.irs-grid {
  position: absolute;
  display: none;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
}

/*@noflip*/
.irs-with-grid .irs-grid {
  display: block;
}

/*@noflip*/
.irs-grid-pol {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 8px;
  background: #000;
}

/*@noflip*/
.irs-grid-pol.small {
  height: 4px;
}

/*@noflip*/
.irs-grid-text {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  white-space: nowrap;
  text-align: center;
  font-size: 9px;
  line-height: 9px;
  color: #000;
}

/*@noflip*/
.irs-disable-mask {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: default;
  background: transparent;
  z-index: 2;
}

/*@noflip*/
.irs-disabled {
  opacity: 0.4;
}

/*!
 * FullCalendar v2.1.0-beta2 Stylesheet
 * Docs & License: http://arshaw.com/fullcalendar/
 * (c) 2013 Adam Shaw
 */
.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc {
  /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed hr,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #ddd;
}

.fc-unthemed .fc-popover {
  background-color: #fff;
}

.fc-unthemed hr,
.fc-unthemed .fc-popover .fc-header {
  background: #eee;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  color: #666;
}

.fc-unthemed .fc-today {
  background: #fcf8e3;
}

.fc-highlight {
  /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
  filter: alpha(opacity=30);
  /* for IE */
}

/* Icons (inline elements with styled text that mock arrow icons)
--------------------------------------------------------------------------------------------------*/
.fc-icon {
  display: inline-block;
  font-size: 2em;
  line-height: 0.5em;
  height: 0.5em;
  /* will make the total height 1em */
  font-family: "Courier New", Courier, monospace;
}

.fc-icon-left-single-arrow:after {
  content: "\\02039";
  font-weight: bold;
}

.fc-icon-right-single-arrow:after {
  content: "\\0203A";
  font-weight: bold;
}

.fc-icon-left-double-arrow:after {
  content: "\\000AB";
}

.fc-icon-right-double-arrow:after {
  content: "\\000BB";
}

.fc-icon-x:after {
  content: "\\000D7";
}

/* Buttons (styled <button> tags, normalized to work cross-browser)
--------------------------------------------------------------------------------------------------*/
.fc button {
  /* force height to include the border and padding */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* dimensions */
  margin: 0;
  height: 2.1em;
  padding: 0 0.6em;
  /* text & cursor */
  font-size: 1em;
  /* normalize */
  white-space: nowrap;
  cursor: pointer;
}

/* Firefox has an annoying inner border */
.fc button-moz-focus-inner {
  margin: 0;
  padding: 0;
}

.fc-state-default {
  /* non-theme */
  border: 1px solid;
}

.fc-state-default.fc-corner-left {
  /* non-theme */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fc-state-default.fc-corner-right {
  /* non-theme */
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* icons in buttons */
.fc button .fc-icon {
  /* non-theme */
  position: relative;
  top: 0.05em;
  /* seems to be a good adjustment across browsers */
  margin: 0 0.1em;
}

/*
  button states
  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)
*/
.fc-state-default {
  background-color: #f5f5f5;
  border-color: #e6e6e6 #e6e6e6 #bfbfbf;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #333;
}

.fc-state-hover,
.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  color: #333333;
  background-color: #e6e6e6;
}

.fc-state-hover {
  color: #333333;
  text-decoration: none;
  background-position: 0 -15px;
  -webkit-transition: background-position 0.1s linear;
  transition: background-position 0.1s linear;
}

.fc-state-down,
.fc-state-active {
  background-color: #cccccc;
}

.fc-state-disabled {
  cursor: default;
  opacity: 0.65;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  display: inline-block;
}

/*
every button that is not first in a button group should scootch over one pixel and cover the
previous button's border...
*/
.fc .fc-button-group > * {
  /* extra precedence b/c buttons have margin set to zero */
  float: left;
  margin: 0 0 0 -1px;
}

.fc .fc-button-group > :first-child {
  /* same */
  margin-left: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
}

.fc-popover .fc-header {
  padding: 2px 4px;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
}

.fc-ltr .fc-popover .fc-header .fc-title,
.fc-rtl .fc-popover .fc-header .fc-close {
  float: left;
}

.fc-rtl .fc-popover .fc-header .fc-title,
.fc-ltr .fc-popover .fc-header .fc-close {
  float: right;
}

/* unthemed */
.fc-unthemed .fc-popover {
  border-width: 1px;
  border-style: solid;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  font-size: 25px;
  margin-top: 4px;
}

/* jqui themed */
.fc-popover > .ui-widget-header + .ui-widget-content {
  border-top: 0;
  /* where they meet, let the header have the border */
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc hr {
  height: 0;
  margin: 0;
  padding: 0 0 2px;
  /* height is unreliable across browsers, so use padding */
  border-style: solid;
  border-width: 1px 0;
}

.fc-clear {
  clear: both;
}

.fc-bg,
.fc-highlight-skeleton,
.fc-helper-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0;
  /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%;
  /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
  /* normalize cross-browser */
}

.fc th {
  text-align: center;
}

.fc th,
.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double;
  /* overcome neighboring borders */
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row {
  /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent;
  /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells */
.fc-row .fc-highlight-skeleton {
  z-index: 2;
  bottom: 0;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton table {
  height: 100%;
  /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td {
  border-color: transparent;
}

/*
row content (which contains day/week numbers and events) as well as "helper" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 3;
  padding-bottom: 1px;
  /* matches the space between events */
}

.fc-row .fc-helper-skeleton {
  z-index: 4;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-helper-skeleton td {
  /* see-through to the background below */
  background: none;
  /* in case <td>s are globally styled */
  border-color: transparent;
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-helper-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller {
  /* this class goes on elements for guaranteed vertical scrollbars */
  overflow-y: scroll;
  overflow-x: hidden;
}

.fc-scroller > * {
  /* we expect an immediate inner element */
  position: relative;
  /* re-scope all positions */
  width: 100%;
  /* hack to force re-sizing this inner element when scrollbars appear/disappear */
  overflow: hidden;
  /* don't let negative margins or absolute positioning create further scroll */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  /* always an <a> tag */
  position: relative;
  /* for resize handle and other inner positioning */
  display: block;
  /* make the <a> tag block */
  border: 1px solid #3a87ad;
  /* default BORDER color */
  background-color: #3a87ad;
  /* default BACKGROUND color */
  color: #fff;
  /* default TEXT color */
  font-size: 0.85em;
  line-height: 1.3;
  border-radius: 3px;
  text-decoration: none;
  /* if it has an href */
}
.fc-event:hover,
.fc-event:focus {
  color: white;
  padding: 0 !important;
  border-color: #3a87ad;
}

.ui-widget .fc-event {
  /* undo jqui's styles on <a> tags */
  color: #fff;
  font-weight: normal;
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer;
  /* give events with links and draggable events a hand mouse pointer */
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 1px 1px 0;
  /* spacing between events and edges */
}

/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-day-grid-event.fc-not-start,
.fc-rtl .fc-day-grid-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px;
  /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-day-grid-event.fc-not-end,
.fc-rtl .fc-day-grid-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px;
  /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-day-grid-event > .fc-content {
  /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

/* resize handle (outside of fc-content, so can go outside of bounds) */
.fc-day-grid-event .fc-resizer {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 7px;
}

.fc-ltr .fc-day-grid-event .fc-resizer {
  right: -3px;
  cursor: e-resize;
}

.fc-rtl .fc-day-grid-event .fc-resizer {
  left: -3px;
  cursor: w-resize;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  text-align: center;
  margin-bottom: 1em;
}

.fc-toolbar .fc-left {
  float: left;
}

.fc-toolbar .fc-right {
  float: right;
}

.fc-toolbar .fc-center {
  display: inline-block;
}

/* the things within each left/right/center section */
.fc .fc-toolbar > * > * {
  /* extra precedence to override button border margins */
  float: left;
  margin-left: 0.75em;
}

/* the first thing within each left/center/right section */
.fc .fc-toolbar > * > :first-child {
  /* extra precedence to override button border margins */
  margin-left: 0;
}

/* title text */
.fc-toolbar h2 {
  margin: 0;
}

/* button layering (for border precedence) */
.fc-toolbar button {
  position: relative;
}

.fc-toolbar .fc-state-hover,
.fc-toolbar .ui-state-hover {
  z-index: 2;
}

.fc-toolbar .fc-state-down {
  z-index: 3;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active {
  z-index: 4;
}

.fc-toolbar button:focus {
  z-index: 5;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
.fc-view-container,
.fc-view > table {
  /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

/* BasicView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-basicWeek-view .fc-content-skeleton,
.fc-basicDay-view .fc-content-skeleton {
  /* in basicWeek and basicDay views, where we are sure there are no day numbers, ensure
     a space at the bottom of the cell to allow for day selecting/clicking */
  padding-bottom: 1em;
}

.fc-basic-view tbody .fc-row {
  min-height: 4em;
  /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-basic-view .fc-week-number,
.fc-basic-view .fc-day-number {
  padding: 0 2px;
}

.fc-basic-view td.fc-week-number span,
.fc-basic-view td.fc-day-number {
  padding-top: 2px;
  padding-bottom: 2px;
}

.fc-basic-view .fc-week-number {
  text-align: center;
}

.fc-basic-view .fc-week-number span {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

.fc-ltr .fc-basic-view .fc-day-number {
  text-align: right;
}

.fc-rtl .fc-basic-view .fc-day-number {
  text-align: left;
}

/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 2px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited {
  /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1;
  /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* AgendaView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-agenda-view .fc-day-grid .fc-row {
  min-height: 3em;
  /* all-day section will never get shorter than this */
}

.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-bottom: 1em;
  /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis {
  /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

.ui-widget td.fc-axis {
  font-weight: normal;
  /* overcome jqui theme making it bold */
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid {
  position: relative;
  /* so slats/bg/content/etc positions get scoped within here */
  min-height: 100%;
  /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table {
  /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr {
  /* the <hr> AgendaView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-highlight-skeleton {
  z-index: 3;
}

.fc-time-grid .fc-content-skeleton {
  position: absolute;
  z-index: 4;
  top: 0;
  left: 0;
  right: 0;
}

.fc-time-grid > .fc-helper-skeleton {
  z-index: 5;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-slats td {
  height: 1.5em;
  border-bottom: 0;
  /* each cell is responsible for its top border */
}

.fc-slats .fc-minor td {
  border-top-style: dotted;
}

.fc-slats .ui-widget-content {
  /* for jqui theme */
  background: none;
  /* see through to fc-bg */
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container {
  /* a div within a cell within the fc-highlight-skeleton */
  position: relative;
  /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-event-container {
  /* a div within a cell within the fc-content-skeleton */
  position: relative;
}

.fc-ltr .fc-time-grid .fc-event-container {
  /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container {
  /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event {
  position: absolute;
  z-index: 1;
  /* scope inner z-index's */
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event.fc-not-start {
  /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-time-grid-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-time-grid-event {
  overflow: hidden;
  /* don't let the bg flow over rounded corners */
}

.fc-time-grid-event > .fc-content {
  /* contains the time and title, but no bg and resizer */
  position: relative;
  z-index: 2;
  /* above the bg */
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

.fc-time-grid-event .fc-bg {
  z-index: 1;
  background: #fff;
  opacity: 0.25;
  filter: alpha(opacity=25);
  /* for IE */
}

/* resizer */
.fc-time-grid-event .fc-resizer {
  position: absolute;
  z-index: 3;
  /* above content */
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event .fc-resizer:after {
  content: "=";
}

/*
    Common
*/
.wizard,
.tabcontrol {
  display: block;
  width: 100%;
  overflow: hidden;
  padding: 25px;
}

.wizard a,
.tabcontrol a {
  outline: 0;
}

.wizard ul,
.tabcontrol ul {
  list-style: none !important;
  padding: 0;
  margin: 0;
}

.wizard ul > li,
.tabcontrol ul > li {
  display: block;
  padding: 0;
}

/* Accessibility */
.wizard > .steps .current-info,
.tabcontrol > .steps .current-info {
  position: absolute;
  left: -999em;
}

.wizard > .content > .title,
.tabcontrol > .content > .title {
  position: absolute;
  left: -999em;
}

/*
    Wizard
*/
.wizard > .steps {
  position: relative;
  display: block;
  width: 100%;
}

.wizard.vertical > .steps {
  display: inline;
  float: left;
  width: 30%;
}

.wizard > .steps .number {
  font-size: 1.429em;
}

.wizard > .steps > ul > li {
  width: 25%;
}

.wizard > .steps > ul > li,
.wizard > .actions > ul > li {
  float: left;
  margin-bottom: 25px;
}

.wizard.vertical > .steps > ul > li {
  float: none;
  width: 100%;
}

.wizard > .steps a,
.wizard > .steps a:hover,
.wizard > .steps a:active {
  display: block;
  width: auto;
  margin-right: 10px;
  padding: 1em 1em;
  text-decoration: none;
  border-radius: 5px;
}

.wizard > .steps a {
  border: none;
}

.wizard > .actions a {
  border: none;
}

.wizard > .steps .disabled a,
.wizard > .steps .disabled a:hover,
.wizard > .steps .disabled a:active {
  background: #eee;
  color: #aaa;
  cursor: default;
  border: none;
}

.wizard > .steps .current a,
.wizard > .steps .current a:hover,
.wizard > .steps .current a:active {
  background: #2184be;
  color: #fff;
  cursor: default;
}

.wizard > .steps .done a,
.wizard > .steps .done a:hover,
.wizard > .steps .done a:active {
  background: #9dc8e2;
  color: #fff;
}

.wizard > .steps .error a,
.wizard > .steps .error a:hover,
.wizard > .steps .error a:active {
  background: #ff3111;
  color: #fff;
}

.wizard > .content {
  display: block;
  overflow: hidden;
  position: relative;
  width: auto;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  background: #f8f8f8;
}

.wizard.vertical > .content {
  display: inline;
  float: left;
  margin: 0 2.5% 0.5em 2.5%;
  width: 65%;
}

.wizard > .content > .body {
  position: relative;
  padding: 25px;
}

.wizard > .content > .body ul {
  list-style: disc !important;
}

.wizard > .content > .body ul > li {
  display: list-item;
}

.wizard > .content > .body > iframe {
  border: 0 none;
  width: 100%;
  height: 100%;
}

.wizard > .content > .body input.error,
.wizard > .content > .body textarea.error {
  background: #fbe3e4;
  border-color: #fbc2c4;
  color: #8a1f11;
}

.wizard > .content > .body label.error {
  color: #8a1f11;
}

input[type="checkbox"] ~ label.error,
input[type="radio"] ~ label.error {
  padding: 0;
  display: block;
}

.wizard > .actions {
  position: relative;
  display: block;
  text-align: right;
  width: 100%;
  margin-top: 25px;
}

.wizard.vertical > .actions {
  display: inline;
  float: right;
  margin: 0 2.5%;
  width: 95%;
}

.wizard > .actions > ul {
  display: inline-block;
  text-align: right;
}

.wizard > .actions > ul > li {
  margin: 0 0.5em;
}

.wizard.vertical > .actions > ul > li {
  margin: 0 0 0 1em;
}

.wizard > .actions a,
.wizard > .actions a:hover,
.wizard > .actions a:active {
  background: #2184be;
  color: #fff;
  display: block;
  padding: 0.5em 1em;
  text-decoration: none;
  border-radius: 5px;
}

.wizard > .actions .disabled a,
.wizard > .actions .disabled a:hover,
.wizard > .actions .disabled a:active {
  background: #eee;
  color: #aaa;
}

/*
    Tabcontrol
*/
.tabcontrol > .steps {
  position: relative;
  display: block;
  width: 100%;
}

.tabcontrol > .steps > ul {
  position: relative;
  margin: 6px 0 0 0;
  top: 1px;
  z-index: 1;
}

.tabcontrol > .steps > ul > li {
  float: left;
  margin: 5px 2px 0 0;
  padding: 1px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.tabcontrol > .steps > ul > li:hover {
  background: #edecec;
  border: 1px solid #bbb;
  padding: 0;
}

.tabcontrol > .steps > ul > li.current {
  background: #fff;
  border: 1px solid #bbb;
  border-bottom: 0 none;
  padding: 0 0 1px 0;
  margin-top: 0;
}

.tabcontrol > .steps > ul > li > a {
  color: #5f5f5f;
  display: inline-block;
  border: 0 none;
  margin: 0;
  padding: 10px 30px;
  text-decoration: none;
}

.tabcontrol > .steps > ul > li > a:hover {
  text-decoration: none;
}

.tabcontrol > .steps > ul > li.current > a {
  padding: 15px 30px 10px 30px;
}

.tabcontrol > .content {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 35em;
  overflow: hidden;
  border-top: 1px solid #bbb;
  padding-top: 20px;
}

.tabcontrol > .content > .body {
  float: left;
  position: absolute;
  width: 95%;
  height: 95%;
  padding: 2.5%;
}

.tabcontrol > .content > .body ul {
  list-style: disc !important;
}

.tabcontrol > .content > .body ul > li {
  display: list-item;
}

.wizard > .actions a[href="#finish"],
.wizard > .actions a[href="#finish"]:hover,
.wizard > .actions a[href="#finish"]:active {
  background: #2eb398 !important;
}

/*
 * blueimp Gallery Indicator CSS 1.1.0
 * https://github.com/blueimp/Gallery
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */
.blueimp-gallery > .indicator {
  position: absolute;
  top: auto;
  right: 15px;
  bottom: 15px;
  left: 15px;
  margin: 0 40px;
  padding: 0;
  list-style: none;
  text-align: center;
  line-height: 10px;
  display: none;
}

.blueimp-gallery > .indicator > li {
  display: inline-block;
  width: 9px;
  height: 9px;
  margin: 6px 3px 0 3px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  border: 1px solid transparent;
  background: #ccc;
  background: rgba(255, 255, 255, 0.25) center no-repeat;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 2px #000;
          box-shadow: 0 0 2px #000;
  opacity: 0.5;
  cursor: pointer;
}

.blueimp-gallery > .indicator > li:hover,
.blueimp-gallery > .indicator > .active {
  background-color: #fff;
  border-color: #fff;
  opacity: 1;
}

.blueimp-gallery-controls > .indicator {
  display: block;
  /* Fix z-index issues (controls behind slide element) on Android: */
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.blueimp-gallery-single > .indicator {
  display: none;
}

.blueimp-gallery > .indicator {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* IE7 fixes */
* + html .blueimp-gallery > .indicator > li {
  display: inline;
}

/*
 * blueimp Gallery Video Factory CSS 1.3.0
 * https://github.com/blueimp/Gallery
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */
.blueimp-gallery > .slides > .slide > .video-content > img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  /* Prevent artifacts in Mozilla Firefox: */
  -moz-backface-visibility: hidden;
}

.blueimp-gallery > .slides > .slide > .video-content > video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.blueimp-gallery > .slides > .slide > .video-content > iframe {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.blueimp-gallery > .slides > .slide > .video-playing > iframe {
  top: 0;
}

.blueimp-gallery > .slides > .slide > .video-content > a {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  margin: -64px auto 0;
  width: 128px;
  height: 128px;
  background: url("/public/imgs/common/blueimp-gallery/video-play.png") center
    no-repeat;
  opacity: 0.8;
  cursor: pointer;
}

.blueimp-gallery > .slides > .slide > .video-content > a:hover {
  opacity: 1;
}

.blueimp-gallery > .slides > .slide > .video-playing > a,
.blueimp-gallery > .slides > .slide > .video-playing > img {
  display: none;
}

.blueimp-gallery > .slides > .slide > .video-content > video {
  display: none;
}

.blueimp-gallery > .slides > .slide > .video-playing > video {
  display: block;
}

.blueimp-gallery > .slides > .slide > .video-loading > a {
  background: url("/public/imgs/common/blueimp-gallery/loading.gif") center
    no-repeat;
  background-size: 64px 64px;
}

/* Replace PNGs with SVGs for capable browsers (excluding IE<9) */
body:last-child
  .blueimp-gallery
  > .slides
  > .slide
  > .video-content:not(.video-loading)
  > a {
  background-image: url("/public/imgs/common/blueimp-gallery/video-play.svg");
}

/* IE7 fixes */
* + html .blueimp-gallery > .slides > .slide > .video-content {
  height: 100%;
}

* + html .blueimp-gallery > .slides > .slide > .video-content > a {
  left: 50%;
  margin-left: -64px;
}

/*
 * blueimp Gallery CSS 2.11.1
 * https://github.com/blueimp/Gallery
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */
.blueimp-gallery,
.blueimp-gallery > .slides > .slide > .slide-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* Prevent artifacts in Mozilla Firefox: */
  -moz-backface-visibility: hidden;
}

.blueimp-gallery > .slides > .slide > .slide-content {
  margin: auto;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  opacity: 1;
}

.blueimp-gallery {
  position: fixed;
  z-index: 9999999999;
  overflow: hidden;
  background: #000;
  background: rgba(0, 0, 0, 0.9);
  opacity: 0;
  display: none;
  direction: ltr;
  -ms-touch-action: none;
  touch-action: none;
}

.blueimp-gallery-carousel {
  position: relative;
  z-index: auto;
  margin: 1em auto;
  /* Set the carousel width/height ratio to 16/9: */
  padding-bottom: 56.25%;
  -webkit-box-shadow: 0 0 10px #000;
          box-shadow: 0 0 10px #000;
  -ms-touch-action: pan-y;
  touch-action: pan-y;
}

.blueimp-gallery-display {
  display: block;
  opacity: 1;
}

.blueimp-gallery > .slides {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.blueimp-gallery-carousel > .slides {
  position: absolute;
}

.blueimp-gallery > .slides > .slide {
  position: relative;
  float: left;
  height: 100%;
  text-align: center;
  -webkit-transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
}

.blueimp-gallery,
.blueimp-gallery > .slides > .slide > .slide-content {
  -webkit-transition: opacity 0.5s linear;
  transition: opacity 0.5s linear;
}

.blueimp-gallery > .slides > .slide-loading {
  background: url("/public/imgs/common/blueimp-gallery/loading.gif") center
    no-repeat;
  background-size: 64px 64px;
}

.blueimp-gallery > .slides > .slide-loading > .slide-content {
  opacity: 0;
}

.blueimp-gallery > .slides > .slide-error {
  background: url("/public/imgs/common/blueimp-gallery/error.png") center
    no-repeat;
}

.blueimp-gallery > .slides > .slide-error > .slide-content {
  display: none;
}

.blueimp-gallery > .prev,
.blueimp-gallery > .next {
  position: absolute;
  top: 50%;
  left: 15px;
  width: 40px;
  height: 40px;
  margin-top: -23px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 60px;
  font-weight: 100;
  line-height: 30px;
  color: #fff;
  text-decoration: none;
  text-shadow: 0 0 2px #000;
  text-align: center;
  background: #222;
  background: rgba(0, 0, 0, 0.5);
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  border: 3px solid #fff;
  border-radius: 23px;
  opacity: 0.5;
  cursor: pointer;
  display: none;
}

.blueimp-gallery > .next {
  left: auto;
  right: 15px;
}

.blueimp-gallery > .close,
.blueimp-gallery > .title {
  position: absolute;
  top: 15px;
  left: 15px;
  margin: 0 40px 0 0;
  font-size: 20px;
  line-height: 30px;
  color: #fff;
  text-shadow: 0 0 2px #000;
  opacity: 0.8;
  display: none;
}

.blueimp-gallery > .close {
  padding: 15px !important;
  right: 15px;
  left: auto;
  margin: -15px;
  font-size: 30px;
  text-decoration: none;
  cursor: pointer;
  border: none;
}

.blueimp-gallery > .play-pause {
  border: none;
  position: absolute;
  right: 15px;
  bottom: 15px;
  width: 15px;
  height: 15px;
  background: url("/public/imgs/common/blueimp-gallery/play-pause.png") 0 0
    no-repeat;
  cursor: pointer;
  opacity: 0.5;
  display: none;
}

.blueimp-gallery-playing > .play-pause {
  background-position: -15px 0;
}

.blueimp-gallery > .prev:hover,
.blueimp-gallery > .next:hover,
.blueimp-gallery > .close:hover,
.blueimp-gallery > .title:hover,
.blueimp-gallery > .play-pause:hover {
  color: #fff;
  opacity: 1;
  padding: 0;
}

.blueimp-gallery-controls > .prev,
.blueimp-gallery-controls > .next,
.blueimp-gallery-controls > .close,
.blueimp-gallery-controls > .title,
.blueimp-gallery-controls > .play-pause {
  display: block;
  /* Fix z-index issues (controls behind slide element) on Android: */
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.blueimp-gallery-single > .prev,
.blueimp-gallery-left > .prev,
.blueimp-gallery-single > .next,
.blueimp-gallery-right > .next,
.blueimp-gallery-single > .play-pause {
  display: none;
}

.blueimp-gallery > .slides > .slide > .slide-content,
.blueimp-gallery > .prev,
.blueimp-gallery > .next,
.blueimp-gallery > .close,
.blueimp-gallery > .play-pause {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Replace PNGs with SVGs for capable browsers (excluding IE<9) */
body:last-child .blueimp-gallery > .slides > .slide-error {
  background-image: url("/public/imgs/common/blueimp-gallery/error.svg");
}

body:last-child .blueimp-gallery > .play-pause {
  width: 20px;
  height: 20px;
  background-size: 40px 20px;
  background-image: url("/public/imgs/common/blueimp-gallery/play-pause.svg");
}

body:last-child .blueimp-gallery-playing > .play-pause {
  background-position: -20px 0;
}

/* IE7 fixes */
* + html .blueimp-gallery > .slides > .slide {
  min-height: 300px;
}

* + html .blueimp-gallery > .slides > .slide > .slide-content {
  position: relative;
}

/*! =======================================================
                      VERSION  6.0.4
========================================================= */
/*! =========================================================
 * bootstrap-slider.js
 *
 * Maintainers:
 *    Kyle Kemp
 *      - Twitter: @seiyria
 *      - Github:  seiyria
 *    Rohit Kalkur
 *      - Twitter: @Rovolutionary
 *      - Github:  rovolution
 *
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */
.slider {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}

.slider.slider-horizontal {
  width: 210px;
  height: 20px;
}

.slider.slider-horizontal .slider-track {
  height: 10px;
  width: 100%;
  margin-top: -5px;
  top: 50%;
  left: 0;
}

.slider.slider-horizontal .slider-selection,
.slider.slider-horizontal .slider-track-low,
.slider.slider-horizontal .slider-track-high {
  height: 100%;
  top: 0;
  bottom: 0;
}

.slider.slider-horizontal .slider-tick,
.slider.slider-horizontal .slider-handle {
  margin-left: -10px;
  margin-top: 0px;
}

.slider.slider-horizontal .slider-tick.triangle,
.slider.slider-horizontal .slider-handle.triangle {
  border-width: 0 10px 10px 10px;
  width: 0;
  height: 0;
  border-bottom-color: #0480be;
  margin-top: 5px;
}

.slider.slider-horizontal .slider-tick-label-container {
  white-space: nowrap;
  margin-top: 20px;
}

.slider.slider-horizontal .slider-tick-label-container .slider-tick-label {
  padding-top: 4px;
  display: inline-block;
  text-align: center;
}

.slider.slider-vertical {
  height: 210px;
  width: 20px;
}

.slider.slider-vertical .slider-track {
  width: 10px;
  height: 100%;
  margin-left: -5px;
  left: 50%;
  top: 0;
}

.slider.slider-vertical .slider-selection {
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
}

.slider.slider-vertical .slider-track-low,
.slider.slider-vertical .slider-track-high {
  width: 100%;
  left: 0;
  right: 0;
}

.slider.slider-vertical .slider-tick,
.slider.slider-vertical .slider-handle {
  margin-left: 0px;
  margin-top: -10px;
}

.slider.slider-vertical .slider-tick.triangle,
.slider.slider-vertical .slider-handle.triangle {
  border-width: 10px 0 10px 10px;
  width: 1px;
  height: 1px;
  border-left-color: #0480be;
  margin-left: 0;
}

.slider.slider-vertical .slider-tick-label-container {
  white-space: nowrap;
}

.slider.slider-vertical .slider-tick-label-container .slider-tick-label {
  padding-left: 4px;
}

.slider.slider-disabled .slider-handle {
  background-image: -webkit-gradient(linear, left top, left bottom, from(#dfdfdf), to(#bebebe));
  background-image: linear-gradient(to bottom, #dfdfdf 0%, #bebebe 100%);
  background-repeat: repeat-x;
}

.slider.slider-disabled .slider-track {
  background-image: -webkit-gradient(linear, left top, left bottom, from(#e5e5e5), to(#e9e9e9));
  background-image: linear-gradient(to bottom, #e5e5e5 0%, #e9e9e9 100%);
  background-repeat: repeat-x;
  cursor: not-allowed;
}

.slider input {
  display: none;
}

.slider .tooltip.top {
  margin-top: -36px;
}

.slider .tooltip-inner {
  white-space: nowrap;
}

.slider .hide {
  display: none;
}

.slider-track {
  position: absolute;
  cursor: pointer;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#f5f5f5), to(#f9f9f9));
  background-image: linear-gradient(to bottom, #f5f5f5 0%, #f9f9f9 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff5f5f5', endColorstr='#fff9f9f9', GradientType=0);
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.slider-selection {
  position: absolute;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#f9f9f9), to(#f5f5f5));
  background-image: linear-gradient(to bottom, #f9f9f9 0%, #f5f5f5 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff9f9f9', endColorstr='#fff5f5f5', GradientType=0);
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
}

.slider-selection.tick-slider-selection {
  background-image: -webkit-gradient(linear, left top, left bottom, from(#89cdef), to(#81bfde));
  background-image: linear-gradient(to bottom, #89cdef 0%, #81bfde 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff89cdef', endColorstr='#ff81bfde', GradientType=0);
}

.slider-track-low,
.slider-track-high {
  position: absolute;
  background: transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
}

.slider-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #337ab7;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#149bdf), to(#0480be));
  background-image: linear-gradient(to bottom, #149bdf 0%, #0480be 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff149bdf', endColorstr='#ff0480be', GradientType=0);
  -webkit-filter: none;
          filter: none;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
  border: 0px solid transparent;
}

.slider-handle.round {
  border-radius: 50%;
}

.slider-handle.triangle {
  background: transparent none;
}

.slider-handle.custom {
  background: transparent none;
}

.slider-handle.custombefore {
  line-height: 20px;
  font-size: 20px;
  content: "\\2605";
  color: #726204;
}

.slider-tick {
  position: absolute;
  width: 20px;
  height: 20px;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#f9f9f9), to(#f5f5f5));
  background-image: linear-gradient(to bottom, #f9f9f9 0%, #f5f5f5 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff9f9f9', endColorstr='#fff5f5f5', GradientType=0);
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-filter: none;
          filter: none;
  opacity: 0.8;
  border: 0px solid transparent;
}

.slider-tick.round {
  border-radius: 50%;
}

.slider-tick.triangle {
  background: transparent none;
}

.slider-tick.custom {
  background: transparent none;
}

.slider-tick.custombefore {
  line-height: 20px;
  font-size: 20px;
  content: "\\2605";
  color: #726204;
}

.slider-tick.in-selection {
  background-image: -webkit-gradient(linear, left top, left bottom, from(#89cdef), to(#81bfde));
  background-image: linear-gradient(to bottom, #89cdef 0%, #81bfde 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff89cdef', endColorstr='#ff81bfde', GradientType=0);
  opacity: 1;
}

@media print {
  /*!
   * FullCalendar v2.1.0-beta2 Print Stylesheet
   * Docs & License: http://arshaw.com/fullcalendar/
   * (c) 2013 Adam Shaw
   */
  /*
   * Include this stylesheet on your page to get a more printer-friendly calendar.
   * When including this stylesheet, use the media='print' attribute of the <link> tag.
   * Make sure to include this stylesheet IN ADDITION to the regular fullcalendar.css.
   */
  .fc {
    max-width: 100% !important;
  }
  /* Global Event Restyling
  --------------------------------------------------------------------------------------------------*/
  .fc-event {
    background: #fff !important;
    color: #000 !important;
    page-break-inside: avoid;
  }
  .fc-event .fc-resizer {
    display: none;
  }
  /* Table & Day-Row Restyling
  --------------------------------------------------------------------------------------------------*/
  th,
  td,
  hr,
  thead,
  tbody,
  .fc-row {
    border-color: #ccc !important;
    background: #fff !important;
  }
  /* kill the overlaid, absolutely-positioned common components */
  .fc-bg,
  .fc-highlight-skeleton,
  .fc-helper-skeleton {
    display: none;
  }
  /* don't force a min-height on rows (for DayGrid) */
  .fc tbody .fc-row {
    height: auto !important;
    /* undo height that JS set in distributeHeight */
    min-height: 0 !important;
    /* undo the min-height from each view's specific stylesheet */
  }
  .fc tbody .fc-row .fc-content-skeleton {
    position: static;
    /* undo .fc-rigid */
    /* don't have chunky padding underneath events (for Agenda, basicWeek, basicDay) */
    padding-bottom: 0 !important;
  }
  /* give back the bottom spacing that was taken away from the content-skeleton's padding (above) */
  /* only works on modern browsers */
  .fc tbody .fc-row .fc-content-skeleton table tr:last-child td {
    padding-bottom: 1px;
  }
  /* sets a min-height on the event skeleton. for IE8. was overexaggerating this, so make small */
  .fc tbody .fc-row .fc-content-skeleton table {
    height: 2em;
  }
  /* sets a min-height on the event skeleton. for modern browsers (not IE8) */
  .fc tbody .fc-row .fc-content-skeleton table:last-child {
    height: 4em;
  }
  /* Undo month-view event limiting. Display all events and hide the "more" links
  --------------------------------------------------------------------------------------------------*/
  .fc-more-cell,
  .fc-more {
    display: none !important;
  }
  .fc tr.fc-limited {
    display: table-row !important;
  }
  .fc td.fc-limited {
    display: table-cell !important;
  }
  /* TimeGrid Restyling
  --------------------------------------------------------------------------------------------------*/
  /* undo the min-height 100% trick used to fill the container's height */
  .fc-time-grid {
    min-height: 0 !important;
  }
  /* don't display the side axis at all ("all-day" and time cells) */
  .fc-agenda-view .fc-axis {
    display: none;
  }
  /* don't display the horizontal lines */
  .fc-slats,
  .fc-time-grid hr {
    /* this hr is used when height is underused and needs to be filled */
    display: none !important;
    /* important overrides inline declaration */
  }
  /* let the container that holds the events be naturally positioned and create real height */
  .fc-time-grid .fc-content-skeleton {
    position: static;
  }
  /* in case there are no events, we still want some height */
  .fc-time-grid .fc-content-skeleton table {
    height: 4em;
  }
  /* kill the horizontal spacing made by the event container. event margins will be done below */
  .fc-time-grid .fc-event-container {
    margin: 0 !important;
  }
  /* TimeGrid *Event* Restyling
  --------------------------------------------------------------------------------------------------*/
  /* naturally position events, vertically stacking them */
  .fc-time-grid .fc-event {
    position: static !important;
    margin: 3px 2px !important;
  }
  /* for events that continue to a future day, give the bottom border back */
  .fc-time-grid .fc-event.fc-not-end {
    border-bottom-width: 1px !important;
  }
  /* indicate the event continues via "..." text */
  .fc-time-grid .fc-event.fc-not-end:after {
    content: "...";
  }
  /* for events that are continuations from previous days, give the top border back */
  .fc-time-grid .fc-event.fc-not-start {
    border-top-width: 1px !important;
  }
  /* indicate the event is a continuation via "..." text */
  .fc-time-grid .fc-event.fc-not-start:before {
    content: "...";
  }
  /* time */
  /* undo a previous declaration and let the time text span to a second line */
  .fc-time-grid .fc-event .fc-time {
    white-space: normal !important;
  }
  /* hide the the time that is normally displayed... */
  .fc-time-grid .fc-event .fc-time span {
    display: none;
  }
  /* ...replace it with a more verbose version (includes AM/PM) stored in an html attribute */
  .fc-time-grid .fc-event .fc-time:after {
    content: attr(data-full);
  }
  /* Vertical Scroller & Containers
  --------------------------------------------------------------------------------------------------*/
  /* kill the scrollbars and allow natural height */
  .fc-scroller,
  .fc-day-grid-container,
  .fc-time-grid-container {
    /* */
    overflow: visible !important;
    height: auto !important;
  }
  /* kill the horizontal border/padding used to compensate for scrollbars */
  .fc-row {
    border: 0 !important;
    margin: 0 !important;
  }
  /* Button Controls
  --------------------------------------------------------------------------------------------------*/
  .fc-button-group,
  .fc button {
    display: none;
    /* don't display any button-related controls */
  }
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {
  top: 8px;
  left: 4px;
  height: 16px;
  width: 16px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 16px;
  -webkit-box-shadow: 0 0 3px #444;
          box-shadow: 0 0 3px #444;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  text-align: left;
  font-family: "Courier New", Courier, monospace;
  text-indent: 4px;
  line-height: 16px;
  content: "+";
  background-color: #31b131;
}

table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > td:first-child:before,
table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > th:first-child:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {
  display: none;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}

table.dataTable.dtr-inline.collapsed.compact
  > tbody
  > tr
  > td:first-child:before,
table.dataTable.dtr-inline.collapsed.compact
  > tbody
  > tr
  > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control,
table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}

table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 16px;
  -webkit-box-shadow: 0 0 3px #444;
          box-shadow: 0 0 3px #444;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  text-align: left;
  font-family: "Courier New", Courier, monospace;
  text-indent: 4px;
  line-height: 16px;
  content: "+";
  background-color: #31b131;
}

table.dataTable.dtr-column > tbody > tr.parent td.control:before,
table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}

table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}

table.dataTable > tbody > tr.child ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

table.dataTable > tbody > tr.child ul li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}

table.dataTable > tbody > tr.child ul li:first-child {
  padding-top: 0;
}

table.dataTable > tbody > tr.child ul li:last-child {
  border-bottom: none;
}

table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}

div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  -webkit-box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}

div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}

div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}

div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}

div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.bootstrap-datetimepicker-widget {
  list-style: none;
}
.bootstrap-datetimepicker-widget.dropdown-menu {
  margin: 2px 0;
  padding: 4px;
  width: 19em;
}
@media (min-width: 990px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1152px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1366px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu:before,
.bootstrap-datetimepicker-widget.dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ccc;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  top: -7px;
  left: 7px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  top: -6px;
  left: 8px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top:before {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #ccc;
  border-top-color: rgba(0, 0, 0, 0.2);
  bottom: -7px;
  left: 6px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top:after {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
  bottom: -6px;
  left: 7px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}
.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}
.bootstrap-datetimepicker-widget a[data-action] {
  padding: 6px 0;
}
.bootstrap-datetimepicker-widget a[data-action]:active {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 54px;
  font-weight: bold;
  font-size: 1.2em;
  margin: 0;
}
.bootstrap-datetimepicker-widget button[data-action] {
  padding: 6px;
  height: 36px;
}
.bootstrap-datetimepicker-widget .btn[data-action="incrementHours"]after {
  content: "Increment Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action="incrementMinutes"]after {
  content: "Increment Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action="decrementHours"]after {
  content: "Decrement Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action="decrementMinutes"]after {
  content: "Decrement Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action="showHours"]after {
  content: "Show Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action="showMinutes"]after {
  content: "Show Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action="togglePeriod"]after {
  content: "Toggle AM/PM";
}
.bootstrap-datetimepicker-widget .btn[data-action="clear"]after {
  content: "Clear the picker";
}
.bootstrap-datetimepicker-widget .btn[data-action="today"]after {
  content: "Set the date to today";
}
.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
}
.bootstrap-datetimepicker-widget .picker-switchafter {
  content: "Toggle Date and Time Screens";
}
.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}
.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
}
.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
}
.bootstrap-datetimepicker-widget table td,
.bootstrap-datetimepicker-widget table th {
  text-align: center;
  border-radius: 4px;
}
.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
}
.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}
.bootstrap-datetimepicker-widget table th.disabled,
.bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #777777;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget table th.prevafter {
  content: "Previous Month";
}
.bootstrap-datetimepicker-widget table th.nextafter {
  content: "Next Month";
}
.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}
.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
  background: #eeeeee;
}
.bootstrap-datetimepicker-widget table td {
  height: 54px;
  line-height: 54px;
  width: 54px;
}
.bootstrap-datetimepicker-widget table td.cw {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #777777;
}
.bootstrap-datetimepicker-widget table td.day {
  height: 20px;
  line-height: 20px;
  width: 20px;
}
.bootstrap-datetimepicker-widget table td.day:hover,
.bootstrap-datetimepicker-widget table td.hour:hover,
.bootstrap-datetimepicker-widget table td.minute:hover,
.bootstrap-datetimepicker-widget table td.second:hover {
  background: #eeeeee;
  cursor: pointer;
}
.bootstrap-datetimepicker-widget table td.old,
.bootstrap-datetimepicker-widget table td.new {
  color: #777777;
}
.bootstrap-datetimepicker-widget table td.today {
  position: relative;
}
.bootstrap-datetimepicker-widget table td.today:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #428bca;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}
.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #428bca;
  color: #428bca;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}
.bootstrap-datetimepicker-widget table td.active.today:before {
  border-bottom-color: #fff;
}
.bootstrap-datetimepicker-widget table td.disabled,
.bootstrap-datetimepicker-widget table td.disabled:hover {
  background: none;
  color: #777777;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 54px;
  height: 54px;
  line-height: 54px;
  margin: 2px 1.5px;
  cursor: pointer;
  border-radius: 4px;
}
.bootstrap-datetimepicker-widget table td span:hover {
  background: #eeeeee;
}
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #428bca;
  color: #428bca;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}
.bootstrap-datetimepicker-widget table td span.old {
  color: #777777;
}
.bootstrap-datetimepicker-widget table td span.disabled,
.bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #777777;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.btn-primary {
  background: #079EDA;
  color: white;
  border-color: #428bca;
}
.btn-primary.btn-outlined {
  color: #428bca;
  background: none;
}
.btn-primary.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-primary.btn-outlined.btn-onlyOnHover:hover,
.btn-primary.btn-outlined.btn-onlyOnHover:focus,
.btn-primary.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-primary.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-primary.btn-outlined.btn-inverse:hover,
.btn-primary.btn-outlined.btn-inverse:focus,
.btn-primary.btn-outlined.btn-inverse.active {
  color: #428bca;
  background: white;
}
.btn-primary.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-primary.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-primary.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #428bca;
  color: white;
  border-color: #428bca;
}
.btn-primary.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-primary.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-primary.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #275c8a;
  border-color: #193c5a;
}
.btn-primary:focus,
.btn-primary.focus,
.btn-primary:hover,
.btn-primary.active {
  color: white;
  background: #6aa3d5;
  border-color: #6aa3d5;
}
.btn-primary:active,
.btn-primary.active,
.btn-primary[aria-expanded="true"],
.btn-primary.active:hover,
.btn-primary.active:focus,
.btn-primary[aria-expanded="true"]:hover,
.btn-primary[aria-expanded="true"]:focus,
.open > .btn-primary.dropdown-toggle {
  color: white;
  background: #275c8a;
  border-color: #193c5a;
  background-image: none;
}
.btn-primary.dropdown-toggle + ul li.active a {
  color: white;
  background: #428bca;
}
.btn-primary.disabled,
.btn-primary[disabled],
fieldset[disabled] .btn-primary {
  pointer-events: none;
}
.btn-primary .badge {
  color: #428bca;
  background-color: #428bca;
}

.menu-primary ul li.active a,
.menu-primary ul li.active a:hover {
  color: white;
  background: #428bca !important;
}

.nav-primary > li.active > a,
.nav-primary > rubix-menu > li.active > a,
.nav-primary > rubix-nav-item > li.active > a {
  color: white;
  background: #428bca;
  border-color: #428bca;
}

.tab-primary {
  border-color: #428bca;
}
.tab-primary > li.active > a {
  border-color: #428bca;
  border-bottom-color: transparent;
}
.tab-primary.nav-pills > li.active > a {
  background: #428bca;
  color: white;
}

.rubix-panel-header.nav-inline .nav-primary > li.active > a {
  border: 1px solid #428bca;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-primary > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-primary {
  background: #428bca !important;
}
.bg-primary table td,
.bg-primary th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-primary:focus {
  background: #428bca !important;
}

.bg-hover-primary:hover {
  background: #428bca !important;
}

.fg-primary {
  color: #428bca;
}
.fg-primary .nav-tabs > li.active > a {
  color: #428bca;
}

.fg-tab-active-primary .nav-tabs > li.active > a {
  color: #428bca !important;
}

.fg-focus-primary:focus {
  color: #428bca;
}

.fg-hover-primary:hover {
  color: #428bca;
}

.border-primary {
  border-color: #428bca !important;
}
.border-primary .rubix-timeline-body > ul {
  border-color: #428bca;
}
.border-primary.rubix-timeline-view:before {
  border-color: #428bca;
}

.border-hover-primary:hover {
  border-color: #428bca !important;
}

.border-focus-primary:focus {
  border-color: #428bca !important;
}

.tl-primary .rubix-timeline-body > ul > li:before {
  border-color: #428bca;
}

.list-bg-primary > .list-group-item.active {
  background: #428bca !important;
  color: white !important;
}

.list-fg-primary > .list-group-item {
  color: #428bca;
}

.btn-success {
  background: #5cb85c;
  color: white;
  border-color: #5cb85c;
}
.btn-success.btn-outlined {
  color: #5cb85c;
  background: none;
}
.btn-success.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-success.btn-outlined.btn-onlyOnHover:hover,
.btn-success.btn-outlined.btn-onlyOnHover:focus,
.btn-success.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-success.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-success.btn-outlined.btn-inverse:hover,
.btn-success.btn-outlined.btn-inverse:focus,
.btn-success.btn-outlined.btn-inverse.active {
  color: #5cb85c;
  background: white;
}
.btn-success.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-success.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-success.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #5cb85c;
  color: white;
  border-color: #5cb85c;
}
.btn-success.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-success.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-success.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #388038;
  border-color: #255625;
}
.btn-success:focus,
.btn-success.focus,
.btn-success:hover,
.btn-success.active {
  color: white;
  background: #80c780;
  border-color: #80c780;
}
.btn-success:active,
.btn-success.active,
.btn-success[aria-expanded="true"],
.btn-success.active:hover,
.btn-success.active:focus,
.btn-success[aria-expanded="true"]:hover,
.btn-success[aria-expanded="true"]:focus,
.open > .btn-success.dropdown-toggle {
  color: white;
  background: #388038;
  border-color: #255625;
  background-image: none;
}
.btn-success.dropdown-toggle + ul li.active a {
  color: white;
  background: #5cb85c;
}
.btn-success.disabled,
.btn-success[disabled],
fieldset[disabled] .btn-success {
  pointer-events: none;
}
.btn-success .badge {
  color: #5cb85c;
  background-color: #5cb85c;
}

.menu-success ul li.active a,
.menu-success ul li.active a:hover {
  color: white;
  background: #5cb85c !important;
}

.nav-success > li.active > a,
.nav-success > rubix-menu > li.active > a,
.nav-success > rubix-nav-item > li.active > a {
  color: white;
  background: #5cb85c;
  border-color: #5cb85c;
}

.tab-success {
  border-color: #5cb85c;
}
.tab-success > li.active > a {
  border-color: #5cb85c;
  border-bottom-color: transparent;
}
.tab-success.nav-pills > li.active > a {
  background: #5cb85c;
  color: white;
}

.rubix-panel-header.nav-inline .nav-success > li.active > a {
  border: 1px solid #5cb85c;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-success > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-success {
  background: #5cb85c !important;
}
.bg-success table td,
.bg-success th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-success:focus {
  background: #5cb85c !important;
}

.bg-hover-success:hover {
  background: #5cb85c !important;
}

.fg-success {
  color: #5cb85c;
}
.fg-success .nav-tabs > li.active > a {
  color: #5cb85c;
}

.fg-tab-active-success .nav-tabs > li.active > a {
  color: #5cb85c !important;
}

.fg-focus-success:focus {
  color: #5cb85c;
}

.fg-hover-success:hover {
  color: #5cb85c;
}

.border-success {
  border-color: #5cb85c !important;
}
.border-success .rubix-timeline-body > ul {
  border-color: #5cb85c;
}
.border-success.rubix-timeline-view:before {
  border-color: #5cb85c;
}

.border-hover-success:hover {
  border-color: #5cb85c !important;
}

.border-focus-success:focus {
  border-color: #5cb85c !important;
}

.tl-success .rubix-timeline-body > ul > li:before {
  border-color: #5cb85c;
}

.list-bg-success > .list-group-item.active {
  background: #5cb85c !important;
  color: white !important;
}

.list-fg-success > .list-group-item {
  color: #5cb85c;
}

.btn-info {
  background: #5bc0de;
  color: white;
  border-color: #5bc0de;
}
.btn-info.btn-outlined {
  color: #5bc0de;
  background: none;
}
.btn-info.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-info.btn-outlined.btn-onlyOnHover:hover,
.btn-info.btn-outlined.btn-onlyOnHover:focus,
.btn-info.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-info.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-info.btn-outlined.btn-inverse:hover,
.btn-info.btn-outlined.btn-inverse:focus,
.btn-info.btn-outlined.btn-inverse.active {
  color: #5bc0de;
  background: white;
}
.btn-info.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-info.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-info.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #5bc0de;
  color: white;
  border-color: #5bc0de;
}
.btn-info.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-info.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-info.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2596b8;
  border-color: #1b6d85;
}
.btn-info:focus,
.btn-info.focus,
.btn-info:hover,
.btn-info.active {
  color: white;
  background: #85d0e7;
  border-color: #85d0e7;
}
.btn-info:active,
.btn-info.active,
.btn-info[aria-expanded="true"],
.btn-info.active:hover,
.btn-info.active:focus,
.btn-info[aria-expanded="true"]:hover,
.btn-info[aria-expanded="true"]:focus,
.open > .btn-info.dropdown-toggle {
  color: white;
  background: #2596b8;
  border-color: #1b6d85;
  background-image: none;
}
.btn-info.dropdown-toggle + ul li.active a {
  color: white;
  background: #5bc0de;
}
.btn-info.disabled,
.btn-info[disabled],
fieldset[disabled] .btn-info {
  pointer-events: none;
}
.btn-info .badge {
  color: #5bc0de;
  background-color: #5bc0de;
}

.menu-info ul li.active a,
.menu-info ul li.active a:hover {
  color: white;
  background: #5bc0de !important;
}

.nav-info > li.active > a,
.nav-info > rubix-menu > li.active > a,
.nav-info > rubix-nav-item > li.active > a {
  color: white;
  background: #5bc0de;
  border-color: #5bc0de;
}

.tab-info {
  border-color: #5bc0de;
}
.tab-info > li.active > a {
  border-color: #5bc0de;
  border-bottom-color: transparent;
}
.tab-info.nav-pills > li.active > a {
  background: #5bc0de;
  color: white;
}

.rubix-panel-header.nav-inline .nav-info > li.active > a {
  border: 1px solid #5bc0de;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-info > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-info {
  background: #5bc0de !important;
}
.bg-info table td,
.bg-info th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-info:focus {
  background: #5bc0de !important;
}

.bg-hover-info:hover {
  background: #5bc0de !important;
}

.fg-info {
  color: #5bc0de;
}
.fg-info .nav-tabs > li.active > a {
  color: #5bc0de;
}

.fg-tab-active-info .nav-tabs > li.active > a {
  color: #5bc0de !important;
}

.fg-focus-info:focus {
  color: #5bc0de;
}

.fg-hover-info:hover {
  color: #5bc0de;
}

.border-info {
  border-color: #5bc0de !important;
}
.border-info .rubix-timeline-body > ul {
  border-color: #5bc0de;
}
.border-info.rubix-timeline-view:before {
  border-color: #5bc0de;
}

.border-hover-info:hover {
  border-color: #5bc0de !important;
}

.border-focus-info:focus {
  border-color: #5bc0de !important;
}

.tl-info .rubix-timeline-body > ul > li:before {
  border-color: #5bc0de;
}

.list-bg-info > .list-group-item.active {
  background: #5bc0de !important;
  color: white !important;
}

.list-fg-info > .list-group-item {
  color: #5bc0de;
}

.btn-warning {
  background: #f0ad4e;
  color: white;
  border-color: #f0ad4e;
}
.btn-warning.btn-outlined {
  color: #f0ad4e;
  background: none;
}
.btn-warning.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-warning.btn-outlined.btn-onlyOnHover:hover,
.btn-warning.btn-outlined.btn-onlyOnHover:focus,
.btn-warning.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-warning.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-warning.btn-outlined.btn-inverse:hover,
.btn-warning.btn-outlined.btn-inverse:focus,
.btn-warning.btn-outlined.btn-inverse.active {
  color: #f0ad4e;
  background: white;
}
.btn-warning.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-warning.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-warning.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #f0ad4e;
  color: white;
  border-color: #f0ad4e;
}
.btn-warning.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-warning.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-warning.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #d18212;
  border-color: #985f0d;
}
.btn-warning:focus,
.btn-warning.focus,
.btn-warning:hover,
.btn-warning.active {
  color: white;
  background: #f4c37d;
  border-color: #f4c37d;
}
.btn-warning:active,
.btn-warning.active,
.btn-warning[aria-expanded="true"],
.btn-warning.active:hover,
.btn-warning.active:focus,
.btn-warning[aria-expanded="true"]:hover,
.btn-warning[aria-expanded="true"]:focus,
.open > .btn-warning.dropdown-toggle {
  color: white;
  background: #d18212;
  border-color: #985f0d;
  background-image: none;
}
.btn-warning.dropdown-toggle + ul li.active a {
  color: white;
  background: #f0ad4e;
}
.btn-warning.disabled,
.btn-warning[disabled],
fieldset[disabled] .btn-warning {
  pointer-events: none;
}
.btn-warning .badge {
  color: #f0ad4e;
  background-color: #f0ad4e;
}

.menu-warning ul li.active a,
.menu-warning ul li.active a:hover {
  color: white;
  background: #f0ad4e !important;
}

.nav-warning > li.active > a,
.nav-warning > rubix-menu > li.active > a,
.nav-warning > rubix-nav-item > li.active > a {
  color: white;
  background: #f0ad4e;
  border-color: #f0ad4e;
}

.tab-warning {
  border-color: #f0ad4e;
}
.tab-warning > li.active > a {
  border-color: #f0ad4e;
  border-bottom-color: transparent;
}
.tab-warning.nav-pills > li.active > a {
  background: #f0ad4e;
  color: white;
}

.rubix-panel-header.nav-inline .nav-warning > li.active > a {
  border: 1px solid #f0ad4e;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-warning > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-warning {
  background: #f0ad4e !important;
}
.bg-warning table td,
.bg-warning th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-warning:focus {
  background: #f0ad4e !important;
}

.bg-hover-warning:hover {
  background: #f0ad4e !important;
}

.fg-warning {
  color: #f0ad4e;
}
.fg-warning .nav-tabs > li.active > a {
  color: #f0ad4e;
}

.fg-tab-active-warning .nav-tabs > li.active > a {
  color: #f0ad4e !important;
}

.fg-focus-warning:focus {
  color: #f0ad4e;
}

.fg-hover-warning:hover {
  color: #f0ad4e;
}

.border-warning {
  border-color: #f0ad4e !important;
}
.border-warning .rubix-timeline-body > ul {
  border-color: #f0ad4e;
}
.border-warning.rubix-timeline-view:before {
  border-color: #f0ad4e;
}

.border-hover-warning:hover {
  border-color: #f0ad4e !important;
}

.border-focus-warning:focus {
  border-color: #f0ad4e !important;
}

.tl-warning .rubix-timeline-body > ul > li:before {
  border-color: #f0ad4e;
}

.list-bg-warning > .list-group-item.active {
  background: #f0ad4e !important;
  color: white !important;
}

.list-fg-warning > .list-group-item {
  color: #f0ad4e;
}

.btn-danger {
  background: #d9534f;
  color: white;
  border-color: #d9534f;
}
.btn-danger.btn-outlined {
  color: #d9534f;
  background: none;
}
.btn-danger.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-danger.btn-outlined.btn-onlyOnHover:hover,
.btn-danger.btn-outlined.btn-onlyOnHover:focus,
.btn-danger.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-danger.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-danger.btn-outlined.btn-inverse:hover,
.btn-danger.btn-outlined.btn-inverse:focus,
.btn-danger.btn-outlined.btn-inverse.active {
  color: #d9534f;
  background: white;
}
.btn-danger.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-danger.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-danger.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #d9534f;
  color: white;
  border-color: #d9534f;
}
.btn-danger.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-danger.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-danger.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #a82824;
  border-color: #761c19;
}
.btn-danger:focus,
.btn-danger.focus,
.btn-danger:hover,
.btn-danger.active {
  color: white;
  background: #e27c79;
  border-color: #e27c79;
}
.btn-danger:active,
.btn-danger.active,
.btn-danger[aria-expanded="true"],
.btn-danger.active:hover,
.btn-danger.active:focus,
.btn-danger[aria-expanded="true"]:hover,
.btn-danger[aria-expanded="true"]:focus,
.open > .btn-danger.dropdown-toggle {
  color: white;
  background: #a82824;
  border-color: #761c19;
  background-image: none;
}
.btn-danger.dropdown-toggle + ul li.active a {
  color: white;
  background: #d9534f;
}
.btn-danger.disabled,
.btn-danger[disabled],
fieldset[disabled] .btn-danger {
  pointer-events: none;
}
.btn-danger .badge {
  color: #d9534f;
  background-color: #d9534f;
}

.menu-danger ul li.active a,
.menu-danger ul li.active a:hover {
  color: white;
  background: #d9534f !important;
}

.nav-danger > li.active > a,
.nav-danger > rubix-menu > li.active > a,
.nav-danger > rubix-nav-item > li.active > a {
  color: white;
  background: #d9534f;
  border-color: #d9534f;
}

.tab-danger {
  border-color: #d9534f;
}
.tab-danger > li.active > a {
  border-color: #d9534f;
  border-bottom-color: transparent;
}
.tab-danger.nav-pills > li.active > a {
  background: #d9534f;
  color: white;
}

.rubix-panel-header.nav-inline .nav-danger > li.active > a {
  border: 1px solid #d9534f;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-danger > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-danger {
  background: #d9534f !important;
}
.bg-danger table td,
.bg-danger th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-danger:focus {
  background: #d9534f !important;
}

.bg-hover-danger:hover {
  background: #d9534f !important;
}

.fg-danger {
  color: #d9534f;
}
.fg-danger .nav-tabs > li.active > a {
  color: #d9534f;
}

.fg-tab-active-danger .nav-tabs > li.active > a {
  color: #d9534f !important;
}

.fg-focus-danger:focus {
  color: #d9534f;
}

.fg-hover-danger:hover {
  color: #d9534f;
}

.border-danger {
  border-color: #d9534f !important;
}
.border-danger .rubix-timeline-body > ul {
  border-color: #d9534f;
}
.border-danger.rubix-timeline-view:before {
  border-color: #d9534f;
}

.border-hover-danger:hover {
  border-color: #d9534f !important;
}

.border-focus-danger:focus {
  border-color: #d9534f !important;
}

.tl-danger .rubix-timeline-body > ul > li:before {
  border-color: #d9534f;
}

.list-bg-danger > .list-group-item.active {
  background: #d9534f !important;
  color: white !important;
}

.list-fg-danger > .list-group-item {
  color: #d9534f;
}

.btn-white {
  background: #ffffff;
  color: white;
  border-color: #ffffff;
}
.btn-white.btn-outlined {
  color: #ffffff;
  background: none;
}
.btn-white.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-white.btn-outlined.btn-onlyOnHover:hover,
.btn-white.btn-outlined.btn-onlyOnHover:focus,
.btn-white.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-white.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-white.btn-outlined.btn-inverse:hover,
.btn-white.btn-outlined.btn-inverse:focus,
.btn-white.btn-outlined.btn-inverse.active {
  color: #ffffff;
  background: white;
}
.btn-white.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-white.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-white.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ffffff;
  color: white;
  border-color: #ffffff;
}
.btn-white.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-white.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-white.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #d1d1d1;
  border-color: #b3b3b3;
}
.btn-white:focus,
.btn-white.focus,
.btn-white:hover,
.btn-white.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-white:active,
.btn-white.active,
.btn-white[aria-expanded="true"],
.btn-white.active:hover,
.btn-white.active:focus,
.btn-white[aria-expanded="true"]:hover,
.btn-white[aria-expanded="true"]:focus,
.open > .btn-white.dropdown-toggle {
  color: white;
  background: #d1d1d1;
  border-color: #b3b3b3;
  background-image: none;
}
.btn-white.dropdown-toggle + ul li.active a {
  color: white;
  background: #ffffff;
}
.btn-white.disabled,
.btn-white[disabled],
fieldset[disabled] .btn-white {
  pointer-events: none;
}
.btn-white .badge {
  color: #ffffff;
  background-color: #ffffff;
}

.menu-white ul li.active a,
.menu-white ul li.active a:hover {
  color: white;
  background: #ffffff !important;
}

.nav-white > li.active > a,
.nav-white > rubix-menu > li.active > a,
.nav-white > rubix-nav-item > li.active > a {
  color: white;
  background: #ffffff;
  border-color: #ffffff;
}

.tab-white {
  border-color: #ffffff;
}
.tab-white > li.active > a {
  border-color: #ffffff;
  border-bottom-color: transparent;
}
.tab-white.nav-pills > li.active > a {
  background: #ffffff;
  color: white;
}

.rubix-panel-header.nav-inline .nav-white > li.active > a {
  border: 1px solid #ffffff;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-white > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-white {
  background: #ffffff !important;
}
.bg-white table td,
.bg-white th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-white:focus {
  background: #ffffff !important;
}

.bg-hover-white:hover {
  background: #ffffff !important;
}

.fg-white {
  color: #ffffff;
}
.fg-white .nav-tabs > li.active > a {
  color: #89949b;
}

.fg-white-full li > a {
  color: #ffffff !important;
}

.fg-tab-active-white .nav-tabs > li.active > a {
  color: #ffffff !important;
}

.fg-focus-white:focus {
  color: #ffffff;
}

.fg-hover-white:hover {
  color: #ffffff;
}

.border-white {
  border-color: #ffffff !important;
}
.border-white .rubix-timeline-body > ul {
  border-color: #ffffff;
}
.border-white.rubix-timeline-view:before {
  border-color: #ffffff;
}

.border-hover-white:hover {
  border-color: #ffffff !important;
}

.border-focus-white:focus {
  border-color: #ffffff !important;
}

.tl-white .rubix-timeline-body > ul > li:before {
  border-color: #ffffff;
}

.list-bg-white > .list-group-item.active {
  background: #ffffff !important;
  color: white !important;
}

.list-fg-white > .list-group-item {
  color: #ffffff;
}

.btn-black {
  background: #000000;
  color: white;
  border-color: #000000;
}
.btn-black.btn-outlined {
  color: #000000;
  background: none;
}
.btn-black.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-black.btn-outlined.btn-onlyOnHover:hover,
.btn-black.btn-outlined.btn-onlyOnHover:focus,
.btn-black.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-black.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-black.btn-outlined.btn-inverse:hover,
.btn-black.btn-outlined.btn-inverse:focus,
.btn-black.btn-outlined.btn-inverse.active {
  color: #000000;
  background: white;
}
.btn-black.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-black.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-black.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #000000;
  color: white;
  border-color: #000000;
}
.btn-black.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-black.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-black.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: black;
  border-color: black;
}
.btn-black:focus,
.btn-black.focus,
.btn-black:hover,
.btn-black.active {
  color: white;
  background: #1a1a1a;
  border-color: #1a1a1a;
}
.btn-black:active,
.btn-black.active,
.btn-black[aria-expanded="true"],
.btn-black.active:hover,
.btn-black.active:focus,
.btn-black[aria-expanded="true"]:hover,
.btn-black[aria-expanded="true"]:focus,
.open > .btn-black.dropdown-toggle {
  color: white;
  background: black;
  border-color: black;
  background-image: none;
}
.btn-black.dropdown-toggle + ul li.active a {
  color: white;
  background: #000000;
}
.btn-black.disabled,
.btn-black[disabled],
fieldset[disabled] .btn-black {
  pointer-events: none;
}
.btn-black .badge {
  color: #000000;
  background-color: #000000;
}

.menu-black ul li.active a,
.menu-black ul li.active a:hover {
  color: white;
  background: #000000 !important;
}

.nav-black > li.active > a,
.nav-black > rubix-menu > li.active > a,
.nav-black > rubix-nav-item > li.active > a {
  color: white;
  background: #000000;
  border-color: #000000;
}

.tab-black {
  border-color: #000000;
}
.tab-black > li.active > a {
  border-color: #000000;
  border-bottom-color: transparent;
}
.tab-black.nav-pills > li.active > a {
  background: #000000;
  color: white;
}

.rubix-panel-header.nav-inline .nav-black > li.active > a {
  border: 1px solid #000000;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-black > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-black {
  background: #000000 !important;
}
.bg-black table td,
.bg-black th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-black:focus {
  background: #000000 !important;
}

.bg-hover-black:hover {
  background: #000000 !important;
}

.fg-custome-blue {
  color: #022144;
}

.custome-blue {
  color: #022144;
}

.btn-custome-blue {
  background: #022144;
  color: white;
  border-color: #022144;
  min-width: 120px;
}
.btn-custome-blue.btn-outlined {
  color: #022144;
  background: none;
}
.btn-custome-blue.btn-outlined.btn-onlyOnHover {
  color: #022144;
}
.btn-custome-blue.btn-outlined.btn-onlyOnHover:hover,
.btn-custome-blue.btn-outlined.btn-onlyOnHover:focus,
.btn-custome-blue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-custome-blue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-custome-blue.btn-outlined.btn-inverse:hover,
.btn-custome-blue.btn-outlined.btn-inverse:focus,
.btn-custome-blue.btn-outlined.btn-inverse.active {
  color: #022144;
  background: white;
}
.btn-custome-blue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-custome-blue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-custome-blue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #022144;
  color: white;
  border-color: #022144;
}
.btn-custome-blue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-custome-blue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-custome-blue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #022144;
  border-color: #022144;
}
.btn-custome-blue:focus,
.btn-custome-blue.focus,
.btn-custome-blue:hover,
.btn-custome-blue.active {
  color: white;
  background: #022144;
  border-color: #022144;
}
.btn-custome-blue:active,
.btn-custome-blue.active,
.btn-custome-blue[aria-expanded="true"],
.btn-custome-blue.active:hover,
.btn-custome-blue.active:focus,
.btn-custome-blue[aria-expanded="true"]:hover,
.btn-custome-blue[aria-expanded="true"]:focus,
.open > .btn-custome-blue.dropdown-toggle {
  color: white;
  background: #275c8a;
  border-color: #193c5a;
  background-image: none;
}
.btn-custome-blue.dropdown-toggle + ul li.active a {
  color: white;
  background: #428bca;
}
.btn-custome-blue.disabled,
.btn-custome-blue[disabled],
fieldset[disabled] .btn-custome-blue {
  pointer-events: none;
}
.btn-custome-blue .badge {
  color: #428bca;
  background-color: #428bca;
}

.fg-black {
  color: #000000;
}
.fg-black .nav-tabs > li.active > a {
  color: #000000;
}

.fg-tab-active-black .nav-tabs > li.active > a {
  color: #000000 !important;
}

.fg-focus-black:focus {
  color: #000000;
}

.fg-hover-black:hover {
  color: #000000;
}

.border-black {
  border-color: #000000 !important;
}
.border-black .rubix-timeline-body > ul {
  border-color: #000000;
}
.border-black.rubix-timeline-view:before {
  border-color: #000000;
}

.border-hover-black:hover {
  border-color: #000000 !important;
}

.border-focus-black:focus {
  border-color: #000000 !important;
}

.tl-black .rubix-timeline-body > ul > li:before {
  border-color: #000000;
}

.list-bg-black > .list-group-item.active {
  background: #000000 !important;
  color: white !important;
}

.list-fg-black > .list-group-item {
  color: #000000;
}

.btn-deepred {
  background: #d71f4b;
  color: white;
  border-color: #d71f4b;
}
.btn-deepred.btn-outlined {
  color: #d71f4b;
  background: none;
}
.btn-deepred.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-deepred.btn-outlined.btn-onlyOnHover:hover,
.btn-deepred.btn-outlined.btn-onlyOnHover:focus,
.btn-deepred.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-deepred.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-deepred.btn-outlined.btn-inverse:hover,
.btn-deepred.btn-outlined.btn-inverse:focus,
.btn-deepred.btn-outlined.btn-inverse.active {
  color: #d71f4b;
  background: white;
}
.btn-deepred.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-deepred.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-deepred.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #d71f4b;
  color: white;
  border-color: #d71f4b;
}
.btn-deepred.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-deepred.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-deepred.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #87132f;
  border-color: #510c1c;
}
.btn-deepred:focus,
.btn-deepred.focus,
.btn-deepred:hover,
.btn-deepred.active {
  color: white;
  background: #e4456b;
  border-color: #e4456b;
}
.btn-deepred:active,
.btn-deepred.active,
.btn-deepred[aria-expanded="true"],
.btn-deepred.active:hover,
.btn-deepred.active:focus,
.btn-deepred[aria-expanded="true"]:hover,
.btn-deepred[aria-expanded="true"]:focus,
.open > .btn-deepred.dropdown-toggle {
  color: white;
  background: #87132f;
  border-color: #510c1c;
  background-image: none;
}
.btn-deepred.dropdown-toggle + ul li.active a {
  color: white;
  background: #d71f4b;
}
.btn-deepred.disabled,
.btn-deepred[disabled],
fieldset[disabled] .btn-deepred {
  pointer-events: none;
}
.btn-deepred .badge {
  color: #d71f4b;
  background-color: #d71f4b;
}

.menu-deepred ul li.active a,
.menu-deepred ul li.active a:hover {
  color: white;
  background: #d71f4b !important;
}

.nav-deepred > li.active > a,
.nav-deepred > rubix-menu > li.active > a,
.nav-deepred > rubix-nav-item > li.active > a {
  color: white;
  background: #d71f4b;
  border-color: #d71f4b;
}

.tab-deepred {
  border-color: #d71f4b;
}
.tab-deepred > li.active > a {
  border-color: #d71f4b;
  border-bottom-color: transparent;
}
.tab-deepred.nav-pills > li.active > a {
  background: #d71f4b;
  color: white;
}

.rubix-panel-header.nav-inline .nav-deepred > li.active > a {
  border: 1px solid #d71f4b;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-deepred > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-deepred {
  background: #d71f4b !important;
}
.bg-deepred table td,
.bg-deepred th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-deepred:focus {
  background: #d71f4b !important;
}

.bg-hover-deepred:hover {
  background: #d71f4b !important;
}

.fg-deepred {
  color: #d71f4b;
}
.fg-deepred .nav-tabs > li.active > a {
  color: #d71f4b;
}

.fg-tab-active-deepred .nav-tabs > li.active > a {
  color: #d71f4b !important;
}

.fg-focus-deepred:focus {
  color: #d71f4b;
}

.fg-hover-deepred:hover {
  color: #d71f4b;
}

.border-deepred {
  border-color: #d71f4b !important;
}
.border-deepred .rubix-timeline-body > ul {
  border-color: #d71f4b;
}
.border-deepred.rubix-timeline-view:before {
  border-color: #d71f4b;
}

.border-hover-deepred:hover {
  border-color: #d71f4b !important;
}

.border-focus-deepred:focus {
  border-color: #d71f4b !important;
}

.tl-deepred .rubix-timeline-body > ul > li:before {
  border-color: #d71f4b;
}

.list-bg-deepred > .list-group-item.active {
  background: #d71f4b !important;
  color: white !important;
}

.list-fg-deepred > .list-group-item {
  color: #d71f4b;
}

.btn-red {
  background: #ea7882;
  color: white;
  border-color: #ea7882;
}
.btn-red.btn-outlined {
  color: #ea7882;
  background: none;
}
.btn-red.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-red.btn-outlined.btn-onlyOnHover:hover,
.btn-red.btn-outlined.btn-onlyOnHover:focus,
.btn-red.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-red.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-red.btn-outlined.btn-inverse:hover,
.btn-red.btn-outlined.btn-inverse:focus,
.btn-red.btn-outlined.btn-inverse.active {
  color: #ea7882;
  background: white;
}
.btn-red.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-red.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-red.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ea7882;
  color: white;
  border-color: #ea7882;
}
.btn-red.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-red.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-red.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #de2938;
  border-color: #ae1b28;
}
.btn-red:focus,
.btn-red.focus,
.btn-red:hover,
.btn-red.active {
  color: white;
  background: #f1a4ab;
  border-color: #f1a4ab;
}
.btn-red:active,
.btn-red.active,
.btn-red[aria-expanded="true"],
.btn-red.active:hover,
.btn-red.active:focus,
.btn-red[aria-expanded="true"]:hover,
.btn-red[aria-expanded="true"]:focus,
.open > .btn-red.dropdown-toggle {
  color: white;
  background: #de2938;
  border-color: #ae1b28;
  background-image: none;
}
.btn-red.dropdown-toggle + ul li.active a {
  color: white;
  background: #ea7882;
}
.btn-red.disabled,
.btn-red[disabled],
fieldset[disabled] .btn-red {
  pointer-events: none;
}
.btn-red .badge {
  color: #ea7882;
  background-color: #ea7882;
}

.menu-red ul li.active a,
.menu-red ul li.active a:hover {
  color: white;
  background: #ea7882 !important;
}

.nav-red > li.active > a,
.nav-red > rubix-menu > li.active > a,
.nav-red > rubix-nav-item > li.active > a {
  color: white;
  background: #ea7882;
  border-color: #ea7882;
}

.tab-red {
  border-color: #ea7882;
}
.tab-red > li.active > a {
  border-color: #ea7882;
  border-bottom-color: transparent;
}
.tab-red.nav-pills > li.active > a {
  background: #ea7882;
  color: white;
}

.rubix-panel-header.nav-inline .nav-red > li.active > a {
  border: 1px solid #ea7882;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-red > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-red {
  background: #ea7882 !important;
}
.bg-red table td,
.bg-red th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-red:focus {
  background: #ea7882 !important;
}

.bg-hover-red:hover {
  background: #ea7882 !important;
}

.fg-red {
  color: #ea7882;
}
.fg-red .nav-tabs > li.active > a {
  color: #ea7882;
}

.fg-tab-active-red .nav-tabs > li.active > a {
  color: #ea7882 !important;
}

.fg-focus-red:focus {
  color: #ea7882;
}

.fg-hover-red:hover {
  color: #ea7882;
}

.border-red {
  border-color: #ea7882 !important;
}
.border-red .rubix-timeline-body > ul {
  border-color: #ea7882;
}
.border-red.rubix-timeline-view:before {
  border-color: #ea7882;
}

.border-hover-red:hover {
  border-color: #ea7882 !important;
}

.border-focus-red:focus {
  border-color: #ea7882 !important;
}

.tl-red .rubix-timeline-body > ul > li:before {
  border-color: #ea7882;
}

.list-bg-red > .list-group-item.active {
  background: #ea7882 !important;
  color: white !important;
}

.list-fg-red > .list-group-item {
  color: #ea7882;
}

.btn-lightred {
  background: #f09fa6;
  color: white;
  border-color: #f09fa6;
}
.btn-lightred.btn-outlined {
  color: #f09fa6;
  background: none;
}
.btn-lightred.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightred.btn-outlined.btn-onlyOnHover:hover,
.btn-lightred.btn-outlined.btn-onlyOnHover:focus,
.btn-lightred.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightred.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightred.btn-outlined.btn-inverse:hover,
.btn-lightred.btn-outlined.btn-inverse:focus,
.btn-lightred.btn-outlined.btn-inverse.active {
  color: #f09fa6;
  background: white;
}
.btn-lightred.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightred.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightred.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #f09fa6;
  color: white;
  border-color: #f09fa6;
}
.btn-lightred.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightred.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightred.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #e4505c;
  border-color: #d52131;
}
.btn-lightred:focus,
.btn-lightred.focus,
.btn-lightred:hover,
.btn-lightred.active {
  color: white;
  background: #f7cbcf;
  border-color: #f7cbcf;
}
.btn-lightred:active,
.btn-lightred.active,
.btn-lightred[aria-expanded="true"],
.btn-lightred.active:hover,
.btn-lightred.active:focus,
.btn-lightred[aria-expanded="true"]:hover,
.btn-lightred[aria-expanded="true"]:focus,
.open > .btn-lightred.dropdown-toggle {
  color: white;
  background: #e4505c;
  border-color: #d52131;
  background-image: none;
}
.btn-lightred.dropdown-toggle + ul li.active a {
  color: white;
  background: #f09fa6;
}
.btn-lightred.disabled,
.btn-lightred[disabled],
fieldset[disabled] .btn-lightred {
  pointer-events: none;
}
.btn-lightred .badge {
  color: #f09fa6;
  background-color: #f09fa6;
}

.menu-lightred ul li.active a,
.menu-lightred ul li.active a:hover {
  color: white;
  background: #f09fa6 !important;
}

.nav-lightred > li.active > a,
.nav-lightred > rubix-menu > li.active > a,
.nav-lightred > rubix-nav-item > li.active > a {
  color: white;
  background: #f09fa6;
  border-color: #f09fa6;
}

.tab-lightred {
  border-color: #f09fa6;
}
.tab-lightred > li.active > a {
  border-color: #f09fa6;
  border-bottom-color: transparent;
}
.tab-lightred.nav-pills > li.active > a {
  background: #f09fa6;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightred > li.active > a {
  border: 1px solid #f09fa6;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightred > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightred {
  background: #f09fa6 !important;
}
.bg-lightred table td,
.bg-lightred th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightred:focus {
  background: #f09fa6 !important;
}

.bg-hover-lightred:hover {
  background: #f09fa6 !important;
}

.fg-lightred {
  color: #f09fa6;
}
.fg-lightred .nav-tabs > li.active > a {
  color: #f09fa6;
}

.fg-tab-active-lightred .nav-tabs > li.active > a {
  color: #f09fa6 !important;
}

.fg-focus-lightred:focus {
  color: #f09fa6;
}

.fg-hover-lightred:hover {
  color: #f09fa6;
}

.border-lightred {
  border-color: #f09fa6 !important;
}
.border-lightred .rubix-timeline-body > ul {
  border-color: #f09fa6;
}
.border-lightred.rubix-timeline-view:before {
  border-color: #f09fa6;
}

.border-hover-lightred:hover {
  border-color: #f09fa6 !important;
}

.border-focus-lightred:focus {
  border-color: #f09fa6 !important;
}

.tl-lightred .rubix-timeline-body > ul > li:before {
  border-color: #f09fa6;
}

.list-bg-lightred > .list-group-item.active {
  background: #f09fa6 !important;
  color: white !important;
}

.list-fg-lightred > .list-group-item {
  color: #f09fa6;
}

.btn-brightblue {
  background: #003bff;
  color: white;
  border-color: #003bff;
}
.btn-brightblue.btn-outlined {
  color: #003bff;
  background: none;
}
.btn-brightblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brightblue.btn-outlined.btn-onlyOnHover:hover,
.btn-brightblue.btn-outlined.btn-onlyOnHover:focus,
.btn-brightblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brightblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brightblue.btn-outlined.btn-inverse:hover,
.btn-brightblue.btn-outlined.btn-inverse:focus,
.btn-brightblue.btn-outlined.btn-inverse.active {
  color: #003bff;
  background: white;
}
.btn-brightblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brightblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brightblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #003bff;
  color: white;
  border-color: #003bff;
}
.btn-brightblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brightblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brightblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #0026a3;
  border-color: #001866;
}
.btn-brightblue:focus,
.btn-brightblue.focus,
.btn-brightblue:hover,
.btn-brightblue.active {
  color: white;
  background: #3362ff;
  border-color: #3362ff;
}
.btn-brightblue:active,
.btn-brightblue.active,
.btn-brightblue[aria-expanded="true"],
.btn-brightblue.active:hover,
.btn-brightblue.active:focus,
.btn-brightblue[aria-expanded="true"]:hover,
.btn-brightblue[aria-expanded="true"]:focus,
.open > .btn-brightblue.dropdown-toggle {
  color: white;
  background: #0026a3;
  border-color: #001866;
  background-image: none;
}
.btn-brightblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #003bff;
}
.btn-brightblue.disabled,
.btn-brightblue[disabled],
fieldset[disabled] .btn-brightblue {
  pointer-events: none;
}
.btn-brightblue .badge {
  color: #003bff;
  background-color: #003bff;
}

.menu-brightblue ul li.active a,
.menu-brightblue ul li.active a:hover {
  color: white;
  background: #003bff !important;
}

.nav-brightblue > li.active > a,
.nav-brightblue > rubix-menu > li.active > a,
.nav-brightblue > rubix-nav-item > li.active > a {
  color: white;
  background: #003bff;
  border-color: #003bff;
}

.tab-brightblue {
  border-color: #003bff;
}
.tab-brightblue > li.active > a {
  border-color: #003bff;
  border-bottom-color: transparent;
}
.tab-brightblue.nav-pills > li.active > a {
  background: #003bff;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brightblue > li.active > a {
  border: 1px solid #003bff;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brightblue > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brightblue {
  background: #003bff !important;
}
.bg-brightblue table td,
.bg-brightblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brightblue:focus {
  background: #003bff !important;
}

.bg-hover-brightblue:hover {
  background: #003bff !important;
}

.fg-brightblue {
  color: #003bff;
}
.fg-brightblue .nav-tabs > li.active > a {
  color: #003bff;
}

.fg-tab-active-brightblue .nav-tabs > li.active > a {
  color: #003bff !important;
}

.fg-focus-brightblue:focus {
  color: #003bff;
}

.fg-hover-brightblue:hover {
  color: #003bff;
}

.border-brightblue {
  border-color: #003bff !important;
}
.border-brightblue .rubix-timeline-body > ul {
  border-color: #003bff;
}
.border-brightblue.rubix-timeline-view:before {
  border-color: #003bff;
}

.border-hover-brightblue:hover {
  border-color: #003bff !important;
}

.border-focus-brightblue:focus {
  border-color: #003bff !important;
}

.tl-brightblue .rubix-timeline-body > ul > li:before {
  border-color: #003bff;
}

.list-bg-brightblue > .list-group-item.active {
  background: #003bff !important;
  color: white !important;
}

.list-fg-brightblue > .list-group-item {
  color: #003bff;
}

.btn-darkblue {
  background: #000e89;
  color: white;
  border-color: #000e89;
}
.btn-darkblue.btn-outlined {
  color: #000e89;
  background: none;
}
.btn-darkblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkblue.btn-outlined.btn-onlyOnHover:hover,
.btn-darkblue.btn-outlined.btn-onlyOnHover:focus,
.btn-darkblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkblue.btn-outlined.btn-inverse:hover,
.btn-darkblue.btn-outlined.btn-inverse:focus,
.btn-darkblue.btn-outlined.btn-inverse.active {
  color: #000e89;
  background: white;
}
.btn-darkblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #000e89;
  color: white;
  border-color: #000e89;
}
.btn-darkblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #1d62b3;
  border-color: #14457f;
}
.btn-darkblue:focus,
.btn-darkblue.focus,
.btn-darkblue:hover,
.btn-darkblue.active {
  color: white;
  background: #76abe9;
  border-color: #76abe9;
}
.btn-darkblue:active,
.btn-darkblue.active,
.btn-darkblue[aria-expanded="true"],
.btn-darkblue.active:hover,
.btn-darkblue.active:focus,
.btn-darkblue[aria-expanded="true"]:hover,
.btn-darkblue[aria-expanded="true"]:focus,
.open > .btn-darkblue.dropdown-toggle {
  color: white;
  background: #1d62b3;
  border-color: #14457f;
  background-image: none;
}
.btn-darkblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #000e89;
}
.btn-darkblue.disabled,
.btn-darkblue[disabled],
fieldset[disabled] .btn-darkblue {
  pointer-events: none;
}
.btn-darkblue .badge {
  color: #000e89;
  background-color: #000e89;
}

.menu-darkblue ul li.active a,
.menu-darkblue ul li.active a:hover {
  color: white;
  background: #000e89 !important;
}

.nav-darkblue > li.active > a,
.nav-darkblue > rubix-menu > li.active > a,
.nav-darkblue > rubix-nav-item > li.active > a {
  color: white;
  background: #000e89;
  border-color: #000e89;
}

.tab-darkblue {
  border-color: #000e89;
}
.tab-darkblue > li.active > a {
  border-color: #000e89;
  border-bottom-color: transparent;
}
.tab-darkblue.nav-pills > li.active > a {
  background: #000e89;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkblue > li.active > a {
  border: 1px solid #000e89;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkblue > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkblue {
  background: #079EDA !important;
}

.bg-custome-blue {
  background: #079EDA !important;
    border-color: #079EDA !important;
  border-radius: 10px;
}
.bg-custome-none {
  background: none !important;
  border: 2px solid #022144;
  color: #022144;
  border-color: #022144 !important;
  padding: 10px 50px !important;
  border-radius: 10px;
}
.bg-custome-none:hover {
  color: #022144 !important;
}

.bg-darkblue table td,
.bg-darkblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-darkblue.btn {
  border-color: #079EDA;
}

.bg-darkblue.btn-outlined {
  color: #022144;
  background-color: white !important;
}

.bg-darkblue.btn-outlined:active {
  background: #000e89 !important;
  color: white !important;
  border-color: #000e89;
}

.bg-darkblue.btn:active {
  background: #000e89 !important;
  border-color: #000e89;
}

.bg-focus-darkblue:focus {
  background: #000e89 !important;
}

.bg-hover-darkblue:hover {
  background: #000e89 !important;
}

.fg-darkblue {
  color: #000e89;
}
.fg-darkblue .nav-tabs > li.active > a {
  color: #000e89;
}

.fg-tab-active-darkblue .nav-tabs > li.active > a {
  color: #000e89 !important;
}

.fg-focus-darkblue:focus {
  color: #000e89;
}

.fg-hover-darkblue:hover {
  color: #000e89;
}

.border-darkblue {
  border-color: #000e89 !important;
}
.border-darkblue .rubix-timeline-body > ul {
  border-color: #000e89;
}
.border-darkblue.rubix-timeline-view:before {
  border-color: #000e89;
}

.border-hover-darkblue:hover {
  border-color: #000e89 !important;
}

.border-focus-darkblue:focus {
  border-color: #000e89 !important;
}

.tl-darkblue .rubix-timeline-body > ul > li:before {
  border-color: #000e89;
}

.list-bg-darkblue > .list-group-item.active {
  background: #000e89 !important;
  color: white !important;
}

.list-fg-darkblue > .list-group-item {
  color: #000e89;
}

.btn-blue {
  background: #79b0ec;
  color: white;
  border-color: #79b0ec;
}
.btn-blue.btn-outlined {
  color: #79b0ec;
  background: none;
}
.btn-blue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-blue.btn-outlined.btn-onlyOnHover:hover,
.btn-blue.btn-outlined.btn-onlyOnHover:focus,
.btn-blue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-blue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-blue.btn-outlined.btn-inverse:hover,
.btn-blue.btn-outlined.btn-inverse:focus,
.btn-blue.btn-outlined.btn-inverse.active {
  color: #79b0ec;
  background: white;
}
.btn-blue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-blue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-blue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #79b0ec;
  color: white;
  border-color: #79b0ec;
}
.btn-blue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-blue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-blue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2981e1;
  border-color: #1963b3;
}
.btn-blue:focus,
.btn-blue.focus,
.btn-blue:hover,
.btn-blue.active {
  color: white;
  background: #a6caf2;
  border-color: #a6caf2;
}
.btn-blue:active,
.btn-blue.active,
.btn-blue[aria-expanded="true"],
.btn-blue.active:hover,
.btn-blue.active:focus,
.btn-blue[aria-expanded="true"]:hover,
.btn-blue[aria-expanded="true"]:focus,
.open > .btn-blue.dropdown-toggle {
  color: white;
  background: #2981e1;
  border-color: #1963b3;
  background-image: none;
}
.btn-blue.dropdown-toggle + ul li.active a {
  color: white;
  background: #79b0ec;
}
.btn-blue.disabled,
.btn-blue[disabled],
fieldset[disabled] .btn-blue {
  pointer-events: none;
}
.btn-blue .badge {
  color: #79b0ec;
  background-color: #79b0ec;
}

.menu-blue ul li.active a,
.menu-blue ul li.active a:hover {
  color: white;
  background: #79b0ec !important;
}

.nav-blue > li.active > a,
.nav-blue > rubix-menu > li.active > a,
.nav-blue > rubix-nav-item > li.active > a {
  color: white;
  background: #79b0ec;
  border-color: #79b0ec;
}

.tab-blue {
  border-color: #79b0ec;
}
.tab-blue > li.active > a {
  border-color: #79b0ec;
  border-bottom-color: transparent;
}
.tab-blue.nav-pills > li.active > a {
  background: #79b0ec;
  color: white;
}

.rubix-panel-header.nav-inline .nav-blue > li.active > a {
  border: 1px solid #79b0ec;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-blue > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-blue {
  background: #079EDA !important;
}
.bg-blue table td,
.bg-blue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-blue:focus {
  background: #79b0ec !important;
}

.bg-hover-blue:hover {
  background: #79b0ec !important;
}

.fg-blue {
  color: #079EDA;
}
.fg-blue .nav-tabs > li.active > a {
  color: #79b0ec;
}

.fg-tab-active-blue .nav-tabs > li.active > a {
  color: #79b0ec !important;
}

.fg-focus-blue:focus {
  color: #79b0ec;
}

.fg-hover-blue:hover {
  color: #79b0ec;
}

.border-blue {
  border-color: #79b0ec !important;
}
.border-blue .rubix-timeline-body > ul {
  border-color: #79b0ec;
}
.border-blue.rubix-timeline-view:before {
  border-color: #79b0ec;
}

.border-hover-blue:hover {
  border-color: #79b0ec !important;
}

.border-focus-blue:focus {
  border-color: #79b0ec !important;
}

.tl-blue .rubix-timeline-body > ul > li:before {
  border-color: #79b0ec;
}

.list-bg-blue > .list-group-item.active {
  background: #79b0ec !important;
  color: white !important;
}

.list-fg-blue > .list-group-item {
  color: #79b0ec;
}

.btn-lightblue50 {
  background: #d2e0eb;
  color: white;
  border-color: #d2e0eb;
}
.btn-lightblue50.btn-outlined {
  color: #d2e0eb;
  background: none;
}
.btn-lightblue50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightblue50.btn-outlined.btn-onlyOnHover:hover,
.btn-lightblue50.btn-outlined.btn-onlyOnHover:focus,
.btn-lightblue50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightblue50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightblue50.btn-outlined.btn-inverse:hover,
.btn-lightblue50.btn-outlined.btn-inverse:focus,
.btn-lightblue50.btn-outlined.btn-inverse.active {
  color: #d2e0eb;
  background: white;
}
.btn-lightblue50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightblue50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightblue50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #d2e0eb;
  color: white;
  border-color: #d2e0eb;
}
.btn-lightblue50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightblue50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightblue50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #92b4cf;
  border-color: #6897bc;
}
.btn-lightblue50:focus,
.btn-lightblue50.focus,
.btn-lightblue50:hover,
.btn-lightblue50.active {
  color: white;
  background: #f5f8fb;
  border-color: #f5f8fb;
}
.btn-lightblue50:active,
.btn-lightblue50.active,
.btn-lightblue50[aria-expanded="true"],
.btn-lightblue50.active:hover,
.btn-lightblue50.active:focus,
.btn-lightblue50[aria-expanded="true"]:hover,
.btn-lightblue50[aria-expanded="true"]:focus,
.open > .btn-lightblue50.dropdown-toggle {
  color: white;
  background: #92b4cf;
  border-color: #6897bc;
  background-image: none;
}
.btn-lightblue50.dropdown-toggle + ul li.active a {
  color: white;
  background: #d2e0eb;
}
.btn-lightblue50.disabled,
.btn-lightblue50[disabled],
fieldset[disabled] .btn-lightblue50 {
  pointer-events: none;
}
.btn-lightblue50 .badge {
  color: #d2e0eb;
  background-color: #d2e0eb;
}

.menu-lightblue50 ul li.active a,
.menu-lightblue50 ul li.active a:hover {
  color: white;
  background: #d2e0eb !important;
}

.nav-lightblue50 > li.active > a,
.nav-lightblue50 > rubix-menu > li.active > a,
.nav-lightblue50 > rubix-nav-item > li.active > a {
  color: white;
  background: #d2e0eb;
  border-color: #d2e0eb;
}

.tab-lightblue50 {
  border-color: #d2e0eb;
}
.tab-lightblue50 > li.active > a {
  border-color: #d2e0eb;
  border-bottom-color: transparent;
}
.tab-lightblue50.nav-pills > li.active > a {
  background: #d2e0eb;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightblue50 > li.active > a {
  border: 1px solid #d2e0eb;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightblue50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightblue50 {
  background: #d2e0eb !important;
}
.bg-lightblue50 table td,
.bg-lightblue50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightblue50:focus {
  background: #d2e0eb !important;
}

.bg-hover-lightblue50:hover {
  background: #d2e0eb !important;
}

.fg-lightblue50 {
  color: #d2e0eb;
}
.fg-lightblue50 .nav-tabs > li.active > a {
  color: #d2e0eb;
}

.fg-tab-active-lightblue50 .nav-tabs > li.active > a {
  color: #d2e0eb !important;
}

.fg-focus-lightblue50:focus {
  color: #d2e0eb;
}

.fg-hover-lightblue50:hover {
  color: #d2e0eb;
}

.border-lightblue50 {
  border-color: #d2e0eb !important;
}
.border-lightblue50 .rubix-timeline-body > ul {
  border-color: #d2e0eb;
}
.border-lightblue50.rubix-timeline-view:before {
  border-color: #d2e0eb;
}

.border-hover-lightblue50:hover {
  border-color: #d2e0eb !important;
}

.border-focus-lightblue50:focus {
  border-color: #d2e0eb !important;
}

.tl-lightblue50 .rubix-timeline-body > ul > li:before {
  border-color: #d2e0eb;
}

.list-bg-lightblue50 > .list-group-item.active {
  background: #d2e0eb !important;
  color: white !important;
}

.list-fg-lightblue50 > .list-group-item {
  color: #d2e0eb;
}

.btn-lightblue {
  background: #a0c7f2;
  color: white;
  border-color: #a0c7f2;
}
.btn-lightblue.btn-outlined {
  color: #a0c7f2;
  background: none;
}
.btn-lightblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightblue.btn-outlined.btn-onlyOnHover:hover,
.btn-lightblue.btn-outlined.btn-onlyOnHover:focus,
.btn-lightblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightblue.btn-outlined.btn-inverse:hover,
.btn-lightblue.btn-outlined.btn-inverse:focus,
.btn-lightblue.btn-outlined.btn-inverse.active {
  color: #a0c7f2;
  background: white;
}
.btn-lightblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #a0c7f2;
  color: white;
  border-color: #a0c7f2;
}
.btn-lightblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #4f97e7;
  border-color: #1e78db;
}
.btn-lightblue:focus,
.btn-lightblue.focus,
.btn-lightblue:hover,
.btn-lightblue.active {
  color: white;
  background: #cde1f8;
  border-color: #cde1f8;
}
.btn-lightblue:active,
.btn-lightblue.active,
.btn-lightblue[aria-expanded="true"],
.btn-lightblue.active:hover,
.btn-lightblue.active:focus,
.btn-lightblue[aria-expanded="true"]:hover,
.btn-lightblue[aria-expanded="true"]:focus,
.open > .btn-lightblue.dropdown-toggle {
  color: white;
  background: #4f97e7;
  border-color: #1e78db;
  background-image: none;
}
.btn-lightblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #a0c7f2;
}
.btn-lightblue.disabled,
.btn-lightblue[disabled],
fieldset[disabled] .btn-lightblue {
  pointer-events: none;
}
.btn-lightblue .badge {
  color: #a0c7f2;
  background-color: #a0c7f2;
}

.menu-lightblue ul li.active a,
.menu-lightblue ul li.active a:hover {
  color: white;
  background: #a0c7f2 !important;
}

.nav-lightblue > li.active > a,
.nav-lightblue > rubix-menu > li.active > a,
.nav-lightblue > rubix-nav-item > li.active > a {
  color: white;
  background: #a0c7f2;
  border-color: #a0c7f2;
}

.tab-lightblue {
  border-color: #a0c7f2;
}
.tab-lightblue > li.active > a {
  border-color: #a0c7f2;
  border-bottom-color: transparent;
}
.tab-lightblue.nav-pills > li.active > a {
  background: #a0c7f2;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightblue > li.active > a {
  border: 1px solid #a0c7f2;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightblue > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightblue {
  background: #a0c7f2 !important;
}
.bg-lightblue table td,
.bg-lightblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightblue:focus {
  background: #a0c7f2 !important;
}

.bg-hover-lightblue:hover {
  background: #a0c7f2 !important;
}

.fg-lightblue {
  color: #a0c7f2;
}
.fg-lightblue .nav-tabs > li.active > a {
  color: #a0c7f2;
}

.fg-tab-active-lightblue .nav-tabs > li.active > a {
  color: #a0c7f2 !important;
}

.fg-focus-lightblue:focus {
  color: #a0c7f2;
}

.fg-hover-lightblue:hover {
  color: #a0c7f2;
}

.border-lightblue {
  border-color: #a0c7f2 !important;
}
.border-lightblue .rubix-timeline-body > ul {
  border-color: #a0c7f2;
}
.border-lightblue.rubix-timeline-view:before {
  border-color: #a0c7f2;
}

.border-hover-lightblue:hover {
  border-color: #a0c7f2 !important;
}

.border-focus-lightblue:focus {
  border-color: #a0c7f2 !important;
}

.tl-lightblue .rubix-timeline-body > ul > li:before {
  border-color: #a0c7f2;
}

.list-bg-lightblue > .list-group-item.active {
  background: #a0c7f2 !important;
  color: white !important;
}

.list-fg-lightblue > .list-group-item {
  color: #a0c7f2;
}

.btn-hoverblue {
  background: #e5effb;
  color: white;
  border-color: #e5effb;
}
.btn-hoverblue.btn-outlined {
  color: #e5effb;
  background: none;
}
.btn-hoverblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-hoverblue.btn-outlined.btn-onlyOnHover:hover,
.btn-hoverblue.btn-outlined.btn-onlyOnHover:focus,
.btn-hoverblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-hoverblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-hoverblue.btn-outlined.btn-inverse:hover,
.btn-hoverblue.btn-outlined.btn-inverse:focus,
.btn-hoverblue.btn-outlined.btn-inverse.active {
  color: #e5effb;
  background: white;
}
.btn-hoverblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-hoverblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-hoverblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #e5effb;
  color: white;
  border-color: #e5effb;
}
.btn-hoverblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-hoverblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-hoverblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #95beef;
  border-color: #609de7;
}
.btn-hoverblue:focus,
.btn-hoverblue.focus,
.btn-hoverblue:hover,
.btn-hoverblue.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-hoverblue:active,
.btn-hoverblue.active,
.btn-hoverblue[aria-expanded="true"],
.btn-hoverblue.active:hover,
.btn-hoverblue.active:focus,
.btn-hoverblue[aria-expanded="true"]:hover,
.btn-hoverblue[aria-expanded="true"]:focus,
.open > .btn-hoverblue.dropdown-toggle {
  color: white;
  background: #95beef;
  border-color: #609de7;
  background-image: none;
}
.btn-hoverblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #e5effb;
}
.btn-hoverblue.disabled,
.btn-hoverblue[disabled],
fieldset[disabled] .btn-hoverblue {
  pointer-events: none;
}
.btn-hoverblue .badge {
  color: #e5effb;
  background-color: #e5effb;
}

.menu-hoverblue ul li.active a,
.menu-hoverblue ul li.active a:hover {
  color: white;
  background: #e5effb !important;
}

.nav-hoverblue > li.active > a,
.nav-hoverblue > rubix-menu > li.active > a,
.nav-hoverblue > rubix-nav-item > li.active > a {
  color: white;
  background: #e5effb;
  border-color: #e5effb;
}

.tab-hoverblue {
  border-color: #e5effb;
}
.tab-hoverblue > li.active > a {
  border-color: #e5effb;
  border-bottom-color: transparent;
}
.tab-hoverblue.nav-pills > li.active > a {
  background: #e5effb;
  color: white;
}

.rubix-panel-header.nav-inline .nav-hoverblue > li.active > a {
  border: 1px solid #e5effb;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-hoverblue > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-hoverblue {
  background: #e5effb !important;
}
.bg-hoverblue table td,
.bg-hoverblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-hoverblue:focus {
  background: #e5effb !important;
}

.bg-hover-hoverblue:hover {
  background: #e5effb !important;
}

.fg-hoverblue {
  color: #e5effb;
}
.fg-hoverblue .nav-tabs > li.active > a {
  color: #e5effb;
}

.fg-tab-active-hoverblue .nav-tabs > li.active > a {
  color: #e5effb !important;
}

.fg-focus-hoverblue:focus {
  color: #e5effb;
}

.fg-hover-hoverblue:hover {
  color: #e5effb;
}

.border-hoverblue {
  border-color: #e5effb !important;
}
.border-hoverblue .rubix-timeline-body > ul {
  border-color: #e5effb;
}
.border-hoverblue.rubix-timeline-view:before {
  border-color: #e5effb;
}

.border-hover-hoverblue:hover {
  border-color: #e5effb !important;
}

.border-focus-hoverblue:focus {
  border-color: #e5effb !important;
}

.tl-hoverblue .rubix-timeline-body > ul > li:before {
  border-color: #e5effb;
}

.list-bg-hoverblue > .list-group-item.active {
  background: #e5effb !important;
  color: white !important;
}

.list-fg-hoverblue > .list-group-item {
  color: #e5effb;
}

.btn-purple {
  background: #b4a1dd;
  color: white;
  border-color: #b4a1dd;
}
.btn-purple.btn-outlined {
  color: #b4a1dd;
  background: none;
}
.btn-purple.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-purple.btn-outlined.btn-onlyOnHover:hover,
.btn-purple.btn-outlined.btn-onlyOnHover:focus,
.btn-purple.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-purple.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-purple.btn-outlined.btn-inverse:hover,
.btn-purple.btn-outlined.btn-inverse:focus,
.btn-purple.btn-outlined.btn-inverse.active {
  color: #b4a1dd;
  background: white;
}
.btn-purple.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-purple.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-purple.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #b4a1dd;
  color: white;
  border-color: #b4a1dd;
}
.btn-purple.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-purple.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-purple.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #7e5ec5;
  border-color: #5f3da8;
}
.btn-purple:focus,
.btn-purple.focus,
.btn-purple:hover,
.btn-purple.active {
  color: white;
  background: #d2c6eb;
  border-color: #d2c6eb;
}
.btn-purple:active,
.btn-purple.active,
.btn-purple[aria-expanded="true"],
.btn-purple.active:hover,
.btn-purple.active:focus,
.btn-purple[aria-expanded="true"]:hover,
.btn-purple[aria-expanded="true"]:focus,
.open > .btn-purple.dropdown-toggle {
  color: white;
  background: #7e5ec5;
  border-color: #5f3da8;
  background-image: none;
}
.btn-purple.dropdown-toggle + ul li.active a {
  color: white;
  background: #b4a1dd;
}
.btn-purple.disabled,
.btn-purple[disabled],
fieldset[disabled] .btn-purple {
  pointer-events: none;
}
.btn-purple .badge {
  color: #b4a1dd;
  background-color: #b4a1dd;
}

.menu-purple ul li.active a,
.menu-purple ul li.active a:hover {
  color: white;
  background: #b4a1dd !important;
}

.nav-purple > li.active > a,
.nav-purple > rubix-menu > li.active > a,
.nav-purple > rubix-nav-item > li.active > a {
  color: white;
  background: #b4a1dd;
  border-color: #b4a1dd;
}

.tab-purple {
  border-color: #b4a1dd;
}
.tab-purple > li.active > a {
  border-color: #b4a1dd;
  border-bottom-color: transparent;
}
.tab-purple.nav-pills > li.active > a {
  background: #b4a1dd;
  color: white;
}

.rubix-panel-header.nav-inline .nav-purple > li.active > a {
  border: 1px solid #b4a1dd;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-purple > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-purple {
  background: #b4a1dd !important;
}
.bg-purple table td,
.bg-purple th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-purple:focus {
  background: #b4a1dd !important;
}

.bg-hover-purple:hover {
  background: #b4a1dd !important;
}

.fg-purple {
  color: #b4a1dd;
}
.fg-purple .nav-tabs > li.active > a {
  color: #b4a1dd;
}

.fg-tab-active-purple .nav-tabs > li.active > a {
  color: #b4a1dd !important;
}

.fg-focus-purple:focus {
  color: #b4a1dd;
}

.fg-hover-purple:hover {
  color: #b4a1dd;
}

.border-purple {
  border-color: #b4a1dd !important;
}
.border-purple .rubix-timeline-body > ul {
  border-color: #b4a1dd;
}
.border-purple.rubix-timeline-view:before {
  border-color: #b4a1dd;
}

.border-hover-purple:hover {
  border-color: #b4a1dd !important;
}

.border-focus-purple:focus {
  border-color: #b4a1dd !important;
}

.tl-purple .rubix-timeline-body > ul > li:before {
  border-color: #b4a1dd;
}

.list-bg-purple > .list-group-item.active {
  background: #b4a1dd !important;
  color: white !important;
}

.list-fg-purple > .list-group-item {
  color: #b4a1dd;
}

.btn-lightpurple50 {
  background: #c1b2e3;
  color: white;
  border-color: #c1b2e3;
}
.btn-lightpurple50.btn-outlined {
  color: #c1b2e3;
  background: none;
}
.btn-lightpurple50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightpurple50.btn-outlined.btn-onlyOnHover:hover,
.btn-lightpurple50.btn-outlined.btn-onlyOnHover:focus,
.btn-lightpurple50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightpurple50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightpurple50.btn-outlined.btn-inverse:hover,
.btn-lightpurple50.btn-outlined.btn-inverse:focus,
.btn-lightpurple50.btn-outlined.btn-inverse.active {
  color: #c1b2e3;
  background: white;
}
.btn-lightpurple50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightpurple50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightpurple50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #c1b2e3;
  color: white;
  border-color: #c1b2e3;
}
.btn-lightpurple50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightpurple50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightpurple50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #8b6fcb;
  border-color: #6743b9;
}
.btn-lightpurple50:focus,
.btn-lightpurple50.focus,
.btn-lightpurple50:hover,
.btn-lightpurple50.active {
  color: white;
  background: #dfd7f1;
  border-color: #dfd7f1;
}
.btn-lightpurple50:active,
.btn-lightpurple50.active,
.btn-lightpurple50[aria-expanded="true"],
.btn-lightpurple50.active:hover,
.btn-lightpurple50.active:focus,
.btn-lightpurple50[aria-expanded="true"]:hover,
.btn-lightpurple50[aria-expanded="true"]:focus,
.open > .btn-lightpurple50.dropdown-toggle {
  color: white;
  background: #8b6fcb;
  border-color: #6743b9;
  background-image: none;
}
.btn-lightpurple50.dropdown-toggle + ul li.active a {
  color: white;
  background: #c1b2e3;
}
.btn-lightpurple50.disabled,
.btn-lightpurple50[disabled],
fieldset[disabled] .btn-lightpurple50 {
  pointer-events: none;
}
.btn-lightpurple50 .badge {
  color: #c1b2e3;
  background-color: #c1b2e3;
}

.menu-lightpurple50 ul li.active a,
.menu-lightpurple50 ul li.active a:hover {
  color: white;
  background: #c1b2e3 !important;
}

.nav-lightpurple50 > li.active > a,
.nav-lightpurple50 > rubix-menu > li.active > a,
.nav-lightpurple50 > rubix-nav-item > li.active > a {
  color: white;
  background: #c1b2e3;
  border-color: #c1b2e3;
}

.tab-lightpurple50 {
  border-color: #c1b2e3;
}
.tab-lightpurple50 > li.active > a {
  border-color: #c1b2e3;
  border-bottom-color: transparent;
}
.tab-lightpurple50.nav-pills > li.active > a {
  background: #c1b2e3;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightpurple50 > li.active > a {
  border: 1px solid #c1b2e3;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightpurple50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightpurple50 {
  background: #c1b2e3 !important;
}
.bg-lightpurple50 table td,
.bg-lightpurple50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightpurple50:focus {
  background: #c1b2e3 !important;
}

.bg-hover-lightpurple50:hover {
  background: #c1b2e3 !important;
}

.fg-lightpurple50 {
  color: #c1b2e3;
}
.fg-lightpurple50 .nav-tabs > li.active > a {
  color: #c1b2e3;
}

.fg-tab-active-lightpurple50 .nav-tabs > li.active > a {
  color: #c1b2e3 !important;
}

.fg-focus-lightpurple50:focus {
  color: #c1b2e3;
}

.fg-hover-lightpurple50:hover {
  color: #c1b2e3;
}

.border-lightpurple50 {
  border-color: #c1b2e3 !important;
}
.border-lightpurple50 .rubix-timeline-body > ul {
  border-color: #c1b2e3;
}
.border-lightpurple50.rubix-timeline-view:before {
  border-color: #c1b2e3;
}

.border-hover-lightpurple50:hover {
  border-color: #c1b2e3 !important;
}

.border-focus-lightpurple50:focus {
  border-color: #c1b2e3 !important;
}

.tl-lightpurple50 .rubix-timeline-body > ul > li:before {
  border-color: #c1b2e3;
}

.list-bg-lightpurple50 > .list-group-item.active {
  background: #c1b2e3 !important;
  color: white !important;
}

.list-fg-lightpurple50 > .list-group-item {
  color: #c1b2e3;
}

.btn-lightpurple {
  background: #d3c9eb;
  color: white;
  border-color: #d3c9eb;
}
.btn-lightpurple.btn-outlined {
  color: #d3c9eb;
  background: none;
}
.btn-lightpurple.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightpurple.btn-outlined.btn-onlyOnHover:hover,
.btn-lightpurple.btn-outlined.btn-onlyOnHover:focus,
.btn-lightpurple.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightpurple.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightpurple.btn-outlined.btn-inverse:hover,
.btn-lightpurple.btn-outlined.btn-inverse:focus,
.btn-lightpurple.btn-outlined.btn-inverse.active {
  color: #d3c9eb;
  background: white;
}
.btn-lightpurple.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightpurple.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightpurple.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #d3c9eb;
  color: white;
  border-color: #d3c9eb;
}
.btn-lightpurple.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightpurple.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightpurple.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #9c86d2;
  border-color: #7859c2;
}
.btn-lightpurple:focus,
.btn-lightpurple.focus,
.btn-lightpurple:hover,
.btn-lightpurple.active {
  color: white;
  background: #f1eef9;
  border-color: #f1eef9;
}
.btn-lightpurple:active,
.btn-lightpurple.active,
.btn-lightpurple[aria-expanded="true"],
.btn-lightpurple.active:hover,
.btn-lightpurple.active:focus,
.btn-lightpurple[aria-expanded="true"]:hover,
.btn-lightpurple[aria-expanded="true"]:focus,
.open > .btn-lightpurple.dropdown-toggle {
  color: white;
  background: #9c86d2;
  border-color: #7859c2;
  background-image: none;
}
.btn-lightpurple.dropdown-toggle + ul li.active a {
  color: white;
  background: #d3c9eb;
}
.btn-lightpurple.disabled,
.btn-lightpurple[disabled],
fieldset[disabled] .btn-lightpurple {
  pointer-events: none;
}
.btn-lightpurple .badge {
  color: #d3c9eb;
  background-color: #d3c9eb;
}

.menu-lightpurple ul li.active a,
.menu-lightpurple ul li.active a:hover {
  color: white;
  background: #d3c9eb !important;
}

.nav-lightpurple > li.active > a,
.nav-lightpurple > rubix-menu > li.active > a,
.nav-lightpurple > rubix-nav-item > li.active > a {
  color: white;
  background: #d3c9eb;
  border-color: #d3c9eb;
}

.tab-lightpurple {
  border-color: #d3c9eb;
}
.tab-lightpurple > li.active > a {
  border-color: #d3c9eb;
  border-bottom-color: transparent;
}
.tab-lightpurple.nav-pills > li.active > a {
  background: #d3c9eb;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightpurple > li.active > a {
  border: 1px solid #d3c9eb;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightpurple > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightpurple {
  background: #d3c9eb !important;
}
.bg-lightpurple table td,
.bg-lightpurple th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightpurple:focus {
  background: #d3c9eb !important;
}

.bg-hover-lightpurple:hover {
  background: #d3c9eb !important;
}

.fg-lightpurple {
  color: #d3c9eb;
}
.fg-lightpurple .nav-tabs > li.active > a {
  color: #d3c9eb;
}

.fg-tab-active-lightpurple .nav-tabs > li.active > a {
  color: #d3c9eb !important;
}

.fg-focus-lightpurple:focus {
  color: #d3c9eb;
}

.fg-hover-lightpurple:hover {
  color: #d3c9eb;
}

.border-lightpurple {
  border-color: #d3c9eb !important;
}
.border-lightpurple .rubix-timeline-body > ul {
  border-color: #d3c9eb;
}
.border-lightpurple.rubix-timeline-view:before {
  border-color: #d3c9eb;
}

.border-hover-lightpurple:hover {
  border-color: #d3c9eb !important;
}

.border-focus-lightpurple:focus {
  border-color: #d3c9eb !important;
}

.tl-lightpurple .rubix-timeline-body > ul > li:before {
  border-color: #d3c9eb;
}

.list-bg-lightpurple > .list-group-item.active {
  background: #d3c9eb !important;
  color: white !important;
}

.list-fg-lightpurple > .list-group-item {
  color: #d3c9eb;
}

.btn-darkbrown {
  background: #ab4f45;
  color: white;
  border-color: #ab4f45;
}
.btn-darkbrown.btn-outlined {
  color: #ab4f45;
  background: none;
}
.btn-darkbrown.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkbrown.btn-outlined.btn-onlyOnHover:hover,
.btn-darkbrown.btn-outlined.btn-onlyOnHover:focus,
.btn-darkbrown.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkbrown.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkbrown.btn-outlined.btn-inverse:hover,
.btn-darkbrown.btn-outlined.btn-inverse:focus,
.btn-darkbrown.btn-outlined.btn-inverse.active {
  color: #ab4f45;
  background: white;
}
.btn-darkbrown.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkbrown.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkbrown.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ab4f45;
  color: white;
  border-color: #ab4f45;
}
.btn-darkbrown.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkbrown.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkbrown.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #6a312b;
  border-color: #3e1d19;
}
.btn-darkbrown:focus,
.btn-darkbrown.focus,
.btn-darkbrown:hover,
.btn-darkbrown.active {
  color: white;
  background: #c06c63;
  border-color: #c06c63;
}
.btn-darkbrown:active,
.btn-darkbrown.active,
.btn-darkbrown[aria-expanded="true"],
.btn-darkbrown.active:hover,
.btn-darkbrown.active:focus,
.btn-darkbrown[aria-expanded="true"]:hover,
.btn-darkbrown[aria-expanded="true"]:focus,
.open > .btn-darkbrown.dropdown-toggle {
  color: white;
  background: #6a312b;
  border-color: #3e1d19;
  background-image: none;
}
.btn-darkbrown.dropdown-toggle + ul li.active a {
  color: white;
  background: #ab4f45;
}
.btn-darkbrown.disabled,
.btn-darkbrown[disabled],
fieldset[disabled] .btn-darkbrown {
  pointer-events: none;
}
.btn-darkbrown .badge {
  color: #ab4f45;
  background-color: #ab4f45;
}

.menu-darkbrown ul li.active a,
.menu-darkbrown ul li.active a:hover {
  color: white;
  background: #ab4f45 !important;
}

.nav-darkbrown > li.active > a,
.nav-darkbrown > rubix-menu > li.active > a,
.nav-darkbrown > rubix-nav-item > li.active > a {
  color: white;
  background: #ab4f45;
  border-color: #ab4f45;
}

.tab-darkbrown {
  border-color: #ab4f45;
}
.tab-darkbrown > li.active > a {
  border-color: #ab4f45;
  border-bottom-color: transparent;
}
.tab-darkbrown.nav-pills > li.active > a {
  background: #ab4f45;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkbrown > li.active > a {
  border: 1px solid #ab4f45;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkbrown > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkbrown {
  background: #ab4f45 !important;
}
.bg-darkbrown table td,
.bg-darkbrown th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkbrown:focus {
  background: #ab4f45 !important;
}

.bg-hover-darkbrown:hover {
  background: #ab4f45 !important;
}

.fg-darkbrown {
  color: #ab4f45;
}
.fg-darkbrown .nav-tabs > li.active > a {
  color: #ab4f45;
}

.fg-tab-active-darkbrown .nav-tabs > li.active > a {
  color: #ab4f45 !important;
}

.fg-focus-darkbrown:focus {
  color: #ab4f45;
}

.fg-hover-darkbrown:hover {
  color: #ab4f45;
}

.border-darkbrown {
  border-color: #ab4f45 !important;
}
.border-darkbrown .rubix-timeline-body > ul {
  border-color: #ab4f45;
}
.border-darkbrown.rubix-timeline-view:before {
  border-color: #ab4f45;
}

.border-hover-darkbrown:hover {
  border-color: #ab4f45 !important;
}

.border-focus-darkbrown:focus {
  border-color: #ab4f45 !important;
}

.tl-darkbrown .rubix-timeline-body > ul > li:before {
  border-color: #ab4f45;
}

.list-bg-darkbrown > .list-group-item.active {
  background: #ab4f45 !important;
  color: white !important;
}

.list-fg-darkbrown > .list-group-item {
  color: #ab4f45;
}

.btn-brown {
  background: #a8553a;
  color: white;
  border-color: #a8553a;
}
.btn-brown.btn-outlined {
  color: #a8553a;
  background: none;
}
.btn-brown.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brown.btn-outlined.btn-onlyOnHover:hover,
.btn-brown.btn-outlined.btn-onlyOnHover:focus,
.btn-brown.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brown.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brown.btn-outlined.btn-inverse:hover,
.btn-brown.btn-outlined.btn-inverse:focus,
.btn-brown.btn-outlined.btn-inverse.active {
  color: #a8553a;
  background: white;
}
.btn-brown.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brown.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brown.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #a8553a;
  color: white;
  border-color: #a8553a;
}
.btn-brown.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brown.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brown.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #643222;
  border-color: #361b13;
}
.btn-brown:focus,
.btn-brown.focus,
.btn-brown:hover,
.btn-brown.active {
  color: white;
  background: #c36e52;
  border-color: #c36e52;
}
.btn-brown:active,
.btn-brown.active,
.btn-brown[aria-expanded="true"],
.btn-brown.active:hover,
.btn-brown.active:focus,
.btn-brown[aria-expanded="true"]:hover,
.btn-brown[aria-expanded="true"]:focus,
.open > .btn-brown.dropdown-toggle {
  color: white;
  background: #643222;
  border-color: #361b13;
  background-image: none;
}
.btn-brown.dropdown-toggle + ul li.active a {
  color: white;
  background: #a8553a;
}
.btn-brown.disabled,
.btn-brown[disabled],
fieldset[disabled] .btn-brown {
  pointer-events: none;
}
.btn-brown .badge {
  color: #a8553a;
  background-color: #a8553a;
}

.menu-brown ul li.active a,
.menu-brown ul li.active a:hover {
  color: white;
  background: #a8553a !important;
}

.nav-brown > li.active > a,
.nav-brown > rubix-menu > li.active > a,
.nav-brown > rubix-nav-item > li.active > a {
  color: white;
  background: #a8553a;
  border-color: #a8553a;
}

.tab-brown {
  border-color: #a8553a;
}
.tab-brown > li.active > a {
  border-color: #a8553a;
  border-bottom-color: transparent;
}
.tab-brown.nav-pills > li.active > a {
  background: #a8553a;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brown > li.active > a {
  border: 1px solid #a8553a;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brown > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brown {
  background: #a8553a !important;
}
.bg-brown table td,
.bg-brown th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brown:focus {
  background: #a8553a !important;
}

.bg-hover-brown:hover {
  background: #a8553a !important;
}

.fg-brown {
  color: #a8553a;
}
.fg-brown .nav-tabs > li.active > a {
  color: #a8553a;
}

.fg-tab-active-brown .nav-tabs > li.active > a {
  color: #a8553a !important;
}

.fg-focus-brown:focus {
  color: #a8553a;
}

.fg-hover-brown:hover {
  color: #a8553a;
}

.border-brown {
  border-color: #a8553a !important;
}
.border-brown .rubix-timeline-body > ul {
  border-color: #a8553a;
}
.border-brown.rubix-timeline-view:before {
  border-color: #a8553a;
}

.border-hover-brown:hover {
  border-color: #a8553a !important;
}

.border-focus-brown:focus {
  border-color: #a8553a !important;
}

.tl-brown .rubix-timeline-body > ul > li:before {
  border-color: #a8553a;
}

.list-bg-brown > .list-group-item.active {
  background: #a8553a !important;
  color: white !important;
}

.list-fg-brown > .list-group-item {
  color: #a8553a;
}

.btn-brown75 {
  background: #c36849;
  color: white;
  border-color: #c36849;
}
.btn-brown75.btn-outlined {
  color: #c36849;
  background: none;
}
.btn-brown75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brown75.btn-outlined.btn-onlyOnHover:hover,
.btn-brown75.btn-outlined.btn-onlyOnHover:focus,
.btn-brown75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brown75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brown75.btn-outlined.btn-inverse:hover,
.btn-brown75.btn-outlined.btn-inverse:focus,
.btn-brown75.btn-outlined.btn-inverse.active {
  color: #c36849;
  background: white;
}
.btn-brown75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brown75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brown75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #c36849;
  color: white;
  border-color: #c36849;
}
.btn-brown75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brown75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brown75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #85422c;
  border-color: #562b1d;
}
.btn-brown75:focus,
.btn-brown75.focus,
.btn-brown75:hover,
.btn-brown75.active {
  color: white;
  background: #d0886f;
  border-color: #d0886f;
}
.btn-brown75:active,
.btn-brown75.active,
.btn-brown75[aria-expanded="true"],
.btn-brown75.active:hover,
.btn-brown75.active:focus,
.btn-brown75[aria-expanded="true"]:hover,
.btn-brown75[aria-expanded="true"]:focus,
.open > .btn-brown75.dropdown-toggle {
  color: white;
  background: #85422c;
  border-color: #562b1d;
  background-image: none;
}
.btn-brown75.dropdown-toggle + ul li.active a {
  color: white;
  background: #c36849;
}
.btn-brown75.disabled,
.btn-brown75[disabled],
fieldset[disabled] .btn-brown75 {
  pointer-events: none;
}
.btn-brown75 .badge {
  color: #c36849;
  background-color: #c36849;
}

.menu-brown75 ul li.active a,
.menu-brown75 ul li.active a:hover {
  color: white;
  background: #c36849 !important;
}

.nav-brown75 > li.active > a,
.nav-brown75 > rubix-menu > li.active > a,
.nav-brown75 > rubix-nav-item > li.active > a {
  color: white;
  background: #c36849;
  border-color: #c36849;
}

.tab-brown75 {
  border-color: #c36849;
}
.tab-brown75 > li.active > a {
  border-color: #c36849;
  border-bottom-color: transparent;
}
.tab-brown75.nav-pills > li.active > a {
  background: #c36849;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brown75 > li.active > a {
  border: 1px solid #c36849;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brown75 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brown75 {
  background: #c36849 !important;
}
.bg-brown75 table td,
.bg-brown75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brown75:focus {
  background: #c36849 !important;
}

.bg-hover-brown75:hover {
  background: #c36849 !important;
}

.fg-brown75 {
  color: #c36849;
}
.fg-brown75 .nav-tabs > li.active > a {
  color: #c36849;
}

.fg-tab-active-brown75 .nav-tabs > li.active > a {
  color: #c36849 !important;
}

.fg-focus-brown75:focus {
  color: #c36849;
}

.fg-hover-brown75:hover {
  color: #c36849;
}

.border-brown75 {
  border-color: #c36849 !important;
}
.border-brown75 .rubix-timeline-body > ul {
  border-color: #c36849;
}
.border-brown75.rubix-timeline-view:before {
  border-color: #c36849;
}

.border-hover-brown75:hover {
  border-color: #c36849 !important;
}

.border-focus-brown75:focus {
  border-color: #c36849 !important;
}

.tl-brown75 .rubix-timeline-body > ul > li:before {
  border-color: #c36849;
}

.list-bg-brown75 > .list-group-item.active {
  background: #c36849 !important;
  color: white !important;
}

.list-fg-brown75 > .list-group-item {
  color: #c36849;
}

.btn-brown60 {
  background: #c67055;
  color: white;
  border-color: #c67055;
}
.btn-brown60.btn-outlined {
  color: #c67055;
  background: none;
}
.btn-brown60.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brown60.btn-outlined.btn-onlyOnHover:hover,
.btn-brown60.btn-outlined.btn-onlyOnHover:focus,
.btn-brown60.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brown60.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brown60.btn-outlined.btn-inverse:hover,
.btn-brown60.btn-outlined.btn-inverse:focus,
.btn-brown60.btn-outlined.btn-inverse.active {
  color: #c67055;
  background: white;
}
.btn-brown60.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brown60.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brown60.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #c67055;
  color: white;
  border-color: #c67055;
}
.btn-brown60.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brown60.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brown60.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #8f4730;
  border-color: #613021;
}
.btn-brown60:focus,
.btn-brown60.focus,
.btn-brown60:hover,
.btn-brown60.active {
  color: white;
  background: #d3907b;
  border-color: #d3907b;
}
.btn-brown60:active,
.btn-brown60.active,
.btn-brown60[aria-expanded="true"],
.btn-brown60.active:hover,
.btn-brown60.active:focus,
.btn-brown60[aria-expanded="true"]:hover,
.btn-brown60[aria-expanded="true"]:focus,
.open > .btn-brown60.dropdown-toggle {
  color: white;
  background: #8f4730;
  border-color: #613021;
  background-image: none;
}
.btn-brown60.dropdown-toggle + ul li.active a {
  color: white;
  background: #c67055;
}
.btn-brown60.disabled,
.btn-brown60[disabled],
fieldset[disabled] .btn-brown60 {
  pointer-events: none;
}
.btn-brown60 .badge {
  color: #c67055;
  background-color: #c67055;
}

.menu-brown60 ul li.active a,
.menu-brown60 ul li.active a:hover {
  color: white;
  background: #c67055 !important;
}

.nav-brown60 > li.active > a,
.nav-brown60 > rubix-menu > li.active > a,
.nav-brown60 > rubix-nav-item > li.active > a {
  color: white;
  background: #c67055;
  border-color: #c67055;
}

.tab-brown60 {
  border-color: #c67055;
}
.tab-brown60 > li.active > a {
  border-color: #c67055;
  border-bottom-color: transparent;
}
.tab-brown60.nav-pills > li.active > a {
  background: #c67055;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brown60 > li.active > a {
  border: 1px solid #c67055;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brown60 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brown60 {
  background: #c67055 !important;
}
.bg-brown60 table td,
.bg-brown60 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brown60:focus {
  background: #c67055 !important;
}

.bg-hover-brown60:hover {
  background: #c67055 !important;
}

.fg-brown60 {
  color: #c67055;
}
.fg-brown60 .nav-tabs > li.active > a {
  color: #c67055;
}

.fg-tab-active-brown60 .nav-tabs > li.active > a {
  color: #c67055 !important;
}

.fg-focus-brown60:focus {
  color: #c67055;
}

.fg-hover-brown60:hover {
  color: #c67055;
}

.border-brown60 {
  border-color: #c67055 !important;
}
.border-brown60 .rubix-timeline-body > ul {
  border-color: #c67055;
}
.border-brown60.rubix-timeline-view:before {
  border-color: #c67055;
}

.border-hover-brown60:hover {
  border-color: #c67055 !important;
}

.border-focus-brown60:focus {
  border-color: #c67055 !important;
}

.tl-brown60 .rubix-timeline-body > ul > li:before {
  border-color: #c67055;
}

.list-bg-brown60 > .list-group-item.active {
  background: #c67055 !important;
  color: white !important;
}

.list-fg-brown60 > .list-group-item {
  color: #c67055;
}

.btn-brown50 {
  background: #d67f6b;
  color: white;
  border-color: #d67f6b;
}
.btn-brown50.btn-outlined {
  color: #d67f6b;
  background: none;
}
.btn-brown50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brown50.btn-outlined.btn-onlyOnHover:hover,
.btn-brown50.btn-outlined.btn-onlyOnHover:focus,
.btn-brown50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brown50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brown50.btn-outlined.btn-inverse:hover,
.btn-brown50.btn-outlined.btn-inverse:focus,
.btn-brown50.btn-outlined.btn-inverse.active {
  color: #d67f6b;
  background: white;
}
.btn-brown50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brown50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brown50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #d67f6b;
  color: white;
  border-color: #d67f6b;
}
.btn-brown50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brown50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brown50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #b34a32;
  border-color: #843624;
}
.btn-brown50:focus,
.btn-brown50.focus,
.btn-brown50:hover,
.btn-brown50.active {
  color: white;
  background: #e1a293;
  border-color: #e1a293;
}
.btn-brown50:active,
.btn-brown50.active,
.btn-brown50[aria-expanded="true"],
.btn-brown50.active:hover,
.btn-brown50.active:focus,
.btn-brown50[aria-expanded="true"]:hover,
.btn-brown50[aria-expanded="true"]:focus,
.open > .btn-brown50.dropdown-toggle {
  color: white;
  background: #b34a32;
  border-color: #843624;
  background-image: none;
}
.btn-brown50.dropdown-toggle + ul li.active a {
  color: white;
  background: #d67f6b;
}
.btn-brown50.disabled,
.btn-brown50[disabled],
fieldset[disabled] .btn-brown50 {
  pointer-events: none;
}
.btn-brown50 .badge {
  color: #d67f6b;
  background-color: #d67f6b;
}

.menu-brown50 ul li.active a,
.menu-brown50 ul li.active a:hover {
  color: white;
  background: #d67f6b !important;
}

.nav-brown50 > li.active > a,
.nav-brown50 > rubix-menu > li.active > a,
.nav-brown50 > rubix-nav-item > li.active > a {
  color: white;
  background: #d67f6b;
  border-color: #d67f6b;
}

.tab-brown50 {
  border-color: #d67f6b;
}
.tab-brown50 > li.active > a {
  border-color: #d67f6b;
  border-bottom-color: transparent;
}
.tab-brown50.nav-pills > li.active > a {
  background: #d67f6b;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brown50 > li.active > a {
  border: 1px solid #d67f6b;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brown50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brown50 {
  background: #d67f6b !important;
}
.bg-brown50 table td,
.bg-brown50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
